// Frontend/src/i18n/translations.ts

// English translations
export const en: Record<string, string> = {

  "reports.toast.submitted.title": "Report request submitted!",
  "reports.toast.submitted.desc": "Your detailed report will be emailed to {email} within a few minutes.",
  "reports.toast.error.generic": "Failed to request report. Please try again.",
  "reports.toast.error.limit": "You've requested 3 reports in the last 24 hours. Please wait.",
  "reports.button.requesting": "Requesting…",
  "reports.button.request": "Request Full Report via Email",
  "reports.notice.csv": "Sends a detailed CSV with every invoice record to your email. Up to 3 requests per 24 hours.",
  "reports.alert.queued": "Report queued!",
  "reports.alert.sent": "Your detailed financial report will be emailed to",
  "reports.alert.sentSuffix": "within a few minutes.",
  "reports.button.emailReport": "Email Report",

  // Settings
  "settings.profile": "Profile",
  "settings.paymentDetails": "Payment Details",

  // Hoa Admins
  "superAdmin.hoaAdmins.alerts.created": "HOA account created — login credentials sent by email.",
  "superAdmin.hoaAdmins.alerts.createFailed": "Failed to create account. Please check the details and try again.",
  "superAdmin.hoaAdmins.alerts.resendSuccess": "Credentials generated and email sent.",
  "superAdmin.hoaAdmins.alerts.resendFailed": "Failed to resend credentials.",
  "superAdmin.hoaAdmins.alerts.invalidCharge": "Service charge must be a number between 0 and 100.",
  "superAdmin.hoaAdmins.alerts.saveFailed": "Failed to save. Please try again.",
  "superAdmin.hoaAdmins.alerts.deletePlanFailed": "Failed to delete plan. Please try again.",
  "superAdmin.hoaAdmins.alerts.deletePlanInUse": "This plan cannot be deleted because it is already referenced by existing invoices. Deactivate it instead.",
  "superAdmin.hoaAdmins.actions.approve": "Aprove",
  "superAdmin.hoaAdmins.actions.reject": "Reject",
  "superAdmin.hoaAdmins.actions.reApprove": "Re-approve",
  "superAdmin.hoaAdmins.actions.resendPass": "Resend Pass",
  "superAdmin.hoaAdmins.actions.setRate": "Set Rate",
  "superAdmin.hoaAdmins.actions.suspend": "Suspend",
  "superAdmin.hoaAdmins.actions.activate": "Activate",
  "superAdmin.hoaAdmins.header.title": "HOA Accounts",
  "superAdmin.hoaAdmins.header.desc": "Manage platform accounts, subscription statuses, and service charges.",
  "superAdmin.hoaAdmins.tabs.admins": "HOAs",
  "superAdmin.hoaAdmins.tabs.subscriptions": "Subscriptions",
  "superAdmin.hoaAdmins.tabs.subPayments": "Subscription Payments",
  "superAdmin.hoaAdmins.stats.total": "Total",
  "superAdmin.hoaAdmins.stats.pending": "Pending",
  "superAdmin.hoaAdmins.stats.active": "Active",
  "superAdmin.hoaAdmins.stats.suspended": "Suspended",
  "superAdmin.hoaAdmins.stats.expired": "Expired",
  "superAdmin.hoaAdmins.filters.search": "Search by name, email, or HOA...",
  "superAdmin.hoaAdmins.filters.status": "Status:",
  "superAdmin.hoaAdmins.actions.exportCsv": "Export CSV",
  "superAdmin.hoaAdmins.actions.createAccount": "Create Account",
  "superAdmin.payments.title": "Payment Management",
  "superAdmin.payments.subtitle": "Track and manage resident payments through the verification workflow",
  "superAdmin.payments.stages.needsReview": "Needs Review",
  "superAdmin.payments.stages.readyToForward": "Ready to Forward",
  "superAdmin.payments.stages.awaitingHoa": "Awaiting HOA",
  "superAdmin.payments.stages.waitingHoa": "Waiting for HOA confirmation",
  "superAdmin.payments.stages.completed": "Completed",
  "superAdmin.payments.stages.fullyProcessed": "Fully processed",
  "superAdmin.payments.filters.allTime": "All time",
  "superAdmin.payments.filters.lastWeek": "Last 1 week",
  "superAdmin.payments.filters.lastMonth": "Last 1 month",
  "superAdmin.payments.filters.last3Months": "Last 3 months",
  "superAdmin.payments.filters.allStatus": "All Status",
  "superAdmin.payments.actions.approve": "Approve",
  "superAdmin.payments.actions.reject": "Reject",
  "superAdmin.payments.actions.details": "Details",
  "superAdmin.payments.actions.viewProof": "View payment proof",
  "superAdmin.payments.dialogs.chooseHoAccount": "Choose which HOA account you're sending the payment to",
  "superAdmin.payments.dialogs.uploadScreenshot": "Upload screenshot or receipt of the bank transfer to HOA",
  "superAdmin.payments.methods.bankTransfer": "Bank Transfer",
  "superAdmin.payments.methods.zelle": "Zelle",
  "superAdmin.payments.methods.pagoMovil": "Pago Móvil",
  "superAdmin.payments.methods.paypalOther": "PayPal / Other",
  "superAdmin.payments.status.pendingVerification": "Pending Verification",
  "superAdmin.payments.status.pendingHoa": "Pending HOA",
  "superAdmin.payments.status.verifiedPaid": "Verified/Paid",
  "superAdmin.payments.status.draft": "Draft",
  "superAdmin.payments.status.sent": "Sent",
  "superAdmin.payments.status.unpaid": "Unpaid",
  "superAdmin.payments.status.cancelled": "Cancelled",
  "superAdmin.payments.status.paid": "Paid",
  "superAdmin.paymentDetail.adminNotes": "Admin Verification Notes",
  "superAdmin.paymentDetail.confirmFile": "Confirmation File",
  "superAdmin.paymentDetail.proofSubmitted": "Payment Proof Submitted",
  "superAdmin.common.refresh": "Refresh",
  "superAdmin.common.clear": "Clear",
  "superAdmin.common.close": "Close",
  "superAdmin.common.cancel": "Cancel",
  "superAdmin.common.reset": "Reset",
  "superAdmin.common.noResults": "No results.",
  "superAdmin.common.openNewTab": "Open in New Tab",
  "superAdmin.common.resend": "Resend",
  "superAdmin.common.pdf": "PDF",
  "superAdmin.payouts.title": "Payouts",
  "superAdmin.payouts.subtitle": "Records of money forwarded to HOA-Admins (with proof of forwarding).",
  "superAdmin.payouts.search": "Search admin / condo / resident / unit / date...",
  "superAdmin.payouts.exportCsv": "Export CSV",
  "superAdmin.payouts.hoaAdmin": "HOA-Admin",
  "superAdmin.payouts.condo": "Condo",
  "superAdmin.payouts.residentUnit": "Resident / Unit",
  "superAdmin.payouts.amount": "Amount",
  "superAdmin.payouts.date": "Date",
  "superAdmin.payouts.proof": "Proof",
  "superAdmin.payouts.viewProof": "View proof of forwarding",
  "superAdmin.payouts.view": "View",
  "superAdmin.payouts.noProof": "No proof uploaded",
  "superAdmin.payouts.noPayouts": "No payouts yet.",
  "superAdmin.markForward.title": "Confirm Payment & Attach Proof",
  "superAdmin.markForward.notFound": "Payment not found",
  "superAdmin.markForward.proofLabel": "Proof (image or PDF)",
  "superAdmin.markForward.selected": "Selected:",
  "superAdmin.markForward.noteLabel": "Note (optional)",
  "superAdmin.markForward.notePlaceholder": "e.g., Transfer reference #12345",
  "superAdmin.markForward.summaryFrom": "from",
  "superAdmin.markForward.toLabel": "To:",
  "superAdmin.markForward.confirmBtn": "Confirm & Save",
  "superAdmin.markForward.toasts.attachProof": "Attach proof of forwarding",
  "superAdmin.markForward.toasts.uploadProof": "Please upload an image or PDF as proof.",
  "superAdmin.markForward.toasts.markedForwarded": "Payment marked as Forwarded",
  "superAdmin.markForward.toasts.proofAttached": "Proof of forwarding attached.",
  "superAdmin.paymentDetail.title": "Payment Verification",
  "superAdmin.paymentDetail.loading": "Loading payment details...",
  "superAdmin.paymentDetail.notFound": "Payment not found",
  "superAdmin.paymentDetail.invoiceSummary": "Invoice Summary",
  "superAdmin.paymentDetail.statusTitle": "Status",
  "superAdmin.paymentDetail.timeline": "Payment Timeline",
  "superAdmin.paymentDetail.invoiceCreated": "Invoice created:",
  "superAdmin.paymentDetail.markedPaid": "Marked as paid:",
  "superAdmin.paymentDetail.adminVerified": "Verified by admin:",
  "superAdmin.paymentDetail.finalized": "Finalized:",
  "superAdmin.paymentDetail.verification": "Verification",
  "superAdmin.paymentDetail.transactionScreenshot": "Transaction Screenshot",
  "superAdmin.paymentDetail.idVerification": "ID Verification",
  "superAdmin.paymentDetail.noProof": "No payment proof uploaded yet.",
  "superAdmin.paymentDetail.residentNotes": "Resident Notes",
  "superAdmin.paymentDetail.platformPaymentTitle": "Platform Payment Details",
  "superAdmin.paymentDetail.platformPaymentDesc": "Resident pays to this account",
  "superAdmin.paymentDetail.hoaPayoutTitle": "HOA Admin Payout Details",
  "superAdmin.paymentDetail.hoaPayoutDesc": "Platform transfers net amount to this account",
  "superAdmin.paymentDetail.uploadedBy": "by {name}",
  "superAdmin.paymentDetail.alreadyVerified": "This payment has already been verified.",
  "superAdmin.paymentDetail.notReadyForVerification": "This payment is not ready for verification.",
  "superAdmin.paymentDetail.openNewTab": "Open in new tab",
  "superAdmin.paymentDetail.noFileProvided": "No file provided",
  "superAdmin.paymentDetail.dueDate": "Due date",
  "superAdmin.paymentDetail.paidOn": "Paid {date}",
  "superAdmin.paymentDetail.confirmedByHoa": "Confirmed by the HOA",
  "superAdmin.paymentDetail.confirmedByHoaDetail": "Recorded by {who} on {date}",
  "superAdmin.paymentDetail.directHoaNote": "The resident paid the HOA directly. The platform does not hold these funds, so no platform verification applies.",
  "superAdmin.paymentDetail.hoaReceivingTitle": "HOA receiving account",
  "superAdmin.paymentDetail.hoaReceivingDesc": "The resident pays into this account",
  "superAdmin.paymentDetail.approveTitle": "Approve Payment?",
  "superAdmin.paymentDetail.approveDesc": "This will verify the payment and update the status so the HOA admin can finalize it.",
  "superAdmin.paymentDetail.notesLabel": "Verification Notes (Optional)",
  "superAdmin.paymentDetail.fileLabel": "Confirmation File (Optional)",
  "superAdmin.paymentDetail.rejectTitle": "Reject Payment?",
  "superAdmin.paymentDetail.rejectDesc": "This will reject the payment proof and reset the invoice status to UNPAID.",
  "superAdmin.paymentDetail.approveBtn": "Approve Payment",
  "superAdmin.paymentDetail.rejectBtn": "Reject Payment",
  "superAdmin.paymentDetail.backToInbox": "Back to Inbox",
  "superAdmin.paymentDetail.toasts.verifySuccess": "Payment verification completed",
  "superAdmin.paymentDetail.toasts.verifyFail": "Verification failed",
  "superAdmin.paymentDetail.toasts.resendSuccess": "Notification resent successfully",
  "superAdmin.paymentDetail.toasts.resendFail": "Failed to resend notification",
  "superAdmin.paymentDetail.toasts.proofRejected": "Payment proof rejected",
  "superAdmin.common.unknownError": "Unknown error",
  "superAdmin.common.back": "Back",
  "superAdmin.hoaAdmins.table.status": "Status",
  "superAdmin.hoaAdmins.table.subscriptionPlan": "Subscription Plan",
  "superAdmin.hoaAdmins.states.noResults": "No results.",

  "superAdmin.hoaAdmins.subs.newPlan": "New Plan",
  "superAdmin.hoaAdmins.states.loadingPlans": "Loading plans...",
  "superAdmin.hoaAdmins.states.noSubscriptions": "No subscriptions yet.",
  "superAdmin.hoaAdmins.states.noSubsFound": "No subscriptions found. Subscriptions are created when HOA admins are approved.",
  "superAdmin.hoaAdmins.states.noPlansFound": "No subscription plans yet. Create one to get started.",
  "superAdmin.hoaAdmins.form.planName": "Plan Name *",
  "superAdmin.hoaAdmins.form.description": "Description",
  "superAdmin.hoaAdmins.form.priceUsd": "Price (USD) *",
  "superAdmin.hoaAdmins.form.billingCycle": "Billing Cycle *",
  "superAdmin.hoaAdmins.form.maxUnits": "Max Units",
  "superAdmin.hoaAdmins.form.zeroUnlimited": "Set to 0 for unlimited.",
  "superAdmin.hoaAdmins.form.activeAvailable": "Active (available for new subscriptions)",
  "superAdmin.hoaAdmins.cycles.monthly": "Monthly",
  "superAdmin.hoaAdmins.cycles.quarterly": "Quarterly",
  "superAdmin.hoaAdmins.cycles.annual": "Annual",
  "superAdmin.hoaAdmins.status.trial": "Trial",
  "superAdmin.hoaAdmins.status.active": "Active",
  "superAdmin.hoaAdmins.status.suspended": "Suspended",
  "superAdmin.hoaAdmins.status.cancelled": "Cancelled",
  "superAdmin.hoaAdmins.status.expired": "Expired",
  "superAdmin.hoaAdmins.status.inactive": "Inactive",
  "superAdmin.hoaAdmins.status.pending": "Pending Approval",
  "superAdmin.hoaAdmins.status.rejected": "Rejected",
  "superAdmin.hoaAdmins.status.all": "All",
  "superAdmin.hoaAdmins.form.email": "Email",
  "superAdmin.hoaAdmins.form.firstName": "First Name",
  "superAdmin.hoaAdmins.form.lastName": "Last Name",
  "superAdmin.hoaAdmins.form.orgName": "Organization / HOA Name",
  "superAdmin.hoaAdmins.form.maxUnitsAllowed": "Max Units Allowed",
  "superAdmin.hoaAdmins.form.createNotice": "The account will be active immediately. Login credentials will be sent to the provided email address.",
  "superAdmin.hoaAdmins.form.reasonOptional": "Reason (optional)",
  "superAdmin.hoaAdmins.headers.subs": "HOA Admin Subscriptions",
  "superAdmin.hoaAdmins.headers.plans": "Subscription Plans",
  "superAdmin.hoaAdmins.headers.charges": "Platform Service Charges",
  "superAdmin.hoaAdmins.headers.settingRateFor": "Setting charge rate for",
  "superAdmin.hoaAdmins.form.chargeNotice": "Percentage of each invoice total charged as a platform fee (e.g. 3.00 = 3%).",
  "superAdmin.hoaAdmins.form.chargeRate": "Service Charge Rate (%)",
  "superAdmin.hoaAdmins.dialogs.createAccount": "Create HOA Admin Account",
  "superAdmin.hoaAdmins.dialogs.rejectAccount": "Reject Account",
  "superAdmin.hoaAdmins.dialogs.rejectNotice": " They will receive an email notification.",
  "superAdmin.hoaAdmins.dialogs.editPlan": "Edit Plan",
  "superAdmin.hoaAdmins.dialogs.newPlan": "New Subscription Plan",
  "superAdmin.hoaAdmins.dialogs.deletePlan": "Delete Plan",
  "superAdmin.hoaAdmins.dialogs.manageSub": "Manage Subscription",
  "superAdmin.hoaAdmins.dialogs.rejectPayment": "Reject Subscription Payment",
  "superAdmin.hoaAdmins.actions.deletePlan": "Delete Plan",
  "superAdmin.hoaAdmins.actions.manage": "Manage",
  "superAdmin.hoaAdmins.actions.manageSub": "Manage Subscription",
  "superAdmin.hoaAdmins.actions.viewProof": "View Proof ↗",
  "superAdmin.hoaAdmins.actions.cancel": "Cancel",
  "superAdmin.hoaAdmins.actions.delete": "Delete",
  "superAdmin.hoaAdmins.actions.edit": "Edit",
  "superAdmin.hoaAdmins.table.adminHoa": "HOA Admin",
  "superAdmin.hoaAdmins.table.plan": "Plan",
  "superAdmin.hoaAdmins.table.period": "Period",
  "superAdmin.hoaAdmins.table.history": "History",
  "superAdmin.hoaAdmins.table.awaiting": "Awaiting Review",
  "superAdmin.hoaAdmins.table.completed": "Completed",
  "superAdmin.hoaAdmins.table.notes": "Notes",
  "superAdmin.hoaAdmins.states.noPlanList": "— No plan —",
  "superAdmin.hoaAdmins.states.noPlan": "No plan",
  "superAdmin.hoaAdmins.states.noPlanAssigned": "No plan assigned",
  "superAdmin.hoaAdmins.states.noPendingSubs": "No pending subscription payments to review.",
  "superAdmin.hoaAdmins.dialogs.rejectingPaymentFrom": "Rejecting payment from",
  "superAdmin.hoaAdmins.dialogs.rejectionReason": "Rejection reason",
  "superAdmin.hoaAdmins.states.loading": "Loading...",
  "superAdmin.hoaAdmins.states.noOrg": "No org",
  "superAdmin.hoaAdmins.table.name": "Name",
  "superAdmin.hoaAdmins.table.email": "Email",
  "superAdmin.hoaAdmins.table.org": "Organization",
  "superAdmin.hoaAdmins.table.charge": "Service Charge",
  "superAdmin.hoaAdmins.table.actions": "Actions",
  "superAdmin.hoaAdmins.text.serviceChargeSuffix": "% service charge",

  // Payments Inbox
  "superAdmin.payments.header.title": "Payment Management",
  "superAdmin.payments.header.desc": "Track and manage resident payments through the verification workflow",
  "superAdmin.payments.tabs.all": "All Payments",
  "superAdmin.payments.tabs.review": "Needs Review",
  "superAdmin.payments.tabs.reviewDesc": "Verify payment proofs",
  "superAdmin.payments.tabs.ready": "Ready to Forward",
  "superAdmin.payments.tabs.readyDesc": "Send to HOA Admin",
  "superAdmin.payments.tabs.awaiting": "Awaiting HOA",
  "superAdmin.payments.tabs.awaitingDesc": "HOA needs to confirm",
  "superAdmin.payments.tabs.completed": "Completed",
  "superAdmin.payments.tabs.completedDesc": "Fully processed",
  "superAdmin.payments.bulk.actions": "Bulk Actions:",
  "superAdmin.payments.bulk.approveAll": "Approve All ({count})",
  "superAdmin.payments.bulk.rejectAll": "Reject All ({count})",
  "superAdmin.payments.bulk.clear": "Clear",
  "superAdmin.payments.bulk.selected": "{count} selected",
  "superAdmin.payments.toolbar.search": "Search resident / email / unit / method…",
  "superAdmin.payments.actions.refreshData": "Refresh data",
  "superAdmin.payments.toolbar.status": "Status",
  "superAdmin.payments.toolbar.showingCount": "Showing {count} payment(s)",
  "superAdmin.payments.filters.pendingVerification": "Pending Verification",
  "superAdmin.payments.filters.verifiedPaid": "Verified/Paid",
  "superAdmin.payments.toolbar.timeRange": "Time range",
  "superAdmin.payments.toolbar.building": "Building",
  "superAdmin.payments.toolbar.allBuildings": "All buildings",
  "superAdmin.payments.filters.last1week": "Last 1 week",
  "superAdmin.payments.filters.last1month": "Last 1 month",
  "superAdmin.payments.filters.last3months": "Last 3 months",
  "superAdmin.payments.actions.reset": "Reset",
  "superAdmin.payments.actions.exportCsv": "Export CSV",
  "superAdmin.payments.toolbar.paymentsCount": "payment(s)",
  "superAdmin.payments.states.unknownBuilding": "Unknown Building",
  "superAdmin.payments.states.rejectedCount": "Rejected {count}x",
  "superAdmin.payments.states.noProof": "No payment proof",
  "superAdmin.payments.states.markedBy": "Marked by: {name}",
  "superAdmin.payments.states.paymentProof": "Payment Proof",
  "superAdmin.payments.actions.forwardToHoa": "Forward to HOA",
  "superAdmin.payments.states.waitingForHoa": "Waiting for HOA confirmation",
  "superAdmin.payments.states.pendingHoa": "Pending HOA",
  "superAdmin.payments.states.noResults": "No results.",
  "superAdmin.payments.table.building": "Building",
  "superAdmin.payments.table.resident": "Resident",
  "superAdmin.payments.table.unit": "Unit",
  "superAdmin.payments.table.amount": "Amount",
  "superAdmin.payments.table.method": "Method",
  "superAdmin.payments.table.completed": "Completed",
  "superAdmin.payments.table.forwarded": "Forwarded",
  "superAdmin.payments.table.date": "Date",
  "superAdmin.payments.table.status": "Status",
  "superAdmin.payments.table.actions": "Actions",
  "superAdmin.payments.states.imageNotFound": "Image not found",
  "superAdmin.payments.actions.openNewTab": "Open in New Tab",
  "superAdmin.payments.actions.close": "Close",
  "superAdmin.payments.dialogs.approvePayment": "Approve Payment",
  "superAdmin.payments.dialogs.approvePaymentDesc": "Approve payment for {name} - ${amount}",
  "superAdmin.payments.dialogs.verificationNotes": "Verification Notes (Optional)",
  "superAdmin.payments.dialogs.verificationNotesPlaceholder": "Add notes about the verification...",
  "superAdmin.payments.actions.approving": "Approving...",
  "superAdmin.payments.actions.confirmApproval": "Confirm Approval",
  "superAdmin.payments.actions.cancel": "Cancel",
  "superAdmin.payments.dialogs.rejectPayment": "Reject Payment",
  "superAdmin.payments.dialogs.rejectPaymentDesc": "Reject payment for {name} - ${amount}",
  "superAdmin.payments.dialogs.rejectReason": "Reason for Rejection",
  "superAdmin.payments.dialogs.rejectReasonPlaceholder": "Explain why this payment is being rejected...",
  "superAdmin.payments.dialogs.bulkRejectDefaultNote": "Bulk rejection",
  "superAdmin.payments.actions.rejecting": "Rejecting...",
  "superAdmin.payments.actions.confirmRejection": "Confirm Rejection",
  "superAdmin.payments.dialogs.bulkApprove": "Bulk Approve Payments",
  "superAdmin.payments.dialogs.bulkApproveDesc": "Approve {count} payment(s)?",
  "superAdmin.payments.dialogs.bulkApproveNotesPlaceholder": "Add notes for all approved payments...",
  "superAdmin.payments.dialogs.approveCount": "Approve {count} Payment(s)",
  "superAdmin.payments.dialogs.bulkReject": "Bulk Reject Payments",
  "superAdmin.payments.dialogs.bulkRejectDesc": "Reject {count} payment(s)?",
  "superAdmin.payments.dialogs.bulkRejectNotesPlaceholder": "Explain why these payments are being rejected...",
  "superAdmin.payments.dialogs.rejectCount": "Reject {count} Payment(s)",
  "superAdmin.payments.dialogs.confirmForward": "Confirm Payment to HOA",
  "superAdmin.payments.dialogs.forwardDesc": "Forward ${amount} to {name}",
  "superAdmin.payments.dialogs.noHoaPaymentMethod": "The HOA admin has not set up a payment method",
  "superAdmin.payments.dialogs.noHoaPaymentMethodDesc": "The HOA admin for {name} hasn't set up any payment details yet.",
  "superAdmin.payments.dialogs.cannotForward": "You cannot forward this payment until they configure their account.",
  "superAdmin.payments.actions.sendingReminder": "Sending reminder...",
  "superAdmin.payments.actions.sendReminder": "📧 Send Setup Reminder to HOA Admin",
  "superAdmin.payments.dialogs.selectPaymentMethod": "Select Payment Method (Required)",
  "superAdmin.payments.dialogs.chooseHoaAccount": "Choose which HOA account you're sending the payment to",
  "superAdmin.payments.dialogs.additionalDestinationDetails": "Additional destination details",
  "superAdmin.payments.dialogs.noSupportedMethod": "No supported forwarding method is configured",
  "superAdmin.payments.dialogs.noSupportedMethodDesc": "This destination has payment details, but none of the currently supported methods in this flow (Bank Transfer, Zelle, Pago Movil, PayPal).",
  "superAdmin.payments.methods.bankAccount": "Bank Account",
  "superAdmin.payments.methods.account": "Account",
  "superAdmin.payments.methods.paypal": "PayPal",
  "superAdmin.payments.dialogs.transferProof": "Transfer Proof (Required)",
  "superAdmin.payments.dialogs.uploadReceipt": "Upload screenshot or receipt of the bank transfer to HOA",
  "superAdmin.payments.dialogs.notesOptional": "Notes (Optional)",
  "superAdmin.payments.dialogs.notesPlaceholder": "Add any notes about this transfer...",
  "superAdmin.payments.actions.forwarding": "Forwarding...",
  "superAdmin.payments.toasts.forwardSuccess": "Payment forwarded to HOA successfully",
  "superAdmin.payments.toasts.forwardFail": "Failed to forward payment",
  "superAdmin.payments.toasts.reminderSentTo": "Reminder sent to {email}",
  "superAdmin.payments.toasts.reminderFail": "Failed to send reminder",
  "superAdmin.payments.toasts.bulkApproveSuccess": "Approved {count} payment(s) successfully",
  "superAdmin.payments.toasts.bulkRejectSuccess": "Rejected {count} payment(s) successfully",
  "superAdmin.payments.toasts.bulkVerifyFail": "Bulk verification failed",

  "settings.subscription": "Subscription",
  "settings.configurations": "Configurations",
  "settings.saveChanges": "Save Changes",
  "settings.saving": "Saving...",
  "settings.save": "Save",
  "settings.orgName": "Organization Name",
  "settings.firstName": "First Name",
  "settings.lastName": "Last Name",
  "settings.manageProfileMsg": "Manage your profile, payment details, and preferences",
  "settings.profileUpdated": "Profile updated successfully",
  "settings.profileUpdateError": "Error updating profile",

  "settings.paymentDetailsCreated": "Payment details created successfully",
  "settings.paymentDetailsCreateError": "Error creating payment details",
  "settings.paymentDetailsUpdated": "Payment details updated successfully",
  "settings.paymentDetailsUpdateError": "Error updating payment details",

  "settings.notificationsUpdated": "Notification settings updated",
  "settings.notificationsUpdateError": "Error updating notification settings",
  "settings.securityUpdated": "Security settings updated",
  "settings.securityUpdateError": "Error updating security settings",

  "settings.subRequestCreated": "Subscription request created. Please upload your payment proof.",
  "settings.subRequestError": "Error creating subscription request.",
  "settings.proofUploaded": "Payment proof sent. Awaiting verification.",
  "settings.proofUploadError": "Error uploading payment proof.",
  "settings.subCancelled": "Subscription request cancelled.",
  "settings.cancelError": "Error cancelling request.",

  "settings.noActivePlan": "No active plan",
  "settings.units": "Units",
  "settings.trialEnds": "Trial ends on",
  "settings.renewsOn": "Renews on",

  "settings.cancelRequest": "Cancel request",
  "settings.uploadProof": "Upload Payment Proof",
  "settings.transferPrefix": "Transfer",
  "settings.transferSuffix": "to our platform account, then upload your receipt below.",

  "settings.screenshotReceipt": "Screenshot / Payment receipt",
  "settings.clickToSelectFile": "Click to select a file (image or PDF)",
  "settings.uploading": "Uploading...",
  "settings.submitProof": "Submit Payment Proof",
  "settings.viewPreviousProof": "View previously submitted proof",

  "settings.waitingAdminVerification": "Awaiting Admin Verification",
  "settings.proofReceivedMessage": "Your payment proof has been received. The platform team will review it and activate your subscription shortly.",
  "settings.viewUploadedProof": "View submitted proof",

  "settings.noPlansAvailable": "No subscription plans available yet.",
  "settings.availablePlans": "Available Plans",
  "settings.current": "Current",
  "settings.upTo": "Up to",
  "settings.unlimited": "unlimited",
  "settings.unitsLowercase": "units",

  "settings.subscribeTo": "Subscribe to",
  "settings.afterConfirmingMsg": "After confirming, you'll be asked to upload your payment proof to activate the subscription.",
  "settings.requesting": "Requesting...",
  "settings.confirmAndRequest": "Confirm and Request",
  "settings.cancel": "Cancel",

  "settings.hide": "Hide",
  "settings.show": "Show",
  "settings.paymentHistory": "payment history",

  "settings.emailNotifications": "Email Notifications",
  "settings.emailNotifDesc": "Receive notifications via email",
  "settings.smsNotifications": "SMS Notifications",
  "settings.smsNotifDesc": "Receive urgent notifications via SMS",
  "settings.maintenanceAlerts": "Maintenance Alerts",
  "settings.maintenanceNotifDesc": "Receive notifications for new maintenance issues",
  "settings.paymentReminders": "Payment Reminders",
  "settings.paymentRemindersDesc": "Send payment reminders to residents",

  "settings.requirePhotos": "Require Photos for Issues",
  "settings.requirePhotosDesc": "Residents must attach photos when reporting issues",
  "settings.autoApproveResidents": "Auto-approve New Residents",
  "settings.autoApproveDesc": "Automatically approve new resident registrations",
  "settings.allowGuests": "Allow Guest Access",
  "settings.allowGuestsDesc": "Residents can grant temporary access to guests",
  "settings.security": "Security",
  "settings.notifications": "Notifications",
  "settings.maintenance": "Maintenance",
  "settings.appInfo": "App Info",
  "settings.password": "Password",
  "settings.bankName": "Bank Name",
  "settings.legalName": "Legal Name",
  "settings.bank": "Bank",
  "settings.idNumber": "ID Number (Cédula/RIF)",
  "settings.phone": "Phone",
  "settings.email": "Email",
  "settings.accountNumber": "Account #",
  "settings.routingNumber": "Routing #",
  "settings.exBanesco": "Ex: Chase Bank",
  "settings.exCondoName": "Ex: Oakwood Condos",
  "settings.exMercantil": "Ex: Wells Fargo",
  "settings.exIdNumber": "Ex: 123456789",
  "settings.currentPassword": "Current Password",
  "settings.newPassword": "New Password",
  "settings.confirmPassword": "Confirm New Password",
  "settings.passwordUpdated": "Password updated successfully",
  "settings.passwordUpdateError": "Error updating password",
  "settings.passwordMinLength": "New password must be at least 8 characters long",
  "settings.passwordsDoNotMatch": "Passwords do not match",
  "settings.showPasswords": "Show passwords",
  "settings.updatePassword": "Update password",
  "settings.gracePeriodTitle": "Expired or Cancelled Subscription",
  "settings.gracePeriodMessage": "You are currently in a 3-day grace period ending on {date}. Please resume your subscription plan below to avoid losing your admin access and permissions.",
  "settings.unitSlotsTitle": "Unit Slots",
  "settings.unitSlotsSubtitle": "Subscription usage and quota information",
  "settings.paymentDetailsSubtitle": "Banking and payment information to receive collections",
  "settings.mySubscriptionTitle": "My Subscription",
  "settings.mySubscriptionSubtitle": "Manage your subscription plan and platform payments",
  "settings.notificationsComingSoonDesc": "Notification preferences will arrive in a future update.",
  "settings.notificationsTitle": "Notification Settings",
  "settings.notificationsSubtitle": "See how you receive notifications",
  "settings.securityComingSoonDesc": "Security and access control settings will arrive in a future update.",
  "settings.securityAccessTitle": "Security & Access",
  "settings.securityAccessSubtitle": "Manage security and access settings",
  "settings.applicationTitle": "Application",
  "settings.applicationSubtitle": "Install CondoGustion for a faster, app-like experience",
  "settings.appVersionTitle": "App Version",
  "settings.appVersionSubtitle": "Check updates and manage app version",
  "settings.accountSecurityTitle": "Account Security",
  "settings.accountSecuritySubtitle": "Update your password to keep your account secure",
  "settings.maintenanceSubtitle": "Manage caches and inspect the manifest",
  "settings.readOnlyEmail": "Email (read-only)",
  "settings.saveProfile": "Save Profile",
  "settings.planUsage": "Plan usage",
  "settings.unitsUsed": "{used} of {total} units used",
  "settings.percentUsed": "{percent}% used",
  "settings.remainingUnits": "{count} remaining",
  "settings.low": "Low",
  "settings.unitsLimitReached": "You've reached your unit limit. Please contact support to upgrade your plan.",
  "settings.subscriptionStatus.trial": "Trial",
  "settings.subscriptionStatus.active": "Active",
  "settings.subscriptionStatus.suspended": "Suspended",
  "settings.subscriptionStatus.cancelled": "Cancelled",
  "settings.subscriptionStatus.expired": "Expired",
  "settings.paymentDetailsVerified": "Your payment details have been verified by Urbe360",
  "settings.bankTransferDetails": "Bank Transfer Details",
  "settings.accountNumberPlaceholder": "Account number",
  "settings.routingPlaceholder": "Routing number",
  "settings.accountHolderName": "Account Holder Name",
  "settings.accountHolderPlaceholder": "Name on account",
  "settings.zelleEmail": "Zelle Email",
  "settings.zellePhone": "Zelle Phone",
  "settings.zelleEmailPlaceholder": "zelle@example.com",
  "settings.cashInstructionsTitle": "Cash Instructions",
  "settings.instructions": "Instructions",
  "settings.cashInstructionsPlaceholder": "Instructions to receive cash payments...",
  "settings.otherPaymentMethods": "Other Payment Methods",
  "settings.paypalEmail": "PayPal Email",
  "settings.paypalEmailPlaceholder": "paypal@example.com",
  "settings.venmoUsername": "Venmo Username",
  "settings.venmoPlaceholder": "@username",
  "settings.cashAppUsername": "Cash App Username",
  "settings.cashAppPlaceholder": "$username",
  "settings.updatePaymentDetails": "Update Payment Details",
  "settings.createPaymentDetails": "Create Payment Details",
  "settings.billingCycleMonthly": "/ month",
  "settings.billingCycleQuarterly": "/ quarter",
  "settings.billingCycleAnnual": "/ year",
  "settings.invoiceStatus.pendingPayment": "Pending Payment",
  "settings.invoiceStatus.pendingVerification": "Pending Verification",
  "settings.invoiceStatus.completed": "Completed",
  "settings.invoiceStatus.rejected": "Rejected",
  "settings.invoiceStatus.cancelled": "Cancelled",
  "settings.sendAmountToFollowing": "Send ${amount} to one of the following:",
  "settings.contactPlatformAdminForPayment": "Contact the platform admin for payment details.",
  "settings.copy": "Copy",
  "settings.plan": "Plan",
  "settings.rejectedReason": "Rejected",
  "settings.paymentMethod.bankTransfer": "Bank Transfer",
  "settings.paymentMethod.zelle": "Zelle",
  "settings.paymentMethod.paypal": "PayPal",
  "settings.paymentMethod.cardStripe": "Card / Stripe",
  "settings.paymentMethod.pagoMovil": "Pago Movil",
  "settings.paymentMethod.cash": "Cash",
  "settings.appInstalled": "App is installed on this device.",
  "settings.howToInstallIOS": "How to install on iPhone/iPad",
  "settings.iosInstallTip": "Safari on iOS doesn't show a native install prompt. Share -> Add to Home Screen.",
  "settings.installApplication": "Install application",
  "settings.waitingBrowserInstall": "Waiting for the browser to allow installation...",
  "settings.installTip": "Tip: use the browser menu (⋮ / ... -> Install app) if the button is disabled.",
  "settings.quickRepairConfirm": "Quick repair will clear caches and service workers, then reload. Continue?",
  "settings.quickRepairFailed": "Quick repair failed. Check the console for details.",
  "settings.fullRepairConfirm": "WARNING: Full repair will clear ALL app data, including session, cache, and storage. You will need to sign in again. Continue?",
  "settings.repairCompletedWithErrors": "Repair completed with {count} error(s). Check the console for details.",
  "settings.fullRepairFailed": "Full repair failed. Check the console for details.",
  "settings.appVersionLabel": "App Version",
  "settings.buildTime": "Build Time",
  "settings.swSupported": "SW Supported",
  "settings.swRegistered": "SW Registered",
  "settings.swActive": "SW Active",
  "settings.swController": "SW Controller",
  "settings.swUpdateAvailable": "SW Update Available",
  "settings.appInfoError": "Could not get app info. Check the console.",
  "settings.quickRepairTitle": "Quick repair: clear caches and service workers",
  "settings.repairing": "Repairing...",
  "settings.quickRepair": "Quick Repair",
  "settings.fullRepairTitle": "Full repair: clear all app data (requires sign-in again)",
  "settings.fullRepair": "Full Repair",
  "settings.appInfoTitle": "View app version and service worker status",
  "settings.viewManifest": "View manifest",
  "settings.renewSubscription": "Renew Subscription",
  "settings.renewPlanFor": "Renew your unit plan for ${price}.",
  "settings.currentRenewalDate": "Current renewal date",
  "settings.renewNow": "Renew now (start next cycle immediately)",
  "settings.renewNextPeriod": "Renew for next period (keep current cycle)",
  "settings.processing": "Processing...",
  "settings.proceed": "Proceed",
  "settings.updateAvailableToast": "Update available! Click 'Update Now' to install.",
  "settings.latestVersionToast": "You're using the latest version!",
  "settings.checkUpdatesError": "Error checking for updates",
  "settings.updatingApp": "Updating app...",
  "settings.updateError": "Update failed. Please update manually.",
  "settings.currentVersion": "Current Version",
  "settings.buildLabel": "Build",
  "settings.newVersionAvailable": "New version available",
  "settings.checking": "Checking...",
  "settings.checkForUpdates": "Check for Updates",
  "settings.updating": "Updating...",
  "settings.updateNow": "Update Now",
  "settings.autoUpdateInfo": "The app checks for updates automatically every 60 seconds. When an update is available, you'll see a banner at the bottom of the screen.",

  // Common
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.create": "Create",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.all": "All",
  "common.yes": "Yes",
  "common.no": "No",
  "common.confirm": "Confirm",
  "common.back": "Back",
  "common.next": "Next",
  "common.submit": "Submit",
  "common.close": "Close",
  "common.view": "View",
  "common.hide": "Hide",
  "common.reset": "Reset",
  "common.dismiss": "Dismiss",
  "common.verifying": "Verifying...",
  "common.sending": "Sending...",
  "common.import": "Import",
  "common.sortBy": "Sort by",
  "common.viewDetails": "View details",
  "common.saveChanges": "Save Changes",
  "common.saving": "Saving...",
  "common.error": "Error",
  "common.success": "Success",
  "common.warning": "Warning",
  "common.info": "Information",
  "common.noResults": "No results found",
  "common.required": "Required",
  "common.optional": "Optional",
  "common.actions": "Actions",
  "common.status": "Status",
  "common.date": "Date",
  "common.amount": "Amount",
  "common.total": "Total",
  "common.details": "Details",
  "common.description": "Description",
  "common.title": "Title",
  "common.content": "Content",
  "common.name": "Name",
  "common.email": "Email",
  "common.phone": "Phone",
  "common.address": "Address",
  "common.unit": "Unit",
  "common.building": "Building",
  "common.password": "Password",
  "common.logout": "Log out",
  "common.login": "Log in",
  "common.register": "Register",
  "common.or": "or",
  "common.and": "and",
  "common.priority": "Priority",
  "common.priority.low": "Low",
  "common.priority.medium": "Medium",
  "common.priority.high": "High",
  "common.priority.urgent": "Urgent",
  "common.unknown": "Unknown",
  "common.refresh": "Refresh",
  "common.refreshing": "Refreshing...",
  "common.working": "Working...",
  "common.none": "None",
  "common.na": "N/A",
  "common.role": "Role",

  // Auth
  "auth.login": "Iniciar sesion",
  "auth.loginTitle": "Bienvenido de nuevo",
  "auth.loginSubtitle": "Inicia sesion en tu cuenta",
  "auth.email": "Correo electronico",
  "auth.password": "Contrasena",
  "auth.forgotPassword": "Olvidaste tu contrasena?",
  "auth.noAccount": "No tienes una cuenta?",
  "auth.hasAccount": "Ya tienes una cuenta?",
  "auth.signUp": "Registrarse",
  "auth.signIn": "Iniciar sesion",
  "auth.rememberMe": "Recordarme",
  "auth.invalidCredentials": "Correo o contrasena invalidos",
  "auth.logoutSuccess": "Has cerrado sesion",
  "auth.sessionExpired": "Tu sesion ha expirado. Por favor inicia sesion de nuevo.",
  "auth.loggingOut": "Cerrando sesion...",
  "auth.adminAccessTitle": "Acceso de administrador",
  "auth.superAdminAccess": "Inicio de sesion Super Admin - Acceso restringido",
  "auth.emailOrId": "Correo o ID",
  "auth.adminEmailPlaceholder": "admin@example.com",
  "auth.emailPlaceholder": "tu@email.com",
  "auth.confirmPassword": "Confirmar contrasena",
  "auth.showPassword": "Mostrar contrasena",
  "auth.hidePassword": "Ocultar contrasena",
  "auth.signingIn": "Iniciando sesion...",
  "auth.redirecting": "Redirigiendo...",
  "auth.signInAdmin": "Iniciar sesion como admin",
  "auth.backToLogin": "← Volver al inicio de sesion",
  "auth.signInError": "No se pudo iniciar sesion. Verifica tus credenciales e intentalo de nuevo.",
  "auth.accountNotResident": "Esta cuenta no es de residente. Usa la pestana de administrador HOA.",
  "auth.hoaLoginHint": "Usa las credenciales proporcionadas por el administrador de tu edificio.",
  "auth.residentPasswordHint": "Inicia sesion con la contrasena de tu cuenta de residente.",
  "auth.residentOtpHint": "Inicia sesion con tu correo para recibir un codigo OTP.",
  "auth.loginWithPassword": "Iniciar sesion con contrasena",
  "auth.keepSignedIn": "Mantener sesion iniciada",
  "auth.otpInfo": "Recibiras un codigo OTP por correo para completar el inicio de sesion.",
  "auth.continue": "Continuar",
  "auth.continueWithOtp": "Continuar con OTP",
  "auth.demoCredentials": "Credenciales de demo",
  "auth.demoAdminLabel": "Admin:",
  "auth.passwordResetTitle": "Restablecer contraseña",
  "auth.passwordResetSubtitle": "El nuevo código funcionará para todas las propiedades vinculadas a tu correo.",
  "auth.sendResetCode": "Enviar código",
  "auth.sending": "Enviando…",
  "auth.verificationCode": "Código de verificación",
  "auth.verifyCode": "Verificar código",
  "auth.verifying": "Verificando…",
  "auth.newPassword": "Nueva contraseña",
  "auth.resetPassword": "Restablecer contraseña",
  "auth.resetting": "Restableciendo…",
  "auth.passwordInvalid": "La contraseña no cumple con los requisitos.",
  "auth.passwordMismatch": "Las contraseñas no coinciden.",
  "auth.passwordReqLength": "Mínimo 8 caracteres",
  "auth.passwordReqLetter": "Al menos una letra",
  "auth.passwordReqNumber": "Al menos un número",
  "auth.unableToRequestReset": "No se pudo enviar el código de restablecimiento.",
  "auth.unableToVerify": "No se pudo verificar el código.",
  "auth.unableToReset": "No se pudo restablecer la contraseña.",

  // Navigation
  "nav.home": "Home",
  "nav.dashboard": "Dashboard",
  "nav.announcements": "Announcements",
  "nav.payments": "Payments",
  "nav.polls": "Polls",
  "nav.issues": "Issues",
  "nav.profile": "Profile",
  "nav.settings": "Settings",
  "nav.news": "News",
  "nav.members": "Members",
  "nav.invoice": "Invoice",
  "nav.comms": "Comms",
  "nav.hoas": "HOAs",
  "nav.residents": "Residents",
  "nav.units": "Units",
  "nav.buildings": "Buildings",
  "nav.reports": "Reports",
  "nav.admin": "Admin",

  // Roles
  "roles.resident": "Resident",
  "roles.hoaAdmin": "Admin",
  "roles.hoaAdminFull": "HOA Admin",
  "roles.superAdmin": "Super Administrador",

  // Layout titles
  "resident.title.announcements": "Announcements",
  "resident.title.polls": "Community Polls",
  "resident.title.issues": "Issue Reports",
  "resident.title.payments": "My Payments",
  "resident.title.profile": "Profile & Settings",
  "resident.title.dashboard": "Dashboard",
  "hoa.layout.console": "HOA Console",
  "hoa.layout.titles.members": "Member Management",
  "hoa.layout.titles.payments": "Payments & Invoices",
  "hoa.layout.titles.communications": "Communications",
  "hoa.layout.titles.reports": "Reports & Analytics",
  "superAdmin.layout.console": "Consola de Plataforma",
  "superAdmin.layout.titles.hoaAdmins": "Admins de HOA",
  "superAdmin.layout.titles.payments": "Bandeja de Pagos",

  // HOA Dashboard
  "common.allCondos": "All condos",
  "common.comingSoon": "Coming Soon",
  "common.inDevelopment": "In Development",
  "hoa.dashboard.announcementsComing": "The announcements and news module is currently in development.",
  "hoa.dashboard.pollsComing": "The active polls and voting module is currently in development.",
  "hoa.dashboard.greeting": "Hello, {name}!",
  "hoa.dashboard.subtitle": "HOA Console • Live metrics & recent activity",
  "hoa.dashboard.overview": "Overview",
  "hoa.dashboard.units": "Units",
  "hoa.dashboard.residents": "Residents",
  "hoa.dashboard.openIssues": "Open Issues",
  "hoa.dashboard.pendingPayments": "Pending Payments",
  "hoa.dashboard.quick.create": "Create",
  "hoa.dashboard.quick.start": "Start",
  "hoa.dashboard.quick.review": "Review",
  "hoa.dashboard.quick.log": "Log",
  "hoa.dashboard.quick.announcement": "Announcement",
  "hoa.dashboard.quick.poll": "Poll",
  "hoa.dashboard.quick.payments": "Payments",
  "hoa.dashboard.quick.issue": "Issue",
  "hoa.dashboard.recentAnnouncements": "Recent Announcements",
  "hoa.dashboard.shown": "{count} shown",
  "hoa.dashboard.updatedJustNow": "Updated just now",
  "hoa.dashboard.noAnnouncements": "No announcements yet.",
  "hoa.dashboard.viewAll": "View all",
  "hoa.dashboard.activePolls": "Active Polls",
  "hoa.dashboard.liveScheduled": "Live & scheduled",
  "hoa.dashboard.noPolls": "No live or scheduled polls.",
  "hoa.dashboard.status.live": "Live",
  "hoa.dashboard.status.scheduled": "Scheduled",
  "hoa.dashboard.ends": "Ends {date}",
  "hoa.dashboard.totalVotes": "Total votes",
  "hoa.dashboard.manage": "Manage",
  "hoa.dashboard.openPolls": "Open Polls",
  "hoa.dashboard.issues": "Issues",
  "hoa.dashboard.openCount": "{count} open",
  "hoa.dashboard.pending": "Pending",
  "hoa.dashboard.inProgress": "In Progress",
  "hoa.dashboard.resolvedThisWeek": "Resolved this week: {count}",
  "hoa.dashboard.openBoard": "Open board",
  "hoa.dashboard.payments": "Payments",
  "hoa.dashboard.pendingProofs": "{count} pending",
  "hoa.dashboard.thisMonth": "This month",
  "hoa.dashboard.approvedThisWeek": "Approved this week",
  "hoa.dashboard.rejectedThisWeek": "Rejected this week",
  "hoa.dashboard.collectedThisMonth": "Collected this month",
  "hoa.dashboard.reviewPayments": "Review Payments",
  "hoa.dashboard.mock.announcements.a101.title": "Elevator Maintenance Friday",
  "hoa.dashboard.mock.announcements.a101.message": "Elevator B will be serviced from 9am to 2pm. Please plan accordingly.",
  "hoa.dashboard.mock.announcements.a102.title": "Community Meeting",
  "hoa.dashboard.mock.announcements.a102.message": "Monthly HOA meeting on Saturday at 7pm in the community room.",
  "hoa.dashboard.mock.announcements.a103.title": "Pool Hours Reminder",
  "hoa.dashboard.mock.announcements.a103.message": "Pool open daily from 6am to 10pm.",
  "hoa.dashboard.mock.polls.p201.title": "Gym Equipment Purchase",
  "hoa.dashboard.mock.polls.p202.title": "Parking Rules Update",
  "hoa.dashboard.mock.polls.p202.options.approve": "Approve",
  "hoa.dashboard.mock.polls.p202.options.reject": "Reject",

  // HOA Announcements
  "hoa.announcements.toast.created": "Announcement published successfully!",
  "hoa.announcements.toast.createFailed": "Failed to create announcement",
  "hoa.announcements.toast.updated": "Announcement updated successfully!",
  "hoa.announcements.toast.updateFailed": "Failed to update announcement",
  "hoa.announcements.toast.deleted": "Announcement deleted successfully!",
  "hoa.announcements.toast.deleteFailed": "Failed to delete announcement",
  "hoa.announcements.count": "{count} announcements",
  "hoa.announcements.createTitle": "Create announcement",
  "hoa.announcements.new": "New Announcement",
  "hoa.announcements.createNew": "Create New Announcement",
  "hoa.announcements.titlePlaceholder": "Announcement title...",
  "hoa.announcements.contentPlaceholder": "Announcement details...",
  "hoa.announcements.pinToTop": "Pin to top",
  "hoa.announcements.publishDate": "Publish Date",
  "hoa.announcements.expiresOptional": "Expires (optional)",
  "hoa.announcements.publishing": "Publishing...",
  "hoa.announcements.publish": "Publish Announcement",
  "hoa.announcements.pinned": "Pinned",
  "hoa.announcements.postedBy": "Posted by {name}",
  "hoa.announcements.expiresOn": "Expires {date}",
  "hoa.announcements.empty": "No announcements yet",
  "hoa.announcements.editTitle": "Edit Announcement",
  "hoa.announcements.deleteTitle": "Delete announcement?",
  "hoa.announcements.deleteMessage": "\"{title}\" will be permanently removed. This action cannot be undone.",
  "hoa.announcements.deleting": "Deleting...",

  // HOA Payments
  "hoa.payments.title": "Payments & Invoices",
  "hoa.payments.subtitle": "Manage invoices, track payments, and confirm transfers.",
  "hoa.payments.tabs.invoices": "Invoices",
  "hoa.payments.bcv.title": "BCV Exchange Rate",
  "payments.rateValidAsOf": "Rate valid as of {date} (BCV: {rate} Bs./USD)",
  "payments.bcvRateAsOf": "BCV Rate: {rate}Bs. (as of {date})",
  "payments.bcvRateNormal": "BCV rate {rate} Bs./USD · {date}",
  "payments.bcvRateCompact": "BCV {rate} · {date}",
  "hoa.payments.bcv.perUsd": "per 1 USD",
  "hoa.payments.bcv.updated": "Updated: {date}",
  "hoa.payments.bcv.loading": "Loading rate...",
  "hoa.payments.bcv.failed": "Failed to load rate",
  "hoa.payments.bcv.rateInline": "BCV: {rate} Bs./USD",
  "hoa.payments.bcv.rateLine": "BCV rate: {rate} Bs./USD",
  "hoa.payments.bcv.unavailable": "BCV rate unavailable",
  "hoa.payments.bcv.refresh": "Refresh",
  "hoa.payments.bcv.refreshing": "Refreshing...",
  "hoa.payments.searchPlaceholder": "Search resident, unit, or notes...",
  "hoa.payments.period": "Period",
  "hoa.payments.period.this": "This Month",
  "hoa.payments.period.last": "Last Month",
  "hoa.payments.period.all": "All Time",
  "hoa.payments.status": "Status",
  "hoa.payments.status.all": "All Statuses",
  "hoa.payments.status.draft": "Draft",
  "hoa.payments.status.sent": "Sent",
  "hoa.payments.status.unpaid": "Unpaid",
  "hoa.payments.status.partiallyPaid": "Partially Paid",
  "hoa.payments.status.pendingVerification": "Pending Verification",
  "hoa.payments.status.pendingHoaTransfer": "Pending HOA Transfer",
  "hoa.payments.status.paid": "Paid",
  "hoa.payments.status.cancelled": "Cancelled",
  "hoa.payments.statusLabel.draft": "Draft",
  "hoa.payments.statusLabel.cancelled": "Cancelled",
  "hoa.payments.statusLabel.residentPaid": "Resident paid (Urbe360 reviewing)",
  "hoa.payments.statusLabel.urbe360Verified": "Urbe360 verified (transferring to HOA)",
  "hoa.payments.statusLabel.urbe360PaidHoa": "Urbe360 paid HOA (waiting confirmation)",
  "hoa.payments.statusLabel.completed": "Payment confirmed",
  "hoa.payments.statusLabel.overdue": "Overdue from resident",
  "hoa.payments.statusLabel.waiting": "Waiting resident payment",
  "hoa.payments.statusSubtitle.draft": "Invoice not yet sent to resident.",
  "hoa.payments.statusSubtitle.cancelled": "Invoice cancelled.",
  "hoa.payments.statusSubtitle.residentPaid": "Resident claims payment to Urbe360. Under review.",
  "hoa.payments.statusSubtitle.urbe360Verified": "Payment verified by Urbe360. Funds being transferred to HOA.",
  "hoa.payments.statusSubtitle.urbe360PaidHoa": "Urbe360 has sent you the funds. Please confirm.",
  "hoa.payments.statusSubtitle.completed": "You confirmed that you received the payment.",
  "hoa.payments.statusSubtitle.overdue": "Resident payment is overdue.",
  "hoa.payments.statusSubtitle.waiting": "Invoice sent, waiting for resident to pay Urbe360.",
  "hoa.payments.statusSubtitle.partiallyPaid": "Part of the balance has been received. A balance is still outstanding.",
  "hoa.payments.sortBy.amount": "Amount",
  "hoa.payments.sortBy.dueDate": "Payment Date",
  "hoa.payments.sortBy.updatedAt": "Updated",
  "hoa.payments.noResults": "No invoices match your filters.",
  "hoa.payments.createInvoice": "Create Invoice",
  "hoa.payments.bulkCreate": "Bulk Create",
  "hoa.payments.table.unit": "Unit",
  "hoa.payments.table.resident": "Resident",
  "hoa.payments.table.period": "Period",
  "hoa.payments.table.amount": "Amount",
  "hoa.payments.table.dueDate": "Due",
  "hoa.payments.table.status": "Status",
  "hoa.payments.table.updated": "Updated",
  "hoa.payments.table.actions": "Actions",
  "hoa.payments.viewProofs": "View Proofs",
  "hoa.payments.confirmReceipt": "Confirm Receipt",
  "hoa.payments.viewDetails": "View Details",
  "hoa.payments.finalize": "Finalize",
  "hoa.payments.recordCash": "Record Cash",
  "hoa.payments.openInNewTab": "Open in new tab",
  "hoa.payments.tooltip.createSingle": "Create a single invoice",
  "hoa.payments.tooltip.bulkGenerate": "Generate invoices in bulk",
  "hoa.payments.tooltip.bulkReminder": "Send reminders to all overdue invoices",
  "hoa.payments.tooltip.refreshRate": "Refresh BCV rate",
  "hoa.payments.tooltip.viewProofs": "View payment proofs",
  "hoa.payments.tooltip.viewDetails": "View invoice details",
  "hoa.payments.tooltip.finalize": "Finalize and confirm receipt",
  "hoa.payments.tooltip.recordCash": "Mark as cash received",
  "hoa.payments.tooltip.delete": "Delete invoice",
  "hoa.payments.edit": "Edit",
  "hoa.payments.delete": "Delete",
  "hoa.payments.modal.createTitle": "Create Invoice",
  "hoa.payments.modal.editTitle": "Edit Invoice",
  "hoa.payments.modal.bulkTitle": "Bulk Create Invoices",
  "hoa.payments.modal.deleteTitle": "Delete Invoice?",
  "hoa.payments.modal.deleteMessage": "This will permanently delete the invoice for {resident}. This cannot be undone.",
  "hoa.payments.modal.deleteMessageWithPeriod": "This will permanently delete the invoice for {resident} ({period}). This cannot be undone.",
  "hoa.payments.modal.deleting": "Deleting...",
  "hoa.payments.modal.confirmTitle": "Confirm Payment Receipt",
  "hoa.payments.modal.confirmMessage": "Have you received the payment from Urbe360?",
  "hoa.payments.modal.confirmButton": "Yes, I received it",
  "hoa.payments.modal.confirming": "Confirming...",
  "hoa.payments.modal.proofsTitle": "Payment Proofs",
  "hoa.payments.modal.detailsTitle": "Payment Details",
  "hoa.payments.form.resident": "Resident",
  "hoa.payments.form.selectResident": "Select a resident",
  "hoa.payments.form.searchResident": "Search residents...",
  "hoa.payments.form.searchResidentByNameEmailUnit": "Search by name, email, or unit...",
  "hoa.payments.form.unit": "Unit",
  "hoa.payments.form.selectUnit": "Select a unit",
  "hoa.payments.form.noUnit": "No unit",
  "hoa.payments.form.errors.selectResidentOrUnit": "Select a resident or unit.",
  "hoa.payments.form.period": "Period (YYYY-MM)",
  "hoa.payments.form.dueDate": "Payment Date",
  "hoa.payments.form.amountSource": "Amount Source",
  "hoa.payments.form.amountSource.fixed": "Fixed Amount",
  "hoa.payments.form.amountSource.unitRent": "Unit's Monthly Rent",
  "hoa.payments.form.baseAmount": "Base Amount (USD)",
  "hoa.payments.form.credits": "Credits (USD)",
  "hoa.payments.form.total": "Total",
  "hoa.payments.form.description": "Description (optional)",
  "hoa.payments.form.descriptionPlaceholder": "Add any notes about this invoice...",
  "hoa.payments.form.status": "Status",
  "hoa.payments.form.paymentMethod": "Payment Method",
  "hoa.payments.form.paymentMethod.stripe": "Stripe / Tarjeta",
  "hoa.payments.form.paymentMethod.bank": "Bank Transfer",
  "hoa.payments.form.paymentMethod.zelle": "Zelle",
  "hoa.payments.form.paymentMethod.pagoMovil": "Pago Móvil",
  "hoa.payments.form.paymentMethod.cash": "Cash",
  "hoa.payments.form.notes": "Notes (optional)",
  "hoa.payments.form.notesPlaceholder": "Add notes about this payment...",
  "hoa.payments.form.creating": "Creating invoice...",
  "hoa.payments.form.updating": "Updating invoice...",
  "hoa.payments.form.selectPeriod": "Select period",
  "hoa.payments.bulk.building": "Building",
  "hoa.payments.bulk.selectBuilding": "Select a building",
  "hoa.payments.bulk.allBuildings": "All buildings",
  "hoa.payments.bulk.subtitle": "Create multiple invoices at once",
  "hoa.payments.bulk.allUnits": "All Units",
  "hoa.payments.bulk.selectedUnits": "{count} selected",
  "hoa.payments.bulk.selectedSummary": "{selected} of {total} selected",
  "hoa.payments.bulk.selectedInvoices": "{count} invoice(s) selected",
  "hoa.payments.bulk.notesPlaceholder": "Optional note for all generated invoices",
  "hoa.payments.bulk.noResidentsFound": "No residents found",
  "hoa.payments.bulk.period": "Billing Period",
  "hoa.payments.bulk.dueDate": "Payment Date",
  "hoa.payments.bulk.useUnitRent": "Use each unit's monthly rent",
  "hoa.payments.bulk.fixedAmount": "Use fixed amount for all",
  "hoa.payments.bulk.creating": "Creating {count} invoices...",
  "hoa.payments.bulk.generating": "Generating...",
  "hoa.payments.bulk.generate": "Generate",
  "hoa.payments.bulk.success": "Created {count} invoices successfully",
  "hoa.payments.bulk.skippedNoFee": "Skipped (no fee/rent): {count}",
  "hoa.payments.bulk.skippedExisting": "Skipped existing: {count}",
  "hoa.payments.bulk.errors.alreadyExists": "Some invoices already exist for selected residents and period.",
  "hoa.payments.bulk.failed": "Failed to create invoices",
  "hoa.payments.incoming.title": "Incoming Payments",
  "hoa.payments.incoming.subtitle": "Payments awaiting your confirmation",
  "hoa.payments.incoming.empty": "No pending confirmations",
  "hoa.payments.incoming.emptyHelp": "Incoming transfers from Urbe360 will appear here for confirmation.",
  "hoa.payments.incoming.loading": "Loading incoming payments...",
  "hoa.payments.incoming.pendingConfirmation": "Pending Confirmation",
  "hoa.payments.incoming.detailsTitle": "Incoming Payment Details",
  "hoa.payments.incoming.totalAmount": "Total amount",
  "hoa.payments.incoming.residentPaymentMethod": "Resident payment method",
  "hoa.payments.incoming.forwardingInfo": "Forwarding Information",
  "hoa.payments.incoming.forwardedBy": "Forwarded by",
  "hoa.payments.incoming.forwardedAt": "Forwarded at",
  "hoa.payments.incoming.forwardedByLabel": "Forwarded by",
  "hoa.payments.incoming.forwardedByOn": "Forwarded by {name} on {date}",
  "hoa.payments.incoming.paymentMethodUsed": "Payment method used",
  "hoa.payments.incoming.yourPaymentAccount": "Your Payment Account",
  "hoa.payments.incoming.fundsTransferredHere": "The funds were transferred to this HOA account.",
  "hoa.payments.incoming.count": "{count} payment(s) waiting confirmation",
  "hoa.payments.toast.created": "Invoice created successfully",
  "hoa.payments.toast.createFailed": "Failed to create invoice",
  "hoa.payments.toast.updated": "Invoice updated successfully",
  "hoa.payments.toast.updateFailed": "Failed to update invoice",
  "hoa.payments.toast.deleted": "Invoice deleted successfully",
  "hoa.payments.toast.deleteFailed": "Failed to delete invoice",
  "hoa.payments.toast.confirmed": "Payment confirmed successfully",
  "hoa.payments.toast.confirmFailed": "Failed to confirm payment",
  "hoa.payments.toast.cashRecorded": "Cash payment recorded successfully",
  "hoa.payments.toast.cashRecordFailed": "Failed to record cash payment",
  "hoa.payments.toast.manualRecorded": "Payment recorded successfully",
  "hoa.payments.toast.manualRecordFailed": "Failed to record payment",
  "hoa.payments.manual.title": "Record payment manually",
  "hoa.payments.manual.method": "Payment method",
  "hoa.payments.manual.proofRequired": "Transaction proof (required)",
  "hoa.payments.manual.referenceOptional": "Bank reference (optional)",
  "hoa.payments.manual.referencePlaceholder": "e.g., confirmation or reference number",
  "hoa.payments.manual.notesOptional": "Notes (optional)",
  "hoa.payments.manual.notesPlaceholder": "Add optional notes for this payment...",
  "hoa.payments.manual.recording": "Recording payment...",
  "hoa.payments.manual.submit": "Record payment",
  "hoa.payments.manual.remainingBalance": "Remaining balance",
  "hoa.payments.manual.paymentDate": "Payment date",
  "hoa.payments.manual.amountUsd": "Amount (USD)",
  "hoa.payments.manual.amountVes": "Amount (VES)",
  "hoa.payments.manual.rateHint": "Converted at",
  "hoa.payments.manual.rateForDate": "BCV rate for {date}",
  "hoa.payments.manual.rateCarried": "no rate published that day; carried forward {days} day(s)",
  "hoa.payments.manual.rateMissing": "No BCV rate is on record for that date. Enter the USD amount directly, or pick another date.",
  "hoa.payments.errors.invoiceExistsForUnitPeriod": "An invoice already exists for this resident/unit and period.",
  "hoa.payments.errors.retryDifferentValues": "Try a different resident, unit, or period.",
  "hoa.payments.card.unit": "Unit {unit}",
  "hoa.payments.card.resident": "Resident: {name}",
  "hoa.payments.card.due": "Due: {date}",
  "hoa.payments.details.invoice": "Invoice Details",
  "hoa.payments.details.resident": "Resident",
  "hoa.payments.details.residentEmail": "Resident Email",
  "hoa.payments.details.unit": "Unit",
  "hoa.payments.details.period": "Period",
  "hoa.payments.details.invoiceDate": "Invoice Date",
  "hoa.payments.details.createdAt": "Created At",
  "hoa.payments.details.dueDate": "Payment Date",
  "hoa.payments.details.amountPaid": "Amount Paid",
  "hoa.payments.details.balanceDue": "Balance Due",
  "hoa.payments.details.updatedAt": "Updated At",
  "hoa.payments.details.baseAmount": "Base Amount",
  "hoa.payments.details.credits": "Credits",
  "hoa.payments.details.totalAmount": "Total Amount",
  "hoa.payments.details.bcvRateFixed": "BCV Rate (fixed at creation)",
  "hoa.payments.details.bcvRateFixedLine": "{rate} Bs./USD · {date}",
  "hoa.payments.details.status": "Status",
  "hoa.payments.details.flow": "Payment Flow",
  "hoa.payments.details.paymentMethod": "Payment Method",
  "hoa.payments.details.cashNotesOptional": "Cash payment notes (optional)",
  "hoa.payments.details.cashNotesPlaceholder": "Add optional notes for this cash payment...",
  "hoa.payments.details.recordingCash": "Recording cash payment...",
  "hoa.payments.details.markedPaidAt": "Marked Paid At",
  "hoa.payments.details.verifiedAt": "Verified At",
  "hoa.payments.details.finalizedAt": "Finalized At",
  "hoa.payments.details.notes": "Notes",
  "hoa.payments.details.description": "Description",
  "hoa.payments.details.noNotes": "No notes",
  "hoa.payments.details.noDescription": "No description",
  "hoa.payments.proofs.loading": "Loading proofs...",
  "hoa.payments.proofs.noProofs": "No proofs available.",
  "hoa.payments.proofs.residentTransactionProof": "Resident Transaction Proof",
  "hoa.payments.proofs.residentIdVerification": "Resident ID Verification",
  "hoa.payments.proofs.residentNotes": "Resident Notes",
  "hoa.payments.proofs.noResidentProofs": "No resident proofs were uploaded.",
  "hoa.payments.proofs.forwardingMethod": "Forwarding Method",
  "hoa.payments.proofs.transferMethod": "Transfer Method",
  "hoa.payments.proofs.stripePaypal": "Stripe / PayPal",
  "hoa.payments.proofs.forwardingNotes": "Forwarding Notes",
  "hoa.payments.proofs.notesFromUrbe": "Notes from Urbe360",
  "hoa.payments.proofs.transferProof": "Transfer Proof",
  "hoa.payments.proofs.transferProofFromUrbe": "Transfer Proof from Urbe360",
  "hoa.payments.proofs.noTransferProof": "No transfer proof uploaded yet.",
  "hoa.payments.proofs.noTransferInfo": "No transfer information provided yet.",

  // HOA Building Details
  "hoa.buildingDetail.backToBuildings": "Back to Buildings",
  "hoa.buildingDetail.edit": "Edit Building",
  "hoa.buildingDetail.delete": "Delete Building",
  "hoa.buildingDetail.deleteConfirm": "Are you sure you want to delete this building?",
  "hoa.buildingDetail.deleteWarning": "This will permanently delete all units, residents, and associated data. This action cannot be undone.",
  "hoa.buildingDetail.deleting": "Deleting...",
  "hoa.buildingDetail.tabs.overview": "Overview",
  "hoa.buildingDetail.tabs.units": "Units",
  "hoa.buildingDetail.tabs.residents": "Residents",
  "hoa.buildingDetail.stats.totalUnits": "Total Units",
  "hoa.buildingDetail.stats.totalResidents": "Total Residents",
  "hoa.buildingDetail.stats.avgMonthlyFee": "Avg. Monthly Fee",
  "hoa.buildingDetail.stats.occupancyRate": "Occupancy Rate",
  "hoa.buildingDetail.info.buildingCode": "Building Code",
  "hoa.buildingDetail.info.buildingName": "Building Name",
  "hoa.buildingDetail.info.address": "Address",
  "hoa.buildingDetail.info.city": "City",
  "hoa.buildingDetail.info.state": "State",
  "hoa.buildingDetail.info.postalCode": "Postal Code",
  "hoa.buildingDetail.info.country": "Country",
  "hoa.buildingDetail.info.defaultMonthlyFee": "Default Monthly Fee",
  "hoa.buildingDetail.info.totalFloors": "Total Floors",
  "hoa.buildingDetail.info.created": "Created",
  "hoa.buildingDetail.units.title": "Units",
  "hoa.buildingDetail.units.addUnit": "Add Unit",
  "hoa.buildingDetail.units.importCSV": "Import CSV",
  "hoa.buildingDetail.units.downloadTemplate": "Download Template",
  "hoa.buildingDetail.units.search": "Search units...",
  "hoa.buildingDetail.units.empty": "No units found. Add your first unit to get started.",
  "hoa.buildingDetail.units.table.number": "Unit Number",
  "hoa.buildingDetail.units.table.floor": "Floor",
  "hoa.buildingDetail.units.table.size": "Size (m²)",
  "hoa.buildingDetail.units.table.bedrooms": "Bedrooms",
  "hoa.buildingDetail.units.table.bathrooms": "Bathrooms",
  "hoa.buildingDetail.units.table.monthlyFee": "Monthly Fee",
  "hoa.buildingDetail.units.table.status": "Status",
  "hoa.buildingDetail.units.table.resident": "Resident",
  "hoa.buildingDetail.units.table.actions": "Actions",
  "hoa.buildingDetail.units.status.vacant": "Vacant",
  "hoa.buildingDetail.units.status.occupied": "Occupied",
  "hoa.buildingDetail.units.status.maintenance": "Maintenance",
  "hoa.buildingDetail.units.modal.create": "Create Unit",
  "hoa.buildingDetail.units.modal.edit": "Edit Unit",
  "hoa.buildingDetail.units.modal.delete": "Delete Unit",
  "hoa.buildingDetail.units.modal.deleteConfirm": "Are you sure you want to delete this unit?",
  "hoa.buildingDetail.units.form.unitNumber": "Unit Number",
  "hoa.buildingDetail.units.form.unitCode": "Unit Code",
  "hoa.buildingDetail.units.form.floor": "Floor",
  "hoa.buildingDetail.units.form.size": "Size (m²)",
  "hoa.buildingDetail.units.form.bedrooms": "Bedrooms",
  "hoa.buildingDetail.units.form.bathrooms": "Bathrooms",
  "hoa.buildingDetail.units.form.monthlyFee": "Monthly Fee (USD)",
  "hoa.buildingDetail.units.form.status": "Status",
  "hoa.buildingDetail.units.form.creating": "Creating...",
  "hoa.buildingDetail.units.form.updating": "Updating...",
  "hoa.buildingDetail.residents.title": "Residents",
  "hoa.buildingDetail.residents.addResident": "Add Resident",
  "hoa.buildingDetail.residents.importCSV": "Import CSV",
  "hoa.buildingDetail.residents.downloadTemplate": "Download Template",
  "hoa.buildingDetail.residents.sendOTP": "Send OTP",
  "hoa.buildingDetail.residents.selectAll": "Select All",
  "hoa.buildingDetail.residents.deselectAll": "Deselect All",
  "hoa.buildingDetail.residents.selected": "{count} selected",
  "hoa.buildingDetail.residents.search": "Search residents...",
  "hoa.buildingDetail.residents.empty": "No residents found. Add your first resident to get started.",
  "hoa.buildingDetail.residents.emptyUnits": "Create a unit first to add residents",
  "hoa.buildingDetail.residents.table.name": "Name",
  "hoa.buildingDetail.residents.table.email": "Email",
  "hoa.buildingDetail.residents.table.phone": "Phone",
  "hoa.buildingDetail.residents.table.unit": "Unit",
  "hoa.buildingDetail.residents.table.role": "Role",
  "hoa.buildingDetail.residents.table.balance": "Balance",
  "hoa.buildingDetail.residents.table.actions": "Actions",
  "hoa.buildingDetail.residents.role.tenant": "Tenant",
  "hoa.buildingDetail.residents.role.owner": "Owner",
  "hoa.buildingDetail.residents.modal.create": "Create Resident",
  "hoa.buildingDetail.residents.modal.edit": "Edit Resident",
  "hoa.buildingDetail.residents.modal.delete": "Delete Resident",
  "hoa.buildingDetail.residents.modal.deleteConfirm": "Are you sure you want to delete this resident?",
  "hoa.buildingDetail.residents.form.firstName": "First Name",
  "hoa.buildingDetail.residents.form.lastName": "Last Name",
  "hoa.buildingDetail.residents.form.email": "Email",
  "hoa.buildingDetail.residents.form.phone": "Phone",
  "hoa.buildingDetail.residents.form.unit": "Unit",
  "hoa.buildingDetail.residents.form.selectUnit": "Select a unit",
  "hoa.buildingDetail.residents.form.role": "Role",
  "hoa.buildingDetail.residents.form.contactType": "Contact Type",
  "hoa.buildingDetail.residents.form.currentBalance": "Current Balance",
  "hoa.buildingDetail.residents.form.creating": "Creating...",
  "hoa.buildingDetail.residents.form.updating": "Updating...",
  "hoa.buildingDetail.toast.unitCreated": "Unit created successfully",
  "hoa.buildingDetail.toast.unitUpdated": "Unit updated successfully",
  "hoa.buildingDetail.toast.unitDeleted": "Unit deleted successfully",
  "hoa.buildingDetail.toast.unitCreateFailed": "Failed to create unit",
  "hoa.buildingDetail.toast.unitUpdateFailed": "Failed to update unit",
  "hoa.buildingDetail.toast.unitDeleteFailed": "Failed to delete unit",
  "hoa.buildingDetail.toast.residentCreated": "Resident created successfully",
  "hoa.buildingDetail.toast.residentUpdated": "Resident updated successfully",
  "hoa.buildingDetail.toast.residentDeleted": "Resident deleted successfully",
  "hoa.buildingDetail.toast.residentCreateFailed": "Failed to create resident",
  "hoa.buildingDetail.toast.residentUpdateFailed": "Failed to update resident",
  "hoa.buildingDetail.toast.residentDeleteFailed": "Failed to delete resident",
  "hoa.buildingDetail.toast.otpSent": "OTP sent successfully",
  "hoa.buildingDetail.toast.otpFailed": "Failed to send OTP",
  "hoa.buildingDetail.toast.buildingDeleted": "Building deleted successfully",
  "hoa.buildingDetail.toast.buildingDeleteFailed": "Failed to delete building",

  // HOA Communications
  "hoa.communications.title": "Communications",
  "hoa.communications.subtitle": "Announcements, polls, and reported issues.",
  "hoa.communications.tabs.announcements": "Announcements",
  "hoa.communications.tabs.polling": "Polling",
  "hoa.communications.tabs.issues": "Reported Issues",

  // HOA Issues (Admin)
  "hoa.issues.subtitle": "Track maintenance requests and status updates.",
  "hoa.issues.new": "New Issue",
  "hoa.issues.status.pending": "Pending",
  "hoa.issues.status.inProgress": "In Progress",
  "hoa.issues.status.resolved": "Resolved",
  "hoa.issues.searchPlaceholder": "Search title, unit, details...",
  "hoa.issues.allPriorities": "All priorities",
  "hoa.issues.empty": "No issues found",
  "hoa.issues.modal.newTitle": "New Issue",
  "hoa.issues.modal.editTitle": "Edit Issue",
  "hoa.issues.deleteTitle": "Delete issue?",
  "hoa.issues.deleteMessage": "\"{title}\" will be permanently removed.",
  "hoa.issues.actions.start": "Start",
  "hoa.issues.actions.resolve": "Resolve",
  "hoa.issues.actions.markResolved": "Mark Resolved",
  "hoa.issues.actions.backToPending": "Back to Pending",
  "hoa.issues.actions.reopen": "Reopen",
  "hoa.issues.unit": "Unit {unit}",
  "hoa.issues.updatedBy": "Updated {date} • Opened by {name}",
  "hoa.issues.titlePlaceholder": "E.g., Water leakage in 7C",
  "hoa.issues.descriptionOptional": "Description (optional)",
  "hoa.issues.descriptionPlaceholder": "Describe the issue...",
  "hoa.issues.assignUnit": "Assign Unit (optional)",
  "hoa.issues.heading": "Issues",
  "hoa.issues.allCategories": "All categories",
  "hoa.issues.loadError": "Could not load issues. Please try again.",
  "hoa.issues.stat.open": "Open",
  "hoa.issues.triage": "Triage",
  "hoa.issues.clearFilters": "Clear filters",
  "hoa.issues.emptyHint": "Reports from residents will appear here as soon as they arrive.",
  "hoa.issues.emptyFiltered": "Nothing matches these filters",
  "hoa.issues.emptyFilteredHint": "Try a different status, or clear the filters to see everything.",
  "hoa.issues.deleteFiles": "Its photos and documents are deleted from storage too.",
  "hoa.issues.statusNote": "Note for the next status change (optional)",
  "hoa.issues.statusNotePlaceholder": "E.g., Plumber booked for Thursday",
  "hoa.issues.actions.cancel": "Cancel issue",

  // HOA Polls
  "hoa.polls.toast.createdTitle": "Poll created",
  "hoa.polls.toast.createdDesc": "Your poll has been created successfully.",
  "hoa.polls.toast.createFailed": "Failed to create poll",
  "hoa.polls.toast.updatedTitle": "Poll updated",
  "hoa.polls.toast.updatedDesc": "Your changes have been saved.",
  "hoa.polls.toast.updateFailed": "Failed to update poll",
  "hoa.polls.toast.deletedTitle": "Poll deleted",
  "hoa.polls.toast.deletedDesc": "The poll has been removed.",
  "hoa.polls.toast.deleteFailed": "Failed to delete poll",
  "hoa.polls.toast.closedTitle": "Poll closed",
  "hoa.polls.toast.closedDesc": "The poll has been closed. No more votes will be accepted.",
  "hoa.polls.toast.closeFailed": "Failed to close poll",
  "hoa.polls.title": "Polls & Voting",
  "hoa.polls.subtitle": "Create polls, monitor live results, and manage schedules.",
  "hoa.polls.statusSummary": "{live} live • {scheduled} scheduled • {closed} closed",
  "hoa.polls.new": "New Poll",
  "hoa.polls.closeTitle": "Close poll?",
  "hoa.polls.closeMessage": "\"{title}\" will be closed and no more votes will be accepted.",
  "hoa.polls.closeAction": "Close poll",
  "hoa.polls.deleteTitle": "Delete poll?",
  "hoa.polls.deleteMessage": "\"{title}\" will be permanently removed. This action cannot be undone.",
  "hoa.polls.status.live": "Live",
  "hoa.polls.status.scheduled": "Scheduled",
  "hoa.polls.status.closed": "Closed",
  "hoa.polls.multipleChoice": "Multiple choice",
  "hoa.polls.anonymous": "Anonymous",
  "hoa.polls.quorum": "{percent}% quorum",
  "hoa.polls.starts": "Starts: {date}",
  "hoa.polls.ends": "Ends: {date}",
  "hoa.polls.totalVotes": "Total votes: {count}",
  "hoa.polls.loadingDetails": "Loading poll details...",
  "hoa.polls.allowMultiple": "Allow multiple",
  "hoa.polls.allowChangeVote": "Allow change vote",
  "hoa.polls.quorumLabel": "Quorum",
  "hoa.polls.eligible": "Eligible",
  "hoa.polls.startsLabel": "Starts",
  "hoa.polls.endsLabel": "Ends",
  "hoa.polls.createdBy": "Created by",
  "hoa.polls.noOptions": "No options available",
  "hoa.polls.editTitle": "Edit Poll",
  "hoa.polls.titlePlaceholder": "Poll title",
  "hoa.polls.descriptionOptional": "Description (optional)",
  "hoa.polls.descriptionPlaceholder": "Short context for residents",
  "hoa.polls.optionsLabel": "Options (labels only)",
  "hoa.polls.optionLabel": "Option {index}",
  "hoa.polls.removeOption": "Remove option",
  "hoa.polls.addOption": "+ Add option",
  "hoa.polls.start": "Start",
  "hoa.polls.end": "End",
  "hoa.polls.quorumOptional": "Quorum % (optional)",
  "hoa.polls.quorumPlaceholder": "e.g., 50",
  "hoa.polls.totalEligibleOptional": "Total eligible voters (optional)",
  "hoa.polls.anonymousVoting": "Anonymous voting",
  "hoa.polls.emptyTitle": "No polls yet",
  "hoa.polls.emptyDesc": "Create your first poll for residents to vote.",
  "hoa.polls.createTitle": "Create Poll",
  "hoa.polls.buildingRequired": "Building *",
  "hoa.polls.loadingBuildings": "Loading buildings...",
  "hoa.polls.selectBuilding": "Select a building",
  "hoa.polls.noBuildings": "No buildings available. Please create a building first.",
  "hoa.polls.options": "Options",
  "hoa.polls.creating": "Creating...",
  "hoa.polls.createAction": "Create poll",

  // HOA Residents
  "hoa.residents.otpSent": "OTP sent successfully to {name}!",
  "otp.alreadyActive": "OTP already active",
  "otp.useExisting": "Use the same code currently active for this resident.",
  "otp.resendAvailableIn": "Resend available in {time}.",
  "otp.resent": "OTP resent",
  "otp.resentDescription": "Existing one-time password resent to resident.",
  "otp.sent": "OTP sent",
  "otp.sentDescription": "One-time password delivered to resident.",
  "otp.failedSend": "Failed to send OTP",
  "otp.failedSendFallback": "Please try again. The email API limit may be exhausted.",
  "otp.sending": "Sending OTP...",
  "otp.bulk.sent": "OTPs sent ({count})",
  "otp.bulk.sentDescription": "All invitations delivered successfully.",
  "otp.bulk.someInCooldown": "{count} resident(s) already had an active OTP in cooldown.",
  "otp.bulk.issues": "OTPs sent with issues ({count} delivered)",
  "otp.bulk.issuesDescription": "{failed} invitation(s) failed. {cooldown} in cooldown.",
  "otp.bulk.failed": "Failed to send OTPs",
  "hoa.residents.title": "Resident Management",
  "hoa.residents.subtitle": "Manage residents, contact info, and payment status.",
  "hoa.residents.searchPlaceholder": "Search resident, email, or unit...",
  "hoa.residents.sendInvites": "Send Invitations ({count})",
  "hoa.residents.sendOtp": "Send OTP ({count})",
  "hoa.residents.sendOtpTitle": "Send OTP",
  "hoa.residents.importCsv": "Import CSV",
  "hoa.residents.selectAll": "Select All ({selected}/{total})",
  "hoa.residents.sort.nameAsc": "Name (A-Z)",
  "hoa.residents.sort.nameDesc": "Name (Z-A)",
  "hoa.residents.sort.unitAsc": "Unit Code (A-Z)",
  "hoa.residents.sort.unitDesc": "Unit Code (Z-A)",
  "hoa.residents.sort.buildingAsc": "Building (A-Z)",
  "hoa.residents.sort.buildingDesc": "Building (Z-A)",
  "hoa.residents.primary": "Primary",
  "hoa.residents.secondary": "Secondary",
  "hoa.residents.primaryResident": "Primary resident",
  "hoa.residents.empty": "No residents yet. Click + to add one.",
  "hoa.residents.noMatches": "No matching residents.",
  "hoa.residents.unitLabel": "Unit {unit} {building}",
  "hoa.residents.add": "Add resident",
  "hoa.residents.deleteTitle": "Delete resident",
  "hoa.residents.deleteDesc": "This action cannot be undone. The resident will be removed from the list.",
  "hoa.residents.sheet.addTitle": "Add Resident",
  "hoa.residents.sheet.editTitle": "Edit Resident",
  "hoa.residents.sheet.description": "Fill in basic details. You can update later.",
  "hoa.residents.sheet.fullName": "Full name *",
  "hoa.residents.sheet.phonePlaceholder": "+1 (555) 123-4567",
  "hoa.residents.sheet.selectUnit": "Select a unit",
  "hoa.residents.roles.owner": "Owner",
  "hoa.residents.roles.tenant": "Tenant",
  "hoa.residents.errors.noPackage": "You cannot manage residents because your subscription is not active. Please update your plan in Settings or contact support.",
  "hoa.residents.errors.limitReached": "You reached the limit allowed by your current plan. Please upgrade to continue.",
  "hoa.residents.errors.validation": "Please review resident data and correct the highlighted fields.",
  "hoa.residents.errors.rateLimited": "Too many attempts in a short time. Please wait a moment and try again.",

  // Profile Page
  "profile.title": "Profile",
  "profile.personalInfo": "Personal Information",
  "profile.personalInfoDesc": "Manage your account details",
  "profile.fullName": "Full Name",
  "profile.email": "Email",
  "profile.phone": "Phone Number",
  "profile.unit": "Unit",
  "profile.saveChanges": "Save Changes",
  "profile.changePhoto": "Change Photo",
  "profile.removePhoto": "Remove Photo",
  "profile.notifications": "Notifications",
  "profile.notificationsDesc": "Control what notifications you receive",
  "profile.announcements": "Announcements",
  "profile.announcementsDesc": "Get notified about new community announcements",
  "profile.polls": "Polls & Voting",
  "profile.pollsDesc": "Get notified about new polls and voting deadlines",
  "profile.paymentReminders": "Payment Reminders",
  "profile.paymentRemindersDesc": "Receive reminders before payment due dates",
  "profile.issueUpdates": "Issue Updates",
  "profile.issueUpdatesDesc": "Get updates on your reported issues",
  "profile.security": "Security",
  "profile.securityDesc": "Manage your password and security settings",
  "profile.changePassword": "Change Password",
  "profile.currentPassword": "Current Password",
  "profile.newPassword": "New Password",
  "profile.confirmPassword": "Confirm New Password",
  "profile.updatePassword": "Update Password",
  "profile.twoFactorAuth": "Two-Factor Authentication",
  "profile.twoFactorAuthDesc": "Add an extra layer of security to your account",
  "profile.enable2FA": "Enable 2FA",
  "profile.disable2FA": "Disable 2FA",
  "profile.language": "Language",
  "profile.languageDesc": "Choose your preferred language",
  "profile.languageAppliedNote": "Language preference will be applied across the app.",
  "profile.english": "English",
  "profile.spanish": "Spanish",
  "profile.default": "Default",
  "profile.appSettings": "App Settings",
  "profile.appSettingsDesc": "Customize your experience",
  "profile.darkMode": "Dark Mode",
  "profile.darkModeDesc": "Switch between light and dark theme",
  "profile.support": "Support",
  "profile.supportDesc": "Get help or contact us",
  "profile.helpCenter": "Help Center",
  "profile.contactSupport": "Contact Support",
  "profile.deleteAccount": "Delete Account",
  "profile.deleteAccountDesc": "Permanently delete your account and all data",
  "profile.deleteAccountWarning": "This action cannot be undone. All your data will be permanently deleted.",
  "profile.confirmDelete": "Yes, delete my account",
  "profile.logoutTitle": "Log Out",
  "profile.logoutDesc": "Sign out of your account",
  "profile.logoutConfirm": "Are you sure you want to log out?",
  "profile.version": "Version",
  "profile.installApp": "Install App",
  "profile.deviceInfo": "Device Information",
  "profile.platform": "Platform",
  "profile.browser": "Browser",
  "profile.personalInfoViewOnlyDesc": "Update your contact details. Unit is view only.",
  "profile.avatarAlt": "Profile avatar",
  "profile.profilePhoto": "Profile photo",
  "profile.photoUploadHelp": "JPG/PNG, up to 4 MB. We'll scan uploads for safety.",
  "profile.saveProfile": "Save Profile",
  "profile.deleteAccountRequestDesc": "Request account deletion. This requires HOA approval.",
  "profile.installHelp": "Install help",
  "profile.install.calloutLine1": "If you don't see the Install button, your browser may not support automatic prompts.",
  "profile.install.calloutLine2": "Follow the steps below for your device.",
  "profile.install.ios.title": "iPhone / iPad (Safari)",
  "profile.install.ios.step1.pre": "Tap the",
  "profile.install.ios.step1.post": "icon in Safari.",
  "profile.install.ios.step2.pre": "Choose",
  "profile.install.ios.step3.pre": "Tap",
  "profile.install.ios.note": "If already installed, open it from your Home Screen.",
  "profile.install.android.title": "Android (Chrome)",
  "profile.install.android.step1.pre": "Tap the",
  "profile.install.android.step1.post": "menu in Chrome.",
  "profile.install.android.step2.pre": "Select",
  "profile.install.android.step2.middle": "or",
  "profile.install.android.step3": "Confirm to install.",
  "profile.install.desktop.title": "Desktop (Chrome / Edge)",
  "profile.install.desktop.step1.pre": "Look for the",
  "profile.install.desktop.step1.post": "icon in the address bar, or",
  "profile.install.desktop.step2.pre": "Open browser menu ->",
  "profile.install.desktop.note": "Installed apps open in their own window.",
  "profile.install.term.share": "Share",
  "profile.install.term.addToHomeScreen": "Add to Home Screen",
  "profile.install.term.add": "Add",
  "profile.install.term.menuDots": "⋮",
  "profile.install.term.installApp": "Install app",
  "profile.install.term.install": "Install",
  "profile.install.button.installApp": "Install app",
  "profile.install.button.installedOrNotSupported": "Installed / Not supported",
  "profile.install.button.install": "Install",
  "profile.install.button.alreadyInstalled": "App is already installed",
  "profile.install.button.notSupported": "Install not supported on this browser",
  "profile.alert.profileUpdated": "Profile updated.",
  "profile.alert.notificationsSaved": "Notification settings saved.",
  "profile.alert.passwordMismatch": "New password and confirmation do not match.",
  "profile.alert.passwordChanged": "Password changed.",
  "profile.alert.loggedOutAllDevices": "Logged out from all devices.",
  "profile.alert.accountDeletionRequested": "Account deletion requested. HOA admin will review.",
  "profile.alert.twoFactorUpdatedStub": "2FA updated (stub).",
  "profile.properties": "Properties",
  "profile.propertiesDesc": "Your active property and all linked memberships.",
  "profile.switchProperty": "Switch Property",
  "profile.active": "Active",
  "profile.primaryContact": "Primary contact",
  "profile.unknownBuilding": "Unknown building",
  "profile.noActiveProperty": "No active property in this session.",

  // Payments Page
  "payments.title": "Payments",
  "payments.subtitle": "Manage your invoices and payment history",
  "payments.pending": "Pending",
  "payments.paid": "Paid",
  "payments.overdue": "Overdue",
  "payments.partiallyPaid": "Partially Paid",
  "payments.dueDate": "Payment Date",
  "payments.dueOn": "Due on",
  "payments.paidOn": "Paid on",
  "payments.amount": "Amount",
  "payments.balance": "Balance",
  "payments.payNow": "Pay Now",
  "payments.viewDetails": "View Details",
  "payments.downloadReceipt": "Download Receipt",
  "payments.paymentMethod": "Payment Method",
  "payments.selectMethod": "Select payment method",
  "payments.bankTransfer": "Bank Transfer",
  "payments.mobilePayment": "Mobile Payment",
  "payments.cash": "Cash",
  "payments.creditCard": "Credit Card",
  "payments.uploadProof": "Upload Payment Proof",
  "payments.proofRequired": "Upload a screenshot or photo of your payment",
  "payments.submitPayment": "Submit Payment",
  "payments.paymentHistory": "Payment History",
  "payments.noPayments": "No payments found",
  "payments.noPendingInvoices": "No pending invoices",
  "payments.allPaid": "All invoices are paid!",
  "payments.invoice": "Invoice",
  "payments.invoiceNumber": "Invoice #",
  "payments.invoiceDetails": "Invoice Details",
  "payments.concept": "Concept",
  "payments.period": "Period",
  "payments.issuedOn": "Issued on",
  "payments.reference": "Reference",
  "payments.notes": "Notes",
  "payments.summary": "Summary",
  "payments.subtotal": "Subtotal",
  "payments.tax": "Tax",
  "payments.discount": "Discount",
  "payments.totalDue": "Total Due",
  "payments.amountPaid": "Amount Paid",
  "payments.remainingBalance": "Remaining Balance",
  "payments.paymentPending": "Payment Pending Verification",
  "payments.paymentVerified": "Payment Verified",
  "payments.paymentRejected": "Payment Rejected",
  "payments.verificationPending": "Your payment is being verified",
  "payments.thankYou": "Thank you for your payment!",
  "payments.dueThisMonth": "Due This Month",
  "payments.totalUnpaid": "Total Unpaid",
  "payments.pendingTab": "Pending",
  "payments.historyTab": "Payment History",
  "payments.searchInvoices": "Search Invoices",
  "payments.searchPlaceholder": "Invoice ID, period, description...",
  "payments.showing": "Showing",
  "payments.invoicesUnpaid": "invoice(s) (unpaid)",
  "payments.invoicesPaid": "invoice(s) (paid)",
  "payments.refresh": "Refresh",
  "payments.refreshing": "Refreshing...",
  "payments.loadingInvoices": "Loading invoices...",
  "payments.noMatchingInvoices": "No invoices match your search.",
  "payments.calendarMonth": "Calendar month",
  "payments.paymentSent": "Payment sent (under review)",
  "payments.paidByUrbe360": "Paid by Urbe360",
  "payments.paymentConfirmed": "Payment confirmed",
  "payments.verified": "Payment verified",
  "payments.transferringToHoa": "Urbe360 verified your payment. Funds are being transferred to HOA.",
  "payments.expired": "Overdue",
  "payments.urbe360Reviewing": "Urbe360 is reviewing your receipt.",
  "payments.urbe360PaidAdmin": "Urbe360 already paid the administration. Pending confirmation.",
  "payments.adminConfirmedPayment": "The administration confirmed they received your payment.",
  "payments.invoiceOverdue": "This invoice is overdue. Please pay as soon as possible.",
  "payments.partiallyPaidSubtitle": "The administration recorded part of this payment. A balance is still outstanding.",
  "payments.notReceived": "We have not received the payment for this invoice yet.",
  "payments.dueOn2": "Due:",
  "payments.paymentSentDate": "Payment sent:",
  "payments.underReview": "under review",
  "payments.paidDate": "Paid:",
  "payments.openInvoice": "Open invoice",
  "payments.unpaid": "Unpaid",
  "payments.verifyingPayment": "Your payment is being verified by the administrator",
  "payments.reviewInvoiceDetails": "Review invoice details.",
  "payments.reviewDetailsAndPay": "Review the details and complete the payment.",
  "payments.invoiceId": "Invoice ID",
  "payments.dueDate2": "Payment Date",
  "payments.baseAmount": "Base Amount",
  "payments.credits": "Credits",
  "payments.paymentTimeline": "Payment Timeline",
  "payments.paymentSentToUrbe360": "Payment sent to Urbe360",
  "payments.urbe360ConfirmedPaid": "Urbe360 confirmed and paid administration",
  "payments.adminConfirmedReceipt": "Administration confirmed receipt of payment",
  "payments.totalToPay": "Total to Pay",
  "payments.invoiceAlreadyPaid": "This invoice is already paid.",
  "payments.choosePaymentMethod": "Choose a payment method",
  "payments.zelle": "Zelle",
  "payments.transfer": "Transfer",
  "payments.stripe": "Stripe / Card (+3%)",
  "payments.pagoMovil": "Pago Movil",
  "payments.stripeCard": "Stripe / Card",
  "payments.recipient": "Recipient",
  "payments.accountName": "Account Name",
  "payments.memo": "Memo",
  "payments.bank": "Bank",
  "payments.instructions": "Instructions",
  "payments.schedule": "Schedule",
  "payments.idNumberRif": "ID Number (Cedula/RIF)",
  "payments.paymentLink": "Payment Link",
  "payments.accountNumber": "Account Number",
  "payments.routingNumber": "Routing Number",
  "payments.method": "Method",
  "payments.service": "Service",
  "payments.paymentAccountDetails": "Payment Account Details",
  "payments.pagoMovilBankName": "Banesco",
  "payments.pagoMovilPhone": "0414-1234567",
  "payments.pagoMovilIdNumber": "J-40123456-7",
  "payments.pagoMovilConcept": "Condo payment",
  "payments.pagoMovilHelper": "Please send your screenshot with the reference number after paying.",
  "payments.cashOfficeDelivery": "Deliver payment at the administration office",
  "payments.cashSchedule": "Monday to Friday, 8am to 5pm",
  "payments.cashHelper": "The payment proof will be uploaded to the platform by administration once received.",
  "payments.stripePaymentLink": "https://buy.stripe.com/test_12345",
  "payments.stripeInstructions": "Pay via the link, then upload a screenshot of the receipt here.",
  "payments.stripeLinkHelper": "The Super Admin has provided this Stripe link. Click or copy it to pay securely, then attach your receipt.",
  "payments.cashManagedByHoaAdmin": "Cash payments are managed directly by your HOA administrator.",
  "payments.cashVisitOfficeInstructions": "Please visit the administration office to deliver cash. They will record the payment and update the status in your portal.",
  "payments.noFileChosen": "No file chosen",
  "payments.copy": "Copy",
  "payments.zelleHelper": "Zelle transfers are usually completed in minutes. No fees.",
  "payments.bankTransferHelper": "ACH transfers may take 1-3 business days.",
  "payments.stripeHelper": "You will be redirected to a secure Stripe page to complete payment. A 3% fee applies.",
  "payments.redirectToStripe": "You will be redirected to Stripe to complete your payment.",
  "payments.goToStripe": "Go to Stripe",
  "payments.uploadPaymentProof": "Upload payment proof",
  "payments.paymentDate": "Date you made the payment *",
  "payments.paymentDateHelp": "The day the transfer left your account. The BCV rate for that day is the one recorded on your receipt.",
  "payments.transactionScreenshot": "Transaction screenshot *",
  "payments.idDocument": "ID document *",
  "payments.choosePdfJpgPng": "Choose PDF/JPG/PNG (max 10MB)",
  "payments.notesOptional": "Notes (optional)",
  "payments.addNoteAboutPayment": "Add any note about your payment...",
  "payments.markAsPaid": "Mark as paid",
  "payments.sending": "Sending...",
  "payments.paymentMarkedAsPaid": "Payment marked as paid!",
  "payments.paymentBeingVerified": "Your payment is being verified by the administrator.",
  "payments.errorMarkingPaid": "Error marking as paid",
  "payments.tryAgainLater": "Please try again later.",
  "payments.uploadPdfOrImage": "Please upload a PDF or image (PNG/JPG).",
  "payments.fileTooLarge": "File is too large (max 10MB).",
  "payments.uploadBothFiles": "You must upload both files: transaction screenshot and ID.",
  "payments.stripeRedirect": "Stripe redirect",
  "payments.featureComingSoon": "This feature will be implemented soon.",
  "payments.receiveConfirmationSoon": "You will receive a confirmation soon.",
  "payments.unitInvoice": "Unit {{UNIT}} • Invoice #{{INVOICE_ID}}",

  // Announcements Page
  "announcements.title": "Announcements",
  "announcements.subtitle": "Community news and updates",
  "announcements.new": "New",
  "announcements.urgent": "Urgent",
  "announcements.general": "General",
  "announcements.maintenance": "Maintenance",
  "announcements.event": "Event",
  "announcements.noAnnouncements": "No announcements",
  "announcements.postedOn": "Posted on",
  "announcements.expiresOn": "Expires on",
  "announcements.readMore": "Read more",
  "announcements.viewAll": "View all",
  "announcements.markAsRead": "Mark as read",
  "announcements.createNew": "Create Announcement",
  "announcements.editAnnouncement": "Edit Announcement",
  "announcements.deleteAnnouncement": "Delete Announcement",
  "announcements.confirmDelete": "Are you sure you want to delete this announcement?",
  "announcements.draft": "Draft",
  "announcements.scheduled": "Scheduled",

  // Polls Page
  "polls.title": "Polls",
  "polls.subtitle": "Vote on community decisions",
  "polls.active": "Active",
  "polls.closed": "Closed",
  "polls.upcoming": "Upcoming",
  "polls.noPolls": "No polls available",
  "polls.vote": "Vote",
  "polls.viewResults": "View Results",
  "polls.votedOn": "You voted on",
  "polls.endsOn": "Ends on",
  "polls.endedOn": "Ended on",
  "polls.startsOn": "Starts on",
  "polls.totalVotes": "Total votes",
  "polls.yourVote": "Your vote",
  "polls.changeVote": "Change vote",
  "polls.submitVote": "Submit Vote",
  "polls.voteRecorded": "Your vote has been recorded",
  "polls.alreadyVoted": "You have already voted",
  "polls.createPoll": "Create Poll",
  "polls.editPoll": "Edit Poll",
  "polls.deletePoll": "Delete Poll",
  "polls.question": "Question",
  "polls.options": "Options",
  "polls.addOption": "Add Option",
  "polls.removeOption": "Remove Option",
  "polls.multipleChoice": "Allow multiple selections",
  "polls.anonymous": "Anonymous voting",
  "polls.results": "Results",
  "polls.participation": "Participation",

  // Issues Page
  "issues.title": "Issues",
  "issues.subtitle": "Report and track maintenance issues",
  "issues.reportIssue": "Report Issue",
  "issues.myIssues": "My Issues",
  "issues.allIssues": "All Issues",
  "issues.open": "Open",
  "issues.inProgress": "In Progress",
  "issues.resolved": "Resolved",
  "issues.closed": "Closed",
  "issues.noIssues": "No issues reported",
  "issues.issueTitle": "Issue Title",
  "issues.issueDescription": "Description",
  "issues.location": "Location",
  "issues.priority": "Priority",
  "issues.low": "Low",
  "issues.medium": "Medium",
  "issues.high": "High",
  "issues.critical": "Critical",
  "issues.attachPhotos": "Attach Photos",
  "issues.submitIssue": "Submit Issue",
  "issues.issueSubmitted": "Issue submitted successfully",
  "issues.statusUpdated": "Status updated",
  "issues.addComment": "Add Comment",
  "issues.comments": "Comments",
  "issues.timeline": "Timeline",
  "issues.createdOn": "Created on",
  "issues.updatedOn": "Updated on",
  "issues.assignedTo": "Assigned to",
  "issues.reportedBy": "Reported by",

  // Dashboard
  "dashboard.welcome": "Welcome",
  "dashboard.welcomeBack": "Welcome back",
  "dashboard.overview": "Overview",
  "dashboard.quickActions": "Quick Actions",
  "dashboard.recentActivity": "Recent Activity",
  "dashboard.pendingPayments": "Pending Payments",
  "dashboard.activePolls": "Active Polls",
  "dashboard.openIssues": "Open Issues",
  "dashboard.newAnnouncements": "New Announcements",
  "dashboard.viewAll": "View All",
  "dashboard.noActivity": "No recent activity",

  // Admin
  "admin.residents": "Residents",
  "admin.addResident": "Add Resident",
  "admin.editResident": "Edit Resident",
  "admin.deleteResident": "Delete Resident",
  "admin.inviteResident": "Invite Resident",
  "admin.residentDetails": "Resident Details",
  "admin.units": "Units",
  "admin.addUnit": "Add Unit",
  "admin.editUnit": "Edit Unit",
  "admin.deleteUnit": "Delete Unit",
  "admin.unitDetails": "Unit Details",
  "admin.unitNumber": "Unit Number",
  "admin.floor": "Floor",
  "admin.type": "Type",
  "admin.size": "Size",
  "admin.owner": "Owner",
  "admin.tenant": "Tenant",
  "admin.vacant": "Vacant",
  "admin.occupied": "Occupied",
  "admin.buildings": "Buildings",
  "admin.addBuilding": "Add Building",
  "admin.editBuilding": "Edit Building",
  "admin.deleteBuilding": "Delete Building",
  "admin.buildingDetails": "Building Details",
  "admin.totalUnits": "Total Units",
  "admin.occupiedUnits": "Occupied Units",
  "admin.vacantUnits": "Vacant Units",
  "admin.createInvoice": "Create Invoice",
  "admin.sendReminder": "Send Reminder",
  "admin.exportData": "Export Data",
  "admin.importData": "Import Data",
  "admin.bulkActions": "Bulk Actions",

  // HOA Buildings
  "hoa.buildings.title": "Building Management",
  "hoa.buildings.subtitle": "Manage buildings/condos, units, and residents in a hierarchical structure.",
  "hoa.buildings.searchPlaceholder": "Search by building name, code, city…",
  "hoa.buildings.importCsv": "Import CSV",
  "hoa.buildings.status.activeOnly": "Active Only",
  "hoa.buildings.status.inactiveOnly": "Inactive Only",
  "hoa.buildings.sort.nameAsc": "Name (A-Z)",
  "hoa.buildings.sort.nameDesc": "Name (Z-A)",
  "hoa.buildings.sort.codeAsc": "Code (A-Z)",
  "hoa.buildings.sort.codeDesc": "Code (Z-A)",
  "hoa.buildings.sort.cityAsc": "City (A-Z)",
  "hoa.buildings.sort.cityDesc": "City (Z-A)",
  "hoa.buildings.sort.unitsAsc": "Units (Low-High)",
  "hoa.buildings.sort.unitsDesc": "Units (High-Low)",
  "hoa.buildings.kpi.totalBuildings": "Total Buildings",
  "hoa.buildings.kpi.active": "Active",
  "hoa.buildings.kpi.inactive": "Inactive",
  "hoa.buildings.kpi.totalUnits": "Total Units",
  "hoa.buildings.kpi.totalResidents": "Total Residents",
  "hoa.buildings.emptyNone": "No buildings yet. Click \"Add Building\" to create your first one.",
  "hoa.buildings.emptyFiltered": "No matching buildings found.",
  "hoa.buildings.deleteTitle": "Delete Building?",
  "hoa.buildings.deleteDesc": "Are you sure you want to delete {name}? This action cannot be undone. All associated units and residents will also be affected.",
  "hoa.buildings.viewAria": "View {name}",
  "hoa.buildings.active": "Active",
  "hoa.buildings.inactive": "Inactive",
  "hoa.buildings.actions": "Building actions",
  "hoa.buildings.edit": "Edit building",
  "hoa.buildings.delete": "Delete building",
  "hoa.buildings.floors": "Floors",
  "hoa.buildings.occupancy": "Occupancy",
  "hoa.buildings.form.addTitle": "Add New Building",
  "hoa.buildings.form.editTitle": "Edit Building",
  "hoa.buildings.form.addDesc": "Enter the details for the new building.",
  "hoa.buildings.form.editDesc": "Update the building information below.",
  "hoa.buildings.form.basicInfo": "Basic Information",
  "hoa.buildings.form.code": "Code",
  "hoa.buildings.form.codePlaceholder": "BLDG-A",
  "hoa.buildings.form.namePlaceholder": "Building A - North Tower",
  "hoa.buildings.form.addressPlaceholder": "123 Main Street",
  "hoa.buildings.form.city": "City",
  "hoa.buildings.form.cityPlaceholder": "Miami",
  "hoa.buildings.form.state": "State",
  "hoa.buildings.form.statePlaceholder": "FL",
  "hoa.buildings.form.postalCode": "Postal Code",
  "hoa.buildings.form.postalCodePlaceholder": "33101",
  "hoa.buildings.form.country": "Country",
  "hoa.buildings.form.countryPlaceholder": "USA",
  "hoa.buildings.form.rifImageLabel": "RIF Document Image",
  "hoa.buildings.form.chooseFile": "Choose file...",
  "hoa.buildings.form.removeFile": "Remove",
  "hoa.buildings.form.viewCurrentRifImage": "View current RIF image",
  "hoa.buildings.form.specs": "Specifications",
  "hoa.buildings.form.totalUnits": "Total Units",
  "hoa.buildings.form.defaultFee": "Default Fee ($)",
  "hoa.buildings.form.additionalInfo": "Additional Information",
  "hoa.buildings.form.notesPlaceholder": "Any additional notes...",
  "hoa.buildings.form.activeStatus": "Active Status",
  "hoa.buildings.form.activeHint": "Inactive buildings won't appear in selections",
  "hoa.buildings.form.create": "Create Building",
  "hoa.buildings.errors.generic": "Something went wrong while saving the building. Please try again.",
  "hoa.buildings.errors.noPackage": "You cannot create buildings because your subscription is not active. Please update your plan in Settings or contact support.",
  "hoa.buildings.errors.limitReached": "You reached your current plan limit. Please upgrade your plan to continue creating buildings.",
  "hoa.buildings.errors.rifTooLarge": "The RIF file is too large. Maximum allowed size is {maxMb} MB.",
  "hoa.buildings.errors.rifInvalidType": "Invalid file format. Please upload an image file (JPG, PNG, WebP, etc.).",
  "hoa.buildings.errors.rifUploadFailed": "We could not upload the RIF document. Please verify the file and try again.",
  "hoa.buildings.errors.subscriptionBlockedTitle": "Building creation is unavailable",
  "hoa.buildings.errors.subscriptionBlocked": "Your current subscription status is {status}. Please update your subscription to create new buildings.",
  "hoa.buildings.errors.network": "We could not connect to the server. Please check your internet connection and try again.",
  "hoa.buildings.errors.timeout": "The request took too long. Please try again.",
  "hoa.buildings.errors.unauthorized": "Your session expired. Please sign in again and retry.",
  "hoa.buildings.errors.forbidden": "Your account cannot perform this action right now.",
  "hoa.buildings.errors.notFound": "The requested resource was not found. Please refresh and try again.",
  "hoa.buildings.errors.conflict": "This building could not be saved because of a conflict. Please review the data and retry.",
  "hoa.buildings.errors.validation": "Please review the form data and correct the highlighted fields.",
  "hoa.buildings.errors.rateLimited": "Too many attempts in a short time. Please wait a moment and try again.",
  "hoa.buildings.errors.server": "The server is temporarily unavailable. Please try again in a few minutes.",

  // Super Admin Dashboard
  "superAdmin.dashboard.greeting": "Hola, {name}!",
  "superAdmin.dashboard.platformConsole": "Consola de Plataforma",
  "superAdmin.dashboard.paymentsInbox.title": "Bandeja de Pagos",
  "superAdmin.dashboard.paymentsInbox.pending": "{count} pendientes",
  "superAdmin.dashboard.paymentsInbox.noPending": "No hay elementos pendientes",
  "superAdmin.dashboard.paymentsInbox.forwardedToday": "Enviados hoy",
  "superAdmin.dashboard.paymentsInbox.lastIncoming": "Ultimo recibido",
  "superAdmin.dashboard.paymentsInbox.quickJump": "Acceso rapido",
  "superAdmin.dashboard.paymentsInbox.openInbox": "Abrir Bandeja",
  "superAdmin.dashboard.actions.manage": "Gestionar",
  "superAdmin.dashboard.actions.view": "Ver",
  "superAdmin.dashboard.actions.open": "Abrir",
  "superAdmin.dashboard.actions.platform": "Plataforma",
  "superAdmin.dashboard.actions.hoaAdmins": "Admins de HOA",
  "superAdmin.dashboard.actions.payouts": "Pagos",
  "superAdmin.dashboard.actions.paymentsInbox": "Bandeja de Pagos",
  "superAdmin.dashboard.actions.settings": "Configuracion",
  "superAdmin.dashboard.approvals.title": "Aprobaciones Pendientes de Admin-HOA",
  "superAdmin.dashboard.approvals.pending": "{count} pendientes",
  "superAdmin.dashboard.approvals.updatedNow": "Actualizado justo ahora",
  "superAdmin.dashboard.approvals.approve": "Aprobar",
  "superAdmin.dashboard.approvals.reject": "Rechazar",
  "superAdmin.dashboard.approvals.noPending": "No hay aprobaciones pendientes.",
  "superAdmin.dashboard.payouts.title": "Pagos Recientes",
  "superAdmin.dashboard.payouts.last14Days": "Ultimos 14 dias",
  "superAdmin.dashboard.payouts.records": "{count} registros",
  "superAdmin.dashboard.payouts.noPayouts": "Sin pagos todavia.",
  "superAdmin.dashboard.payouts.viewAll": "Ver todos los pagos",
  "superAdmin.dashboard.platformNominal": "Todos los sistemas funcionando",
  "superAdmin.dashboard.systemNotes.title": "Notas del Sistema",
  "superAdmin.dashboard.systemNotes.viewAll": "Ver todo",

  // Super Admin Settings
  "superAdmin.settings.title": "Super Admin • Settings",
  "superAdmin.settings.subtitle": "Manage platform notifications, security, and app install.",
  "superAdmin.settings.paymentDetails.title": "Platform Payment Details",
  "superAdmin.settings.paymentDetails.desc": "Configure the bank, Zelle, and PayPal details shown to admins when they pay their subscription.",
  "superAdmin.settings.paymentDetails.generalInstructions": "General Payment Instructions",
  "superAdmin.settings.paymentDetails.generalInstructionsHint": "Optional note about available payment methods.",
  "superAdmin.settings.paymentDetails.generalInstructionsPlaceholder": "Ex: Please include your HOA name in the transfer note.",
  "superAdmin.settings.paymentDetails.bankNotes": "Additional Bank Notes",
  "superAdmin.settings.paymentDetails.bankNotesPlaceholder": "Ex: Include HOA name in memo",
  "superAdmin.settings.paymentDetails.zelleName": "Zelle Name",
  "superAdmin.settings.paymentDetails.zelleNamePlaceholder": "Ex: Urbe-360",
  "superAdmin.settings.paymentDetails.zellePhonePlaceholder": "Ex: +1 555 123 4567",
  "superAdmin.settings.paymentDetails.pagoMovilPhonePlaceholder": "Ex: +58 414 1234567",
  "superAdmin.settings.paymentDetails.lastUpdated": "Last updated:",
  "superAdmin.settings.notifications.title": "Notifications",
  "superAdmin.settings.notifications.desc": "Choose what you want to be notified about.",
  "superAdmin.settings.notifications.paymentsInbox": "Payments Inbox",
  "superAdmin.settings.notifications.paymentsInboxHint": "Get alerts when new resident payment proofs arrive for review.",
  "superAdmin.settings.notifications.hoaRequests": "HOA Requests",
  "superAdmin.settings.notifications.hoaRequestsHint": "Notify when HOAs request onboarding or require approval.",
  "superAdmin.settings.notifications.billingAlerts": "Billing Alerts",
  "superAdmin.settings.notifications.billingAlertsHint": "Platform subscription/Stripe-related alerts that need attention.",
  "superAdmin.settings.notifications.save": "Save Notifications",
  "superAdmin.settings.notifications.callout": "You can fine-tune alert routing per HOA later (e.g., send invoices to a finance email). For now this toggles global platform notifications for your super-admin account.",
  "superAdmin.settings.notifications.saved": "Notification settings saved.",
  "superAdmin.settings.security.desc": "Manage your password and sessions.",
  "superAdmin.settings.security.logoutAllDevices": "Logout all devices",
  "superAdmin.settings.security.passwordMismatch": "New password and confirmation do not match.",
  "superAdmin.settings.security.passwordChanged": "Password changed.",
  "superAdmin.settings.security.loggedOutAllDevices": "Logged out from all devices.",
  "superAdmin.settings.install.desc": "Install this PWA for a faster, app-like experience.",
  "superAdmin.settings.install.help": "Install help",
  "superAdmin.settings.install.callout": "If you don’t see the Install button, your browser may not support automatic prompts. Follow the steps below for your device.",
  "superAdmin.settings.install.iosTitle": "iPhone / iPad (Safari)",
  "superAdmin.settings.install.iosStep1": "Tap the Share icon in Safari.",
  "superAdmin.settings.install.iosStep2": "Choose Add to Home Screen.",
  "superAdmin.settings.install.iosStep3": "Tap Add.",
  "superAdmin.settings.install.androidTitle": "Android (Chrome)",
  "superAdmin.settings.install.androidStep1": "Tap the ⋮ menu in Chrome.",
  "superAdmin.settings.install.androidStep2": "Select Install app or Add to Home screen.",
  "superAdmin.settings.install.androidStep3": "Confirm to install.",
  "superAdmin.settings.install.desktopTitle": "Desktop (Chrome / Edge)",
  "superAdmin.settings.install.desktopStep1": "Look for the Install icon in the address bar, or",
  "superAdmin.settings.install.desktopStep2": "Open browser menu → Install app.",
  "superAdmin.settings.install.installApp": "Install app",
  "superAdmin.settings.install.installedOrUnsupported": "Installed / Not supported",
  "superAdmin.settings.install.install": "Install",
  "superAdmin.settings.install.alreadyInstalled": "App is already installed",
  "superAdmin.settings.install.notSupported": "Install not supported on this browser",

  // Not Found
  "notFound.title": "Page Not Found",
  "notFound.subtitle": "Sorry, the page you’re looking for doesn’t exist or has been moved.",
  "notFound.goHome": "Go Home",
  "notFound.goBack": "Go Back",

  // Activation
  "activation.title": "Activa tu cuenta",
  "activation.verify.subtitle": "Ingresa tus credenciales para comenzar",
  "activation.otp.subtitle": "Ingresa el codigo OTP enviado a tu correo",
  "activation.invitationCode": "Codigo de invitacion",
  "activation.emailPlaceholder": "tu@email.com",
  "activation.tempPassword": "Contrasena temporal",
  "activation.tempPasswordPlaceholder": "De tu correo de invitacion",
  "activation.tempPasswordHint": "Revisa tu correo para la contrasena temporal.",
  "activation.invitationExpired": "Esta invitacion ha expirado. Por favor contacta a tu administrador HOA.",
  "activation.invitationInvalid": "Invitacion invalida. Verifica tu codigo y correo.",
  "activation.otpInstructions": "Despues de hacer clic en \"Obtener OTP\", revisa tu correo para el codigo de 6 digitos.",
  "activation.sendingOtp": "Enviando OTP...",
  "activation.getOtp": "Obtener codigo OTP",
  "activation.otpSentTitle": "OTP enviado!",
  "activation.otpSentDesc": "Revisa tu correo en",
  "activation.enterOtp": "Ingresa el codigo OTP de 6 digitos",
  "activation.otpExpires": "El codigo expira en 10 minutos",
  "activation.verifying": "Verificando...",
  "activation.verifyLogin": "Verificar e iniciar sesion",
  "activation.resendOtp": "Reenviar codigo OTP",
  "activation.backToLogin": "Volver al inicio de sesion",
  "activation.needHelp": "Necesitas ayuda? Contacta a tu administrador HOA",

  // Password Change
  "passwordChange.title": "Cambia tu contrasena",
  "passwordChange.subtitle": "Por seguridad, debes cambiar tu contrasena temporal antes de continuar.",
  "passwordChange.requiredTitle": "Paso obligatorio:",
  "passwordChange.requiredDesc": "Este es tu primer inicio de sesion. Crea una contrasena segura para proteger tu cuenta.",
  "passwordChange.currentTempPassword": "Contrasena temporal actual",
  "passwordChange.tempPasswordPlaceholder": "Tu contrasena temporal",
  "passwordChange.newPasswordPlaceholder": "Crea una contrasena segura",
  "passwordChange.confirmPasswordPlaceholder": "Vuelve a escribir tu nueva contrasena",
  "passwordChange.requirementsTitle": "Requisitos de contrasena:",
  "passwordChange.requirementLength": "Al menos 8 caracteres",
  "passwordChange.requirementLetters": "Contiene letras",
  "passwordChange.requirementNumbers": "Contiene numeros",
  "passwordChange.requirementMatch": "Las contrasenas coinciden",
  "passwordChange.error.length": "La contrasena debe tener al menos 8 caracteres",
  "passwordChange.error.letters": "La contrasena debe contener letras",
  "passwordChange.error.numbers": "La contrasena debe contener numeros",
  "passwordChange.successTitle": "Exito!",
  "passwordChange.successDesc": "Tu contrasena ha sido cambiada. Redirigiendo...",
  "passwordChange.buttonLoading": "Cambiando contrasena...",
  "passwordChange.buttonSuccess": "Exito!",
  "passwordChange.buttonSubmit": "Cambiar contrasena",
  "passwordChange.help": "Elige una contrasena segura que no hayas usado antes.",

  // Clear Storage
  "clearStorage.title": "Storage Debug & Clear",
  "clearStorage.checkStorage": "Check Current Storage",
  "clearStorage.clearAll": "Clear ALL Storage",
  "clearStorage.goToLogin": "Go to Login Page",
  "clearStorage.cleared": "✅ All storage cleared!",
  "clearStorage.contentsTitle": "Storage Contents:",
  "clearStorage.instructionsTitle": "📝 Instructions:",
  "clearStorage.instructions.check": "Click \"Check Current Storage\" to see what's stored",
  "clearStorage.instructions.clear": "Click \"Clear ALL Storage\" to remove everything",
  "clearStorage.instructions.goToLogin": "Click \"Go to Login Page\" to navigate to login",
  "clearStorage.sessionStorageHeader": "=== SessionStorage ===",
  "clearStorage.localStorageHeader": "=== LocalStorage ===",

  // Registration
  "register.error.requiredFields": "Please fill in all required fields",
  "register.error.passwordRequirements": "Please ensure your password meets all requirements",
  "register.error.sendOtp": "Failed to send OTP. Please try again.",
  "register.error.enterOtp": "Please enter the 6-digit code",
  "register.error.createAccount": "Failed to create account. Please try again.",
  "register.error.invalidOtp": "Invalid OTP code. Please try again.",
  "register.error.resendOtp": "Failed to resend OTP. Please try again.",
  "register.success.title": "Registration Successful!",
  "register.success.subtitle": "Your HOA Admin account has been created. You can now sign in to manage your condo.",
  "register.success.continue": "Continue to Sign In",
  "register.otp.title": "Verify Your Email",
  "register.otp.sentTo": "We've sent a 6-digit code to",
  "register.otp.enterCode": "Enter OTP Code",
  "register.otp.verifying": "Verifying...",
  "register.otp.verifyCreate": "Verify & Create Account",
  "register.otp.sending": "Sending...",
  "register.otp.resend": "Resend OTP",
  "register.otp.back": "Back to Registration",
  "register.details.title": "Create HOA Admin Account",
  "register.details.subtitle": "Register your condo association and start managing your community",
  "register.firstName": "First Name",
  "register.firstNamePlaceholder": "John",
  "register.lastName": "Last Name",
  "register.lastNamePlaceholder": "Doe",
  "register.condoName": "Condo/Association Name",
  "register.condoNamePlaceholder": "Sunset Towers HOA",
  "register.details.sendingCode": "Sending verification code...",

  // Resident Setup
  "resident.setup.loadingProfile": "Cargando tu perfil...",
  "resident.setup.title": "Completa tu perfil",
  "resident.setup.subtitle": "Configura tu cuenta para acceder a todas las funciones de residentes",
  "resident.setup.emailLabel": "Correo:",
  "resident.setup.emailHint": "Tu correo no se puede cambiar. Contacta a tu HOA si esto es incorrecto.",
  "resident.setup.fullNamePlaceholder": "Juan Perez",
  "resident.setup.phonePlaceholder": "+58 (212) 555-1234",
  "resident.setup.preferredLanguage": "Idioma preferido",
  "resident.setup.setPasswordTitle": "Configura tu contrasena",
  "resident.setup.passwordPlaceholder": "Al menos 8 caracteres",
  "resident.setup.confirmPasswordPlaceholder": "Vuelve a escribir tu contrasena",
  "resident.setup.passwordRuleLength": "La contrasena debe tener al menos 8 caracteres",
  "resident.setup.passwordRuleStrong": "Usa una contrasena fuerte y unica",
  "resident.setup.completing": "Completando configuracion...",
  "resident.setup.complete": "Completar configuracion",
  "resident.setup.terms": "Al completar la configuracion, aceptas nuestros Terminos de servicio y Politica de privacidad",
  "resident.setup.profileLoadFailed": "No se pudo cargar el perfil. Por favor inicia sesion de nuevo.",
  "resident.setup.fullNameRequired": "El nombre completo es obligatorio",
  "resident.setup.passwordRequired": "La contrasena es obligatoria",
  "resident.setup.passwordLength": "La contrasena debe tener al menos 8 caracteres",
  "resident.setup.completeTitle": "Configuracion completada!",
  "resident.setup.completeDesc": "Tu cuenta ya esta lista para usarse.",
  "resident.setup.failed": "No se pudo completar la configuracion. Intenta de nuevo.",
  "resident.setup.failedTitle": "La configuracion fallo",

  // Resident OTP
  "resident.otp.enterCodeError": "Por favor ingresa el codigo OTP",
  "resident.otp.loginFailed": "Inicio de sesion fallido. Verifica tu codigo OTP.",
  "resident.otp.requiredTitle": "Se requiere verificacion OTP",
  "resident.otp.noEmailTitle": "No se proporciono una direccion de correo.",
  "resident.otp.noEmailDesc": "Usa el enlace enviado a tu correo por tu administrador HOA o contactalo para recibir un nuevo codigo OTP.",
  "resident.otp.title": "Verificar codigo OTP",
  "resident.otp.sentTo": "Codigo OTP enviado a:",
  "resident.otp.subtitle": "Ingresa el codigo OTP de 6 digitos de tu correo para verificar tu identidad.",
  "resident.otp.enterCode": "Ingresar codigo OTP",
  "resident.otp.placeholder": "123456",
  "resident.otp.checkEmail": "Revisa tu bandeja de entrada y la carpeta de spam",
  "resident.otp.noCode": "No recibiste el codigo?",
  "resident.otp.contactHoa": "Contacta a tu administrador HOA",
  "resident.otp.didntReceive": "Didn't receive the code?",
  "resident.otp.resendCode": "Resend code",
  "resident.otp.resendIn": "Resend in",
  "resident.otp.cooldownError": "Please wait before requesting another code.",
  "auth.codeSent": "Code sent.",

  // Resident Dashboard
  "resident.dashboard.greeting": "Hello, {name}!",
  "resident.dashboard.residentFallback": "Resident",
  "resident.dashboard.unitStatus": "Unit {unit} • Everything is up to date",
  "resident.dashboard.paymentStatus": "Payment Status",
  "resident.dashboard.upToDate": "Up to date",
  "resident.dashboard.lastPaymentMade": "Last payment made",
  "resident.dashboard.action.report": "Report",
  "resident.dashboard.action.issue": "Issue",
  "resident.dashboard.action.view": "View",
  "resident.dashboard.action.payments": "Payments",
  "resident.dashboard.latestAnnouncement": "Latest Announcement",
  "resident.dashboard.announcementSummary": "Elevator maintenance scheduled",
  "resident.dashboard.latestPoll": "Latest Poll",
  "resident.dashboard.pollCloses": "Closes:",
  "resident.dashboard.voteCount": "{count} votes",
  "resident.dashboard.goToPolls": "Go to Polls",
  "resident.dashboard.voteNow": "Vote now",
  "resident.dashboard.pollTitle": "Should we extend pool hours to 11 PM?",
  "resident.dashboard.comingSoon": "Coming Soon",
  "resident.dashboard.pollsComingSoonDescription": "Voting and polls feature is coming in a future update.",
  "resident.dashboard.inDevelopment": "In Development",
  "resident.dashboard.pendingInvitationTitle": "Pending Invitation",
  "resident.dashboard.pendingAccept": "Accept Invitation",
  "resident.dashboard.pendingAcceptError": "Could not start the acceptance process. Please try again.",
  "resident.dashboard.overdue": "Overdue",
  "resident.dashboard.underReview": "Under Review",
  "resident.dashboard.paymentDue": "Payment Due",
  "resident.dashboard.nextPaymentDue": "Next payment due",
  "resident.dashboard.noPayments": "No pending payments",
  "resident.dashboard.switchUnit": "Switch unit",

  // Resident property selection
  "resident.selectProperty.title": "Select a Property",
  "resident.selectProperty.subtitle": "Choose which unit or HOA you want to access. Your session will be limited to the property you select.",
  "resident.selectProperty.loading": "Loading available properties…",
  "resident.selectProperty.noProperties": "No active properties are available for this account.",
  "resident.selectProperty.propertyFallback": "Property",
  "resident.selectProperty.unit": "Unit",
  "resident.selectProperty.primaryContact": "Primary contact",
  "resident.selectProperty.enter": "Enter",
  "resident.selectProperty.opening": "Opening…",
  "resident.selectProperty.backToPortal": "Back to resident portal",
  "resident.selectProperty.loadError": "Unable to load properties. Please try again.",
  "resident.selectProperty.enterError": "Unable to enter the selected property. Please try again.",

  // Announcements (Resident)
  "announcements.activeTitle": "Active Announcements",
  "announcements.count": "{count} announcement(s)",
  "announcements.filterPriority": "Filter by Priority",
  "announcements.filterAll": "All Priorities",
  "announcements.loading": "Loading announcements...",
  "announcements.pinned": "Pinned",
  "announcements.priorityLabel": "Priority",
  "announcements.published": "Published",
  "announcements.author": "Author",
  "announcements.message": "Message",
  "announcements.noneMatch": "No announcements match your filter.",
  "announcements.postedBy": "Posted by {name}",
  "announcements.priority.urgent": "Urgent",
  "announcements.priority.high": "High",
  "announcements.priority.medium": "Medium",
  "announcements.priority.low": "Low",

  // Polls (Resident)
  "polls.communityTitle": "Community Polls",
  "polls.activeCount": "{count} active poll(s)",
  "polls.howToVoteTitle": "How to vote:",
  "polls.howToVote.step1": "Click on a poll card to view details and vote",
  "polls.howToVote.step2": "Select your choice(s) and submit",
  "polls.howToVote.step3": "You can only vote once per poll",
  "polls.howToVote.step4": "Results are shown after you vote or when the poll closes",
  "polls.loading": "Loading polls...",
  "polls.noneActive": "No active polls at this time",
  "polls.status.voted": "Voted",
  "polls.status.closingSoon": "Closing Soon",
  "polls.status.active": "Active",
  "polls.status.closed": "Closed",
  "polls.voteCount": "{count} vote(s)",
  "polls.ends": "Ends",
  "polls.noEndDate": "No end date",
  "polls.voteNow": "Vote Now",
  "polls.voteThanks": "Thank you for participating!",
  "polls.noOptionTitle": "No option selected",
  "polls.noOptionDesc": "Please select at least one option to vote.",
  "polls.voteFailed": "Vote failed",
  "polls.submitFailed": "Failed to submit vote",
  "polls.loadingPoll": "Loading poll...",
  "polls.alreadyVotedTitle": "Already Voted",
  "polls.alreadyVotedDesc": "You have already voted on this poll",
  "polls.alreadyVotedNote": "You can only vote once per poll. Thank you for participating!",
  "polls.castVoteTitle": "Cast Your Vote",
  "polls.multipleOptions": "You can select multiple options",
  "polls.singleOption": "You can only select one option",
  "polls.submitting": "Submitting...",
  "polls.loadingResults": "Loading results...",
  "polls.resultsTitle": "Poll Results",
  "polls.voteSummary": "{total} vote(s) from {voters} voter(s)",
  "polls.ended": "Ended",
  "polls.inHours": "in {count}h",
  "polls.inDays": "in {count}d",

  // Issues (Resident)
  "issues.timeFrame": "Time frame",
  "issues.selectRange": "Select a range",
  "issues.range.week": "Last 1 week",
  "issues.range.month": "Last 1 month",
  "issues.range.quarter": "Last 3 months",
  "issues.range.all": "All time",
  "issues.allStatuses": "All statuses",
  "issues.pending": "Pending",
  "issues.noneMatch": "No issues match your filters.",
  "issues.count": "Showing {count} issue(s)",
  "issues.viewDetails": "View details",
  "issues.reported": "Reported",
  "issues.reporter": "Reporter",
  "issues.assignee": "Assignee",
  "issues.issue": "Issue",
  "issues.detailsSubtitle": "Full details for this report.",
  "issues.reportMeta": "{name} • {role} • {unit}",
  "issues.titlePlaceholder": "Brief description of the issue…",
  "issues.detailDescription": "Detailed Description",
  "issues.detailPlaceholder": "Please provide detailed information about the issue…",
  "issues.category": "Category",
  "issues.selectCategory": "Select category",
  "issues.categoryGeneral": "General",
  "issues.categoryPlumbing": "Plumbing",
  "issues.categoryElectrical": "Electrical",
  "issues.categoryHvac": "HVAC",
  "issues.categoryCommonArea": "Common Area",
  "issues.selectPriority": "Select priority",
  "issues.photosOptional": "Photos (Optional)",
  "issues.clickToUpload": "Click to upload photos",
  "issues.uploadHint": "PNG, JPG or PDF up to 10MB",
  "issues.uploadError": "Please upload PNG/JPG/PDF up to 10MB.",
  "issues.reportSubmitted": "Issue submitted. We’ll keep you posted!",
  "issues.reportCancelled": "Report cancelled.",

  "issues.status.PENDING": "Pending",
  "issues.status.IN_PROGRESS": "In Progress",
  "issues.status.RESOLVED": "Resolved",
  "issues.status.CANCELLED": "Cancelled",
  "issues.priority.LOW": "Low",
  "issues.priority.MEDIUM": "Medium",
  "issues.priority.HIGH": "High",
  "issues.priority.URGENT": "Urgent",

  "issues.description": "Description",
  "issues.commonArea": "Common area",
  "issues.aSpecificUnit": "A specific unit",
  "issues.commonAreaExplainer":
    "Everyone in this building will see this report and be notified once.",
  "issues.searchUnitOrResident": "Search by unit or resident name",
  "issues.noUnitMatches": "No unit or resident matches that.",
  "issues.noUnitsInBuilding": "This building has no units yet.",
  "issues.noResidents": "No residents on file",
  "issues.willNotify": "Will notify",
  "issues.pickAUnit": "Choose which unit this is about.",
  "issues.building": "Building",
  "issues.allBuildings": "All buildings",
  "issues.unassigned": "Unassigned",
  "issues.attachments": "Attachments",
  "issues.attachmentHint": "Up to 5 files — PNG, JPG, WEBP or PDF, 10MB each",
  "issues.attachmentCount": "{count} attachment(s)",
  "issues.commentCount": "{count} comment(s)",
  "issues.tooManyFiles": "You can attach at most 5 files.",
  "issues.badFileType": "Only PNG, JPG, WEBP or PDF files are allowed.",
  "issues.fileTooLarge": "Each file must be smaller than 10MB.",
  "issues.noComments": "No comments yet.",
  "issues.commentPlaceholder": "Write a comment…",
  "issues.internalNote": "Internal note",
  "issues.internalOnly": "Internal note (admins only)",
  "issues.timelineReported": "Reported",
  "issues.timelineChanged": "{from} → {to}",
  "issues.loadError": "Could not load issues. Please try again.",
  "issues.summaryLine": "{open} open · {resolved} resolved",
  "issues.emptyHint": "Nothing to show for this period. Report a problem and you can follow it here.",
  "issues.descriptionHint": "Where it is, when it started, anything you have already tried.",
  "issues.pagination": "Pages",
  "issues.previousPage": "Previous page",
  "issues.nextPage": "Next page",
  "issues.showingRange": "{first}–{last} of {count}",
  "issues.newCategory": "New",
  "issues.newCategoryPlaceholder": "E.g. Roof leaks, Parking, Pool",
  "issues.addCategory": "Add category",

  // BCV rate history
  "nav.rates": "Rates",
  "hoa.payments.tabs.rates": "BCV rates",
  "hoa.payments.waiting.nobody": "Not sent yet",
  "hoa.payments.waiting.resident": "Waiting on the resident",
  "hoa.payments.waiting.you": "Needs your review",
  "hoa.payments.waiting.platform": "With the platform",
  "hoa.payments.waiting.settled": "Settled",
  "hoa.payments.overdue": "Overdue",
  "hoa.payments.overdueDays": "{days}d overdue",
  "hoa.payments.kpi.overdue": "Overdue",
  "hoa.payments.kpi.overdueSub": "past the due date",
  "hoa.payments.moreActions": "More actions",
  "hoa.payments.kpi.needsReview": "proof(s) to check",
  "hoa.payments.kpi.rateShort": "{rate}% collected",
  "hoa.payments.noResultsFiltered": "Nothing matches this period and status. Clear the filters to see everything.",
  "rates.title": "BCV exchange rate",
  "rates.subtitle": "The official rate for every day, and how each day's figure was arrived at.",
  "rates.previousMonth": "Previous month",
  "rates.nextMonth": "Next month",
  "rates.jumpToMonth": "Jump to a month",
  "rates.day": "Day",
  "rates.rate": "Bs. / USD",
  "rates.change": "Change",
  "rates.source": "Source",
  "rates.published": "Published",
  "rates.carried": "Carried forward",
  "rates.longestGap": "Longest gap",
  "rates.uncovered": "No data",
  "rates.reason.published": "Published by BCV",
  "rates.reason.weekend": "Weekend",
  "rates.reason.noPublication": "No publication",
  "rates.reason.beforeCoverage": "Before our records",
  "rates.carriedFrom": "from {date} · {days} day(s)",
  "rates.gapWarning": "{days} banking days in a row with no publication. One or two is a public holiday; a run this long usually means the daily fetch stopped.",
  "rates.staleWarning": "Today is using a rate carried forward {days} days. Check that the daily fetch is still running.",
  "rates.loadError": "Could not load the rate history. Please try again.",
  "rates.footnote": "BCV publishes on banking days only, each afternoon for the next banking day. On weekends and public holidays nothing is published, so the last published rate stays in force — that is what \"carried forward\" means. A non-weekend day with no publication is shown as such rather than assumed to be a holiday, because a stopped fetch looks identical.",
  "rates.viewInHistory": "See this day",
  "rates.emptyMonth": "No rates for this month",
  "rates.coverageStarts": "Our records begin on {date}.",
  "rates.noDataYet": "No BCV rates have been recorded yet.",
  "rates.jumpToFirst": "Go to the first month",
  "issues.ageToday": "today",
  "issues.ageOneDay": "1 day ago",
  "issues.ageDays": "{days} days ago",
  "issues.lastUpdated": "Last updated {when}",
  "issues.attachmentTotal": "{count} file(s) · {size}",
  "issues.previousImage": "Previous image",
  "issues.nextImage": "Next image",
  "issues.openOriginal": "Open the original",

  // Payments
  "payments.zelleCash": "Zelle Cash",
  "payments.stripeCheckout": "Stripe Checkout",
  "payments.paymentInstructions": "Payment Instructions",
  "payments.sendPaymentToAccount": "Send your payment to this account",

  // Validation messages
  "validation.required": "This field is required",
  "validation.email": "Please enter a valid email address",
  "validation.minLength": "Must be at least {min} characters",
  "validation.maxLength": "Must be at most {max} characters",
  "validation.passwordMatch": "Passwords do not match",
  "validation.invalidPhone": "Please enter a valid phone number",
  "validation.invalidAmount": "Please enter a valid amount",
  "validation.selectOption": "Please select an option",
  "validation.uploadFile": "Please upload a file",
  "validation.fileTooLarge": "File size must be less than {size}MB",
  "validation.invalidFileType": "Invalid file type. Allowed: {types}",

  // Error messages
  "error.generic": "Something went wrong. Please try again.",
  "error.network": "Network error. Please check your connection.",
  "error.notFound": "The requested resource was not found.",
  "error.unauthorized": "You are not authorized to perform this action.",
  "error.forbidden": "Access denied.",
  "error.serverError": "Server error. Please try again later.",
  "error.timeout": "Request timed out. Please try again.",
  "error.invalidData": "Invalid data provided.",

  // Success messages
  "success.saved": "Changes saved successfully",
  "success.created": "Created successfully",
  "success.updated": "Updated successfully",
  "success.deleted": "Deleted successfully",
  "success.sent": "Sent successfully",
  "success.uploaded": "Uploaded successfully",

  // Date/Time
  "date.today": "Today",
  "date.yesterday": "Yesterday",
  "date.tomorrow": "Tomorrow",
  "date.thisWeek": "This week",
  "date.lastWeek": "Last week",
  "date.thisMonth": "This month",
  "date.lastMonth": "Last month",
  "date.daysAgo": "{count} days ago",
  "date.hoursAgo": "{count} hours ago",
  "date.minutesAgo": "{count} minutes ago",
  "date.justNow": "Just now",

  // Commission Breakdown
  "commission.title": "Payment Breakdown",
  "commission.totalAmount": "Total Invoice Amount",
  "commission.platformFee": "Platform Fee (10%)",
  "commission.paid": "Paid",
  "commission.netToHoa": "Net to HOA Admin",
  "commission.pendingTransfer": "Payment received by platform. Pending transfer to HOA admin.",
  "commission.completedCycle": "Full payment cycle complete. HOA admin has received funds.",

  // Payment Details Card
  "payment.details.notAvailable": "{title} payment details not available",
  "payment.details.verified": "Account verified",
  // This badge reads PaymentDetails.is_verified, which is a property of the
  // BANK ACCOUNT, not of any payment. Labelled just "Unverified" beside a
  // settled payment it was read as the payment being unverified.
  "payment.details.unverified": "Account not verified",
  "payment.details.accountEmail": "Account Email",
  "payment.details.bankTransfer": "Bank Transfer",
  "payment.details.account": "Account: {number}",
  "payment.details.routing": "Routing: {number}",
  "payment.details.zelle": "Zelle",
  "payment.details.zellePhone": "Zelle Phone",
  "payment.details.paypal": "PayPal",
  "payment.details.venmo": "Venmo",
  "payment.details.cashapp": "Cash App",
  "payment.details.noMethods": "No payment methods configured",

  // Bulk Import Modal
  "import.title": "Bulk Import {type}",
  "import.description": "Upload a CSV file to import multiple {type} at once. You'll see a quick preview before importing.",
  "import.instructions": "Instructions:",
  "import.step1": "Download the CSV template below",
  "import.step2": "Fill in your {type} data",
  "import.step3": "Upload the completed CSV file",
  "import.step4": "Review the preview, then click Import",
  "import.template": "{type} Template",
  "import.entity.buildings": "Buildings",
  "import.entity.units": "Units",
  "import.entity.residents": "Residents",
  "import.csvFormat": "CSV format",
  "import.downloading": "Downloading...",
  "import.download": "Download",
  "import.uploadLabel": "Upload CSV File",
  "import.chooseFile": "Choose a CSV file",
  "import.clickToBrowse": "Click to browse",
  "import.importing": "Importing...",
  "import.processingCsv": "Processing your CSV file",
  "import.readingPreview": "Reading CSV preview\u2026",
  "import.showing": "Showing first {count} of {total} rows",
  "import.columns": "{count} columns",
  "import.success": "Success! Imported {count} {type} successfully.",
  "import.partialFailed": "Partial/Failed Import: Imported {success} out of {total} {type}. {errors} error(s) found.",
  "import.errorDetails": "Error details",
  "import.downloadErrorCsv": "Download error CSV",
  "import.rowHeader": "Row",
  "import.errorsHeader": "Error(s)",
  "import.rowData": "Row data",
  "import.noData": "No data",
  "import.importBtn": "Import {type}",
  "import.reviewAndConfirm": "Review & Confirm",
  "import.invalidFile": "Please select a CSV file",
  "import.missingColumns": "Missing required columns: {columns}. Download the template for the correct format.",
  "import.failed": "Import failed. Please review the file and try again.",
  "import.parseFailed": "Could not read the CSV file. Please verify the format and try again.",
  "import.invalidEncoding": "The CSV file must use UTF-8 encoding.",
  "import.fileTooLarge": "The CSV file is too large. Maximum size is {maxMb} MB.",
  "import.rateLimited": "Too many import attempts. Please wait a moment and try again.",
  "import.validRows": "Valid rows",
  "import.invalidRows": "Invalid rows",
  "import.willCreate": "Will create",
  "import.selectAllValid": "Select all valid",
  "import.clearSelection": "Clear selection",
  "import.noCreateUntilConfirm": "No records are created during preview. Records are created only after you confirm import.",
  "import.statusWillCreate": "Will create",
  "import.statusSkipped": "Skipped",
  "import.statusInvalid": "Invalid",
  "import.confirmPrompt": "You are about to create {count} record(s). Confirm to continue.",
  "import.noRowsSelected": "Select at least one valid row to import.",
  "import.duplicateInFile": "Duplicate in file",
  "import.duplicateExisting": "Already exists",

  // Bulk Invite Modal
  "invite.title": "Send Bulk Invitations",
  "invite.description": "Send account activation invitations to selected residents via email.",
  "invite.howItWorks": "How it works:",
  "invite.step1": "Each resident receives an email with a secure claim link",
  "invite.step2": "They open the link and request a one-time access code",
  "invite.step3": "Enter the code to confirm the membership",
  "invite.step4": "Set their password and access the portal",
  "invite.selectedResidents": "Selected Residents ({count})",
  "invite.customMessage": "Custom Message (Optional)",
  "invite.messagePlaceholder": "Add a personal message to the invitation email...",
  "invite.messageHint": "This message will be included in the invitation email.",
  "invite.expiryLabel": "Invitation Expires After",
  "invite.days": "days",
  "invite.expiryHint": "Invitations will expire after {count} day(s). Valid range: 1-30 days.",
  "invite.success": "Success! Sent {count} invitation(s) successfully.",
  "invite.someFailed": "Some invitations failed:",
  "invite.sentList": "Invitations Sent:",
  "invite.expires": "Expires: {date}",
  "invite.sending": "Sending...",
  "invite.sendBtn": "Send {count} Invitation(s)",

  // Bulk OTP Modal
  "otp.send.title": "Send OTP to Residents",
  "otp.send.subtitle": "Send one-time passwords to {count} resident(s)",
  "otp.send.selectedResidents": "Selected Residents:",
  "otp.send.unit": "Unit {code}",
  "otp.send.whatNext": "\uD83D\uDCE7 What happens next?",
  "otp.send.infoStep1": "Each resident will receive a 6-digit OTP via email",
  "otp.send.infoStep2": "OTP codes are valid for 24 hours",
  "otp.send.infoStep3": "Residents can use the OTP for authentication",
  "otp.send.failed": "\u274C Failed to send OTP",
  "otp.send.sending": "Sending OTP codes...",
  "otp.send.sendingWait": "Please wait while we send emails to all selected residents",
  "otp.send.successTitle": "OTP Sent Successfully!",
  "otp.send.successDesc": "Sent to {success} out of {total} residents",
  "otp.send.deliveryStatus": "Delivery Status:",
  "otp.send.failedCount": "\u26A0\uFE0F {count} email(s) failed to send",
  "otp.send.failedHint": "Please check email addresses and try again later",
  "otp.send.sendBtn": "Send OTP",
  "otp.send.pendingSending": "Sending...",

  // Reports
  "reports.title": "Reports & Analytics",
  "reports.subtitle": "Choose a period and export summaries for your board.",
  "reports.period.current_month": "Current Month",
  "reports.period.last_month": "Last Month",
  "reports.period.3months": "Last 3 Months",
  "reports.period.6months": "Last 6 Months",
  "reports.period.year": "This Year",
  "reports.exportReport": "Export Report",
  "reports.export": "Export",
  "reports.financial.title": "Financial Summary",
  "reports.financial.totalRevenue": "Total Revenue",
  "reports.financial.collected": "Collected",
  "reports.financial.pending": "Pending",
  "reports.financial.collectionRate": "Collection Rate",
  "reports.financial.trendChart": "Monthly Collection Trend",
  "reports.financial.trendChartDesc": "Revenue collected vs pending over time",
  "reports.financial.statusChart": "Collection Breakdown",
  "reports.financial.statusChartDesc": "Revenue breakdown by collection status for this period",
  "reports.financial.overdue": "Overdue",
  "reports.financial.invoiceCount": "Invoices",
  "reports.financial.noData": "No invoice data for this period",
  "reports.occupancy.title": "Occupancy Report",
  "reports.occupancy.totalUnits": "Total Units",
  "reports.occupancy.occupied": "Occupied",
  "reports.occupancy.vacant": "Vacant",
  "reports.occupancy.rate": "Occupancy Rate",
  "reports.maintenance.title": "Maintenance Report",
  "reports.maintenance.totalIssues": "Total Issues",
  "reports.maintenance.resolved": "Resolved",
  "reports.maintenance.pending": "Pending",
  "reports.maintenance.rate": "Resolution Rate",
  "reports.maintenance.byCategory": "Issues by Category",
  "reports.maintenance.issueCount": "{count} issues",
  "reports.action.monthly.title": "Monthly Report",
  "reports.action.monthly.desc": "Receive a full CSV with every invoice record, resident details, payment status, and BCV rates.",
  "reports.action.monthly.cta": "Generate",
  "reports.action.resident.title": "Resident Report",
  "reports.action.resident.desc": "Detailed per-resident breakdown with all payment activity for the selected period.",
  "reports.action.resident.cta": "Export",
  "reports.action.custom.title": "Custom Report",
  "reports.action.custom.desc": "Create custom date range report",
  "reports.action.custom.cta": "Create",
  "reports.comingSoon": "Open custom report builder (coming soon)",

  // Units
  "units.importCSV": "Import CSV",
  "units.stat.total": "Total",
  "units.stat.paid": "Paid",
  "units.stat.pending": "Pending",
  "units.stat.occupied": "Occupied",
  "units.stat.vacant": "Vacant",
  "units.stat.inactive": "Inactive",
  "units.search.placeholder": "Search unit or resident…",
  "units.filter.all": "All",
  "units.filter.paid": "Paid",
  "units.filter.pending": "Pending",
  "units.filter.vacant": "Vacant",
  "units.filter.occupied": "Occupied",
  "units.filter.inactive": "Inactive",
  "units.empty": "No matching units.",
  "units.unit": "Unit {number}",
  "units.perMonth": "${amount}/month",
  "units.unassigned": "Unassigned",
  "units.displayNumber": "Ref: {number}",
  "units.floor": "Floor {floor}",
  "units.residentCount": "{count} resident(s)",
  "units.status.paid": "Paid",
  "units.status.pending": "Pending",
  "units.status.vacant": "Vacant",
  "units.status.occupied": "Occupied",
  "units.status.inactive": "Inactive",
  "units.viewPayment": "View Payment",
  "units.add": "Add unit",
  "units.drawer.title": "Payments — Unit {number}",
  "units.drawer.vacant": "Vacant",
  "units.drawer.noInvoices": "No invoices for this unit.",
  "units.drawer.issued": "Issued {issued} • Due {due}",
  "units.invoice.status.sent": "Sent",
  "units.invoice.status.cancelled": "Cancelled",
  "units.modal.newUnit": "New Unit",
  "units.modal.editUnit": "Edit Unit",
  "units.modal.unitNumber": "Unit number",
  "units.modal.unitCode": "Unit Code",
  "units.modal.floor": "Floor (optional)",
  "units.modal.displayNumber": "Display Number",
  "units.modal.monthlyFee": "Monthly Fee",
  "units.modal.status": "Status",
  "units.modal.rent": "Monthly rent",
  "units.modal.residentSection": "Resident (optional)",
  "units.modal.name": "Name",
  "units.modal.createUnit": "Create unit",
  "units.confirm.deleteTitle": "Delete unit",
  "units.confirm.deleteMessage": "Are you sure you want to delete Unit {number}? This cannot be undone.",
  "units.errors.noPackage": "You cannot create or edit units because your subscription is not active. Please update your plan in Settings or contact support.",
  "units.errors.limitReached": "You reached your current unit limit. Please upgrade your plan to create more units.",
  "units.errors.validation": "Please review unit data and correct the highlighted fields.",
  "units.errors.rateLimited": "Too many attempts in a short time. Please wait a moment and try again.",

  // Venezuela compliance
  "residents.cedula": "Cédula",
  "residents.cedulaPlaceholder": "V-12345678 or E-12345678",
  "buildings.rif": "RIF",
  "buildings.rifPlaceholder": "J-12345678-9",
  "invoice.download": "Download PDF",
  "invoice.downloadReceipt": "Download Receipt",
  "invoice.downloadError": "Failed to download document",
  "invoice.sendReminder": "Send Reminder",
  "invoice.reminderSent": "Overdue reminder sent successfully",
  "invoice.reminderFailed": "Failed to send reminder",
  "invoice.notifications": "Notification Log",
  "invoice.notifSent": "Invoice Sent",
  "invoice.notifFailed": "Send Failed",
  "invoice.notifMocked": "SMS (mock)",

  // Payments - KPI Cards
  "hoa.payments.kpi.expected": "Expected (this month)",
  "hoa.payments.kpi.showAll": "Tap to clear filters",
  "hoa.payments.details.section.invoice": "Invoice details",
  "hoa.payments.form.section.recipients": "Who gets an invoice",
  "hoa.payments.form.amountSourceLabel": "Charge each resident",
  "hoa.payments.bulk.projectedTotal": "Total {total}",
  "hoa.payments.form.createSubtitle": "One invoice for one unit.",
  "hoa.payments.form.section.who": "Who it is for",
  "hoa.payments.form.section.amount": "Amount and dates",
  "hoa.payments.form.unitOrResident": "Unit or resident",
  "hoa.payments.form.pickBuildingFirst": "Choose a building to see its units.",
  "hoa.payments.form.pickOneHint": "Search by unit number or by the resident's name.",
  "hoa.payments.form.noUnitsInBuilding": "This building has no units yet.",
  "hoa.payments.form.noMatches": "No unit or resident matches that.",
  "hoa.payments.form.vacantUnit": "No residents on file",
  "hoa.payments.form.methodUnset": "Not specified",
  "hoa.payments.reminderModal.title": "Send overdue reminders",
  "hoa.payments.reminderModal.subtitle": "Choose who to remind. Everyone overdue is selected.",
  "hoa.payments.reminderModal.selectAll": "Select all",
  "hoa.payments.reminderModal.chosen": "{count} of {total}",
  "hoa.payments.reminderModal.send": "Send {count}",
  "hoa.payments.reminderModal.noneTitle": "Nothing is overdue",
  "hoa.payments.reminderModal.noneHint": "Every invoice is either paid, not yet due, or already being processed.",
  "hoa.payments.reminderModal.loadFailed": "Could not load the list. Close and try again.",
  "hoa.payments.reminderModal.footnote": "Residents already paying are left out automatically, even if their invoice still reads unpaid.",
  "hoa.payments.kpi.incoming": "Waiting on you",
  "hoa.payments.kpi.incomingSub": "Confirm the money arrived",
  "hoa.payments.kpi.paid": "Paid (this month)",
  "hoa.payments.kpi.sent": "Sent invoices",
  "hoa.payments.kpi.rate": "Collection rate",

  // Payments - Bulk Reminder
  "hoa.payments.tabs.notifications": "Notification Log",
  "hoa.payments.bulkReminder": "Send reminders",
  "hoa.payments.bulkReminderSending": "Sending…",
  "hoa.payments.bulkReminderTitle": "Reminder results",
  "hoa.payments.bulkReminderTotal": "Total:",
  "hoa.payments.bulkReminderSent": "Sent:",
  "hoa.payments.bulkReminderMocked": "Mocked:",
  "hoa.payments.bulkReminderFailed": "Failed:",
  "hoa.payments.bulkReminderSummary": "Sent {sent} of {total} reminders",
  "hoa.payments.bulkReminderFailedToast": "Failed to send bulk reminders",
  "hoa.payments.bulkReminderDaysOverdue": "{count}d overdue",

  // Notification Log
  "hoa.notifLog.allTypes": "All Types",
  "hoa.notifLog.allStatuses": "All Statuses",
  "hoa.notifLog.typeOverdue": "Overdue Reminder",
  "hoa.notifLog.typeInvoiceSent": "Invoice Sent",
  "hoa.notifLog.channelEmail": "Email",
  "hoa.notifLog.channelSms": "SMS",
  "hoa.notifLog.triggeredAuto": "Auto",
  "hoa.notifLog.records": "{count} records",
  "hoa.notifLog.noResults": "No notifications found",
  "hoa.notifLog.refreshing": "Refreshing…",
  "hoa.notifLog.refresh": "↺ Refresh",
  "hoa.notifLog.loading": "Loading…",
  "hoa.notifLog.colDate": "Date",
  "hoa.notifLog.colInvoice": "Invoice",
  "hoa.notifLog.colType": "Type",
  "hoa.notifLog.colChannel": "Channel",
  "hoa.notifLog.colStatus": "Status",
  "hoa.notifLog.colRecipient": "Recipient",
  "hoa.notifLog.colTriggeredBy": "Triggered By",
  "hoa.notifLog.colError": "Error",
  "hoa.notifLog.resendOk": "Reminder resent.",
  "hoa.notifLog.resendFailed": "Could not resend. Try again.",
  "hoa.notifLog.status.sent": "Sent",
  "hoa.notifLog.status.failed": "Failed",
  "hoa.notifLog.status.mocked": "Mocked",
  "hoa.notifLog.retryNotification": "Retry notification",
  "hoa.notifLog.resend": "Resend",
  "hoa.notifLog.toast.resent": "Notification resent successfully",
  "hoa.notifLog.toast.resendFailed": "Failed to resend notification",

  // Building Detail Page
  "hoa.buildingDetail.noVacantUnits": "No vacant units available",
  "hoa.buildingDetail.markUnitVacant": "Mark a unit vacant or create a new unit to continue.",
  "hoa.buildingDetail.createUnit": "Create Unit",
  "hoa.buildingDetail.cannotCreateResident": "Cannot Create Resident",
  "hoa.buildingDetail.noVacantUnitsDescription": "No vacant units available in this building. All units are currently occupied or inactive.",
  "hoa.buildingDetail.createNewVacantUnit": "✓ Create a new vacant unit, or",
  "hoa.buildingDetail.markExistingUnitVacant": "✓ Mark an existing unit as vacant with 0 residents",
  "hoa.buildingDetail.createUnitFirst": "No vacant units available - Create a unit first",
  "hoa.buildingDetail.viewAllUnits": "View All Units",
  "hoa.buildingDetail.notFound.title": "Building Not Found",
  "hoa.buildingDetail.notFound.description": "The building you're looking for doesn't exist or has been deleted.",
  "hoa.buildingDetail.editBuildingDescription": "Update the building information below.",
  "hoa.buildingDetail.loadingUnits": "Loading units...",
  "hoa.buildingDetail.retry": "Retry",
  "hoa.buildingDetail.adjustSearch": "Try adjusting your search criteria.",
  "hoa.buildingDetail.adjustSearchOrFilter": "Try adjusting your search or filter criteria.",
  "hoa.buildingDetail.status.active": "Active",
  "hoa.buildingDetail.status.inactive": "Inactive",
  "hoa.buildingDetail.rifLabel": "RIF (Tax Information Registry)",
  "hoa.buildingDetail.rifHelper": "Printed on official invoices and receipts",
  "hoa.buildingDetail.rifPlaceholder": "J-12345678-9",
  "hoa.buildingDetail.defaultMonthlyFeePlaceholder": "0.00",
  "hoa.buildingDetail.info.title": "Building Information",
  "hoa.buildingDetail.info.lastUpdated": "Last Updated",
  "hoa.buildingDetail.info.totalUnitsPlanned": "Total Units (Planned)",
  "hoa.buildingDetail.notes": "Notes",
  "hoa.buildingDetail.unitLabel": "Unit {code}",
  "hoa.buildingDetail.floorLabel": "Floor {floor}",
  "hoa.buildingDetail.perMonthShort": "/mo",
  "hoa.buildingDetail.optional": "optional",
  "hoa.buildingDetail.sections.basicInformation": "Basic Information",
  "hoa.buildingDetail.sections.financialInformation": "Financial Information",
  "hoa.buildingDetail.sections.systemInformation": "System Information",
  "hoa.buildingDetail.financial.currentBalance": "Current Balance",
  "hoa.buildingDetail.financial.initialBalance": "Initial Balance",
  "hoa.buildingDetail.stats.detailed": "Detailed Statistics",
  "hoa.buildingDetail.stats.occupiedSub": "{count} occupied",
  "hoa.buildingDetail.stats.primarySub": "{count} primary",
  "hoa.buildingDetail.stats.occupiedUnits": "Occupied Units",
  "hoa.buildingDetail.stats.vacantUnits": "Vacant Units",
  "hoa.buildingDetail.stats.inactiveUnits": "Inactive Units",
  "hoa.buildingDetail.stats.primaryResidents": "Primary Residents",
  "hoa.buildingDetail.stats.secondaryResidents": "Secondary Residents",
  "hoa.buildingDetail.stats.totalBalance": "Total Balance",
  "hoa.buildingDetail.units.filter.allStatus": "All Status",
  "hoa.buildingDetail.units.status.inactive": "Inactive",
  "hoa.buildingDetail.units.errorLoading": "Error loading units",
  "hoa.buildingDetail.units.emptyInBuilding": "No units in this building yet",
  "hoa.buildingDetail.units.emptyHint": "Click \"Add Unit\" to create the first unit.",
  "hoa.buildingDetail.units.noMatching": "No matching units",
  "hoa.buildingDetail.units.residentCount": "{count} resident(s)",
  "hoa.buildingDetail.units.actionsAria": "Unit actions",
  "hoa.buildingDetail.units.detailsTitle": "Unit Details",
  "hoa.buildingDetail.units.viewingDetailsFor": "Viewing details for Unit {code}",
  "hoa.buildingDetail.units.loadDetailsFailed": "Failed to load unit details",
  "hoa.buildingDetail.units.updateUnit": "Update Unit",
  "hoa.buildingDetail.units.deleteTitle": "Delete Unit?",
  "hoa.buildingDetail.units.deleteDescription": "Are you sure you want to delete Unit {code}? This action cannot be undone. All associated data will be permanently removed.",
  "hoa.buildingDetail.units.deleteResidentWarning": "Warning: This unit has {count} resident(s).",
  "hoa.buildingDetail.units.modal.createDescription": "Adding unit to",
  "hoa.buildingDetail.units.modal.editDescription": "Editing unit in",
  "hoa.buildingDetail.units.form.unitCodePlaceholder": "A-101",
  "hoa.buildingDetail.units.form.floorPlaceholder": "1",
  "hoa.buildingDetail.units.form.unitNumberPlaceholder": "01",
  "hoa.buildingDetail.units.form.monthlyFeePlaceholder": "300.00",
  "hoa.buildingDetail.units.form.alicuota": "Alicuota (%)",
  "hoa.buildingDetail.units.form.alicuotaPlaceholder": "2.5000",
  "hoa.buildingDetail.units.form.alicuotaHelper": "Proportional share of building expenses (e.g. 2.5 = 2.5%)",
  "hoa.buildingDetail.units.form.selectStatus": "Select status",
  "hoa.buildingDetail.residents.unitsRequired": "Units required before adding residents",
  "hoa.buildingDetail.residents.assignmentWarning": "Residents must be assigned to a vacant unit. Create a unit first, then return here to add residents.",
  "hoa.buildingDetail.residents.searchByFields": "Search residents by name, email, phone, or unit...",
  "hoa.buildingDetail.residents.sendOtpCount": "Send OTP ({count})",
  "hoa.buildingDetail.residents.assignedToUnit": "Residents must be assigned to a unit.",
  "hoa.buildingDetail.residents.noMatching": "No matching residents",
  "hoa.buildingDetail.residents.selectResidentAria": "Select {name}",
  "hoa.buildingDetail.residents.actionsAria": "Resident actions",
  "hoa.buildingDetail.residents.noEmailAddress": "No email address",
  "hoa.buildingDetail.residents.selectVacantUnit": "Select a vacant unit",
  "hoa.buildingDetail.residents.noUnitsAvailable": "No units available. Create a unit to continue.",
  "hoa.buildingDetail.residents.detailsTitle": "Resident Details",
  "hoa.buildingDetail.residents.viewingDetailsFor": "Viewing details for {name}",
  "hoa.buildingDetail.residents.fullName": "Full Name",
  "hoa.buildingDetail.residents.language": "Language",
  "hoa.buildingDetail.residents.unitInformation": "Unit Information",
  "hoa.buildingDetail.residents.typeTitle": "Resident Type",
  "hoa.buildingDetail.residents.identityTitle": "Identity",
  "hoa.buildingDetail.residents.idDocument": "ID Document",
  "hoa.buildingDetail.residents.viewDocument": "View Document",
  "hoa.buildingDetail.residents.loadDetailsFailed": "Failed to load resident details",
  "hoa.buildingDetail.residents.updateResident": "Update Resident",
  "hoa.buildingDetail.residents.deleteTitle": "Delete Resident?",
  "hoa.buildingDetail.residents.deleteDescription": "Are you sure you want to delete {name} from Unit {unit}? This action cannot be undone. All associated data will be permanently removed.",
  "hoa.buildingDetail.residents.deletePrimaryWarning": "Warning: This is the primary contact for the unit.",
  "hoa.buildingDetail.residents.modal.createDescription": "Adding resident to",
  "hoa.buildingDetail.residents.modal.editDescription": "Editing resident in",
  "hoa.buildingDetail.residents.form.firstNamePlaceholder": "John",
  "hoa.buildingDetail.residents.form.lastNamePlaceholder": "Doe",
  "hoa.buildingDetail.residents.form.emailPlaceholder": "john.doe@email.com",
  "hoa.buildingDetail.residents.form.phonePlaceholder": "+1 (555) 123-4567",
  "hoa.buildingDetail.residents.form.identityDocument": "Identity Document",
  "hoa.buildingDetail.residents.form.identityPlaceholder": "V-12345678",
  "hoa.buildingDetail.residents.form.identityHelper": "Format: V-12345678 / E-12345678",
  "hoa.buildingDetail.residents.form.idDocumentPhoto": "ID Document Photo",
  "hoa.buildingDetail.residents.form.idDocumentUploadHelper": "Upload a photo or scan of the identity document/passport.",
  "hoa.buildingDetail.residents.form.idDocumentReplaceHelper": "Upload a new photo/scan to replace the current one.",
  "hoa.buildingDetail.residents.form.idPreviewAlt": "ID preview",
  "hoa.buildingDetail.residents.form.selectVacantUnit": "Select a vacant unit",
  "hoa.buildingDetail.residents.form.selectType": "Select type",
  "hoa.buildingDetail.residents.form.primaryContact": "Primary Contact",
  "hoa.buildingDetail.residents.form.primaryContactHelper": "Main contact for this unit",
  "hoa.buildingDetail.residents.contact.primary": "Primary",
  "hoa.buildingDetail.residents.contact.secondary": "Secondary",
  "hoa.buildingDetail.toast.buildingUpdated": "Building updated successfully",
  "hoa.buildingDetail.toast.buildingUpdateFailed": "Failed to update building",
  "hoa.buildingDetail.toast.unitCreatedDescription": "Unit {code} has been added to {building}",
  "hoa.buildingDetail.toast.unitUpdatedDescription": "Unit {code} has been updated",
  "hoa.buildingDetail.toast.unitDeletedDescription": "Unit {code} has been deleted successfully",
  "hoa.buildingDetail.toast.unitDuplicate": "Unit code \"{code}\" already exists in this building",
  "hoa.buildingDetail.toast.unitDeleteErrorDescription": "An error occurred while deleting the unit",
  "hoa.buildingDetail.toast.residentCreatedDescription": "{name} has been added to {building}",
  "hoa.buildingDetail.toast.residentUpdatedDescription": "{name} has been updated",
  "hoa.buildingDetail.toast.residentDeletedDescription": "{name} has been deleted successfully",
  "hoa.buildingDetail.toast.residentDuplicate": "Resident with email \"{email}\" already exists",
  "hoa.buildingDetail.toast.residentDeleteErrorDescription": "An error occurred while deleting the resident",
  "hoa.buildingDetail.noVacantUnitsDescriptionShort": "in this building. All units are currently occupied or inactive.",
};



// Spanish translations
export const es: Record<string, string> = {

  "reports.toast.submitted.title": "¡Solicitud de reporte enviada!",
  "reports.toast.submitted.desc": "Tu reporte detallado será enviado a {email} en unos minutos.",
  "reports.toast.error.generic": "Error al solicitar el reporte. Por favor, intenta de nuevo.",
  "reports.toast.error.limit": "Has solicitado 3 reportes en las últimas 24 horas. Por favor, espera.",
  "reports.button.requesting": "Solicitando…",
  "reports.button.request": "Solicitar Reporte Completo por Email",
  "reports.notice.csv": "Recibirás un archivo CSV detallado con todos los registros de facturas en tu correo electrónico. Hasta 3 solicitudes.",
  "reports.alert.queued": "¡Reporte en la cola!",
  "reports.alert.sent": "Tu reporte financiero detallado será enviado a",
  "reports.alert.sentSuffix": "en los próximos minutos.",
  "reports.button.emailReport": "Enviar Email",

  // Settings
  "settings.profile": "Perfil",
  "settings.paymentDetails": "Detalles de Pago",

  // Hoa Admins
  "superAdmin.hoaAdmins.actions.createAccount": "Crear Cuenta",
  "superAdmin.hoaAdmins.alerts.created": "Cuenta de condominio creada — credenciales de acceso enviadas por correo.",
  "superAdmin.hoaAdmins.alerts.createFailed": "No se pudo crear la cuenta. Revisa los datos e inténtalo de nuevo.",
  "superAdmin.hoaAdmins.alerts.resendSuccess": "Credenciales generadas y correo enviado.",
  "superAdmin.hoaAdmins.alerts.resendFailed": "No se pudieron reenviar las credenciales.",
  "superAdmin.hoaAdmins.alerts.invalidCharge": "El cargo por servicio debe ser un número entre 0 y 100.",
  "superAdmin.hoaAdmins.alerts.saveFailed": "No se pudo guardar. Inténtalo de nuevo.",
  "superAdmin.hoaAdmins.header.title": "Cuentas de Condominios",
  "superAdmin.hoaAdmins.header.desc": "Gestiona las cuentas de la plataforma, los estados de suscripción y los cargos por servicio.",
  "superAdmin.hoaAdmins.tabs.admins": "Condominios",
  "superAdmin.hoaAdmins.tabs.subscriptions": "Suscripciones",
  "superAdmin.hoaAdmins.tabs.subPayments": "Pagos de Suscripción",
  "superAdmin.hoaAdmins.alerts.deletePlanFailed": "No se pudo eliminar el plan. Inténtalo de nuevo.",
  "superAdmin.hoaAdmins.alerts.deletePlanInUse": "No se puede eliminar este plan porque ya está referenciado por facturas existentes. Desactívalo en su lugar.",
  "superAdmin.hoaAdmins.actions.exportCsv": "Exportar CSV",
  "superAdmin.hoaAdmins.actions.approve": "Aprobar",
  "superAdmin.hoaAdmins.actions.reject": "Rechazar",
  "superAdmin.hoaAdmins.actions.reApprove": "Reaprobar",
  "superAdmin.hoaAdmins.actions.setRate": "Ajustar Tarifa",
  "superAdmin.hoaAdmins.actions.suspend": "Suspender",
  "superAdmin.hoaAdmins.actions.activate": "Activar",
  "superAdmin.hoaAdmins.stats.total": "Total",
  "superAdmin.hoaAdmins.stats.pending": "Pendientes",
  "superAdmin.hoaAdmins.stats.active": "Activos",
  "superAdmin.hoaAdmins.stats.suspended": "Suspendidos",
  "superAdmin.hoaAdmins.stats.expired": "Expirados",
  "superAdmin.hoaAdmins.filters.search": "Buscar por nombre, correo, o junta...",
  "superAdmin.hoaAdmins.filters.status": "Estado:",
  "superAdmin.payments.title": "Gestión de Pagos",
  "superAdmin.payments.subtitle": "Rastrea y gestiona los pagos de los residentes a través del flujo de verificación",
  "superAdmin.payments.stages.needsReview": "Necesita Revisión",
  "superAdmin.payments.stages.readyToForward": "Listo para Reenviar",
  "superAdmin.payments.stages.awaitingHoa": "Esperando Junta",
  "superAdmin.payments.stages.waitingHoa": "Esperando confirmación de la Junta",
  "superAdmin.payments.stages.completed": "Completado",
  "superAdmin.payments.stages.fullyProcessed": "Totalmente procesado",
  "superAdmin.payments.filters.allTime": "Todo el tiempo",
  "superAdmin.payments.filters.lastWeek": "Última semana",
  "superAdmin.payments.filters.lastMonth": "Último mes",
  "superAdmin.payments.filters.last3Months": "Últimos 3 meses",
  "superAdmin.payments.filters.allStatus": "Todos los Estados",
  "superAdmin.payments.actions.approve": "Aprobar",
  "superAdmin.payments.actions.reject": "Rechazar",
  "superAdmin.payments.actions.details": "Detalles",
  "superAdmin.payments.actions.viewProof": "Ver comprobante de pago",
  "superAdmin.payments.dialogs.chooseHoAccount": "Elige a qué cuenta de la Junta estás enviando el pago",
  "superAdmin.payments.dialogs.uploadScreenshot": "Sube captura o recibo de la transferencia bancaria a la Junta",
  "superAdmin.payments.methods.bankTransfer": "Transferencia Bancaria",
  "superAdmin.payments.methods.zelle": "Zelle",
  "superAdmin.payments.methods.pagoMovil": "Pago Móvil",
  "superAdmin.payments.methods.paypalOther": "PayPal / Otro",
  "superAdmin.payments.status.pendingVerification": "Pendiente de Verificación",
  "superAdmin.payments.status.pendingHoa": "Pendiente de la Junta",
  "superAdmin.payments.status.verifiedPaid": "Verificado/Pagado",
  "superAdmin.payments.status.draft": "Borrador",
  "superAdmin.payments.status.sent": "Enviado",
  "superAdmin.payments.status.unpaid": "No Pagado",
  "superAdmin.payments.status.cancelled": "Cancelado",
  "superAdmin.payments.status.paid": "Pagado",
  "superAdmin.paymentDetail.adminNotes": "Notas de Verificación del Administrador",
  "superAdmin.paymentDetail.confirmFile": "Archivo de Confirmación",
  "superAdmin.paymentDetail.proofSubmitted": "Comprobante de Pago Enviado",
  "superAdmin.common.refresh": "Actualizar",
  "superAdmin.common.clear": "Limpiar",
  "superAdmin.common.close": "Cerrar",
  "superAdmin.common.cancel": "Cancelar",
  "superAdmin.common.reset": "Restablecer",
  "superAdmin.common.noResults": "Sin resultados.",
  "superAdmin.common.openNewTab": "Abrir en Nueva Pestaña",
  "superAdmin.common.resend": "Reenviar",
  "superAdmin.common.pdf": "PDF",
  "superAdmin.payouts.title": "Pagos a Condominios",
  "superAdmin.payouts.subtitle": "Registros de dinero reenviado a Administradores de Condominio (con comprobante).",
  "superAdmin.payouts.search": "Buscar admin / edificio / residente / unidad / fecha...",
  "superAdmin.payouts.exportCsv": "Exportar CSV",
  "superAdmin.payouts.hoaAdmin": "Administrador-HOA",
  "superAdmin.payouts.condo": "Edificio",
  "superAdmin.payouts.residentUnit": "Residente / Unidad",
  "superAdmin.payouts.amount": "Monto",
  "superAdmin.payouts.date": "Fecha",
  "superAdmin.payouts.proof": "Comprobante",
  "superAdmin.payouts.viewProof": "Ver comprobante de reenvío",
  "superAdmin.payouts.view": "Ver",
  "superAdmin.payouts.noProof": "Sin comprobante subido",
  "superAdmin.payouts.noPayouts": "No hay pagos aún.",
  "superAdmin.markForward.title": "Confirmar Pago y Adjuntar Comprobante",
  "superAdmin.markForward.notFound": "Pago no encontrado",
  "superAdmin.markForward.proofLabel": "Comprobante (imagen o PDF)",
  "superAdmin.markForward.selected": "Seleccionado:",
  "superAdmin.markForward.noteLabel": "Nota (opcional)",
  "superAdmin.markForward.notePlaceholder": "ej., Referencia de transferencia #12345",
  "superAdmin.markForward.summaryFrom": "de",
  "superAdmin.markForward.toLabel": "Para:",
  "superAdmin.markForward.confirmBtn": "Confirmar y Guardar",
  "superAdmin.markForward.toasts.attachProof": "Adjuntar comprobante de reenvío",
  "superAdmin.markForward.toasts.uploadProof": "Por favor cargue una imagen o PDF como comprobante.",
  "superAdmin.markForward.toasts.markedForwarded": "Pago marcado como Reenviado",
  "superAdmin.markForward.toasts.proofAttached": "Comprobante adjuntado exitosamente.",
  "superAdmin.paymentDetail.title": "Verificación de Pago",
  "superAdmin.paymentDetail.loading": "Cargando detalles del pago...",
  "superAdmin.paymentDetail.notFound": "Pago no encontrado",
  "superAdmin.paymentDetail.invoiceSummary": "Resumen de Factura",
  "superAdmin.paymentDetail.statusTitle": "Estado",
  "superAdmin.paymentDetail.timeline": "Línea de Tiempo del Pago",
  "superAdmin.paymentDetail.invoiceCreated": "Factura creada:",
  "superAdmin.paymentDetail.markedPaid": "Marcada como pagada:",
  "superAdmin.paymentDetail.adminVerified": "Verificada por el admin:",
  "superAdmin.paymentDetail.finalized": "Finalizada:",
  "superAdmin.paymentDetail.verification": "Verificación",
  "superAdmin.paymentDetail.transactionScreenshot": "Captura de Pantalla",
  "superAdmin.paymentDetail.idVerification": "Verificación de Identidad",
  "superAdmin.paymentDetail.noProof": "Aún no se ha subido ningún comprobante de pago.",
  "superAdmin.paymentDetail.residentNotes": "Notas del Residente",
  "superAdmin.paymentDetail.platformPaymentTitle": "Detalles de Pago de la Plataforma",
  "superAdmin.paymentDetail.platformPaymentDesc": "El residente paga a esta cuenta",
  "superAdmin.paymentDetail.hoaPayoutTitle": "Detalles de Pago al Admin HOA",
  "superAdmin.paymentDetail.hoaPayoutDesc": "La plataforma transfiere el monto neto a esta cuenta",
  "superAdmin.paymentDetail.uploadedBy": "por {name}",
  "superAdmin.paymentDetail.alreadyVerified": "Este pago ya ha sido verificado.",
  "superAdmin.paymentDetail.notReadyForVerification": "Este pago no está listo para la verificación.",
  "superAdmin.paymentDetail.openNewTab": "Abrir en nueva pestaña",
  "superAdmin.paymentDetail.noFileProvided": "Sin archivo adjunto",
  "superAdmin.paymentDetail.dueDate": "Fecha de vencimiento",
  "superAdmin.paymentDetail.paidOn": "Pagado el {date}",
  "superAdmin.paymentDetail.confirmedByHoa": "Confirmado por el condominio",
  "superAdmin.paymentDetail.confirmedByHoaDetail": "Registrado por {who} el {date}",
  "superAdmin.paymentDetail.directHoaNote": "El residente pagó directamente al condominio. La plataforma no retiene estos fondos, por lo que no aplica verificación de la plataforma.",
  "superAdmin.paymentDetail.hoaReceivingTitle": "Cuenta receptora del condominio",
  "superAdmin.paymentDetail.hoaReceivingDesc": "El residente paga en esta cuenta",
  "superAdmin.paymentDetail.approveTitle": "¿Aprobar Pago?",
  "superAdmin.paymentDetail.approveDesc": "Esto verificará el pago y actualizará el estado para que el admin del Condominio pueda finalizarlo.",
  "superAdmin.paymentDetail.notesLabel": "Notas de Verificación (Opcional)",
  "superAdmin.paymentDetail.fileLabel": "Archivo de Confirmación (Opcional)",
  "superAdmin.paymentDetail.rejectTitle": "¿Rechazar Pago?",
  "superAdmin.paymentDetail.rejectDesc": "Esto rechazará el comprobante de pago y restablecerá el estado de la factura a NO PAGADA.",
  "superAdmin.paymentDetail.approveBtn": "Aprobar Pago",
  "superAdmin.paymentDetail.rejectBtn": "Rechazar Pago",
  "superAdmin.paymentDetail.backToInbox": "Volver al buzón",
  "superAdmin.paymentDetail.toasts.verifySuccess": "Verificación de pago completada",
  "superAdmin.paymentDetail.toasts.verifyFail": "Error en la verificación",
  "superAdmin.paymentDetail.toasts.resendSuccess": "Notificación reenviada con éxito",
  "superAdmin.paymentDetail.toasts.resendFail": "Error al reenviar la notificación",
  "superAdmin.paymentDetail.toasts.proofRejected": "Comprobante de pago rechazado",
  "superAdmin.common.unknownError": "Error desconocido",
  "superAdmin.common.back": "Volver",
  "superAdmin.hoaAdmins.table.status": "Estado",
  "superAdmin.hoaAdmins.table.subscriptionPlan": "Plan de Suscripción",
  "superAdmin.hoaAdmins.actions.resendPass": "Reenviar Clave",
  "superAdmin.hoaAdmins.states.noResults": "Sin resultados.",

  "superAdmin.hoaAdmins.subs.newPlan": "Nuevo Plan",
  "superAdmin.hoaAdmins.states.loadingPlans": "Cargando planes...",
  "superAdmin.hoaAdmins.states.noSubscriptions": "Sin suscripciones aún.",
  "superAdmin.hoaAdmins.states.noSubsFound": "No se encontraron suscripciones. Se crean cuando se aprueba un administrador de condominio.",
  "superAdmin.hoaAdmins.states.noPlansFound": "Aún no hay planes de suscripción. Crea uno para comenzar.",
  "superAdmin.hoaAdmins.form.planName": "Nombre del Plan *",
  "superAdmin.hoaAdmins.form.description": "Descripción",
  "superAdmin.hoaAdmins.form.priceUsd": "Precio (USD) *",
  "superAdmin.hoaAdmins.form.billingCycle": "Ciclo de Facturación *",
  "superAdmin.hoaAdmins.form.maxUnits": "Unidades Máximas",
  "superAdmin.hoaAdmins.form.zeroUnlimited": "Ponga 0 para ilimitado.",
  "superAdmin.hoaAdmins.form.activeAvailable": "Activo (disponible para nuevas suscripciones)",
  "superAdmin.hoaAdmins.cycles.monthly": "Mensual",
  "superAdmin.hoaAdmins.cycles.quarterly": "Trimestral",
  "superAdmin.hoaAdmins.cycles.annual": "Anual",
  "superAdmin.hoaAdmins.status.trial": "Prueba",
  "superAdmin.hoaAdmins.status.active": "Activo",
  "superAdmin.hoaAdmins.status.suspended": "Suspendido",
  "superAdmin.hoaAdmins.status.cancelled": "Cancelado",
  "superAdmin.hoaAdmins.status.expired": "Expirado",
  "superAdmin.hoaAdmins.status.inactive": "Inactivo",
  "superAdmin.hoaAdmins.status.pending": "Pendiente de Aprobación",
  "superAdmin.hoaAdmins.status.rejected": "Rechazado",
  "superAdmin.hoaAdmins.status.all": "Todos",
  "superAdmin.hoaAdmins.form.email": "Correo Electrónico",
  "superAdmin.hoaAdmins.form.firstName": "Nombre",
  "superAdmin.hoaAdmins.form.lastName": "Apellido",
  "superAdmin.hoaAdmins.form.orgName": "Organización / Nombre del Condominio",
  "superAdmin.hoaAdmins.form.maxUnitsAllowed": "Unidades Máximas Permitidas",
  "superAdmin.hoaAdmins.form.createNotice": "La cuenta estará activa de inmediato. Las credenciales de inicio de sesión se enviarán a la dirección de correo electrónico proporcionada.",
  "superAdmin.hoaAdmins.form.reasonOptional": "Motivo (opcional)",
  "superAdmin.hoaAdmins.headers.subs": "Suscripciones de Admins HOA",
  "superAdmin.hoaAdmins.headers.plans": "Planes de Suscripción",
  "superAdmin.hoaAdmins.headers.charges": "Cargos de Servicio de la Plataforma",
  "superAdmin.hoaAdmins.headers.settingRateFor": "Ajustando tarifa para",
  "superAdmin.hoaAdmins.form.chargeNotice": "Porcentaje de cada factura cobrado como comisión de plataforma (ej. 3.00 = 3%).",
  "superAdmin.hoaAdmins.form.chargeRate": "Tasa de Cargo de Servicio (%)",
  "superAdmin.hoaAdmins.dialogs.createAccount": "Crear Cuenta de Admin HOA",
  "superAdmin.hoaAdmins.dialogs.rejectAccount": "Rechazar Cuenta",
  "superAdmin.hoaAdmins.dialogs.rejectNotice": " Recibirán una notificación por correo electrónico.",
  "superAdmin.hoaAdmins.dialogs.editPlan": "Editar Plan",
  "superAdmin.hoaAdmins.dialogs.newPlan": "Nuevo Plan de Suscripción",
  "superAdmin.hoaAdmins.dialogs.deletePlan": "Eliminar Plan",
  "superAdmin.hoaAdmins.dialogs.manageSub": "Gestionar Suscripción",
  "superAdmin.hoaAdmins.dialogs.rejectPayment": "Rechazar Pago de Suscripción",
  "superAdmin.hoaAdmins.actions.deletePlan": "Eliminar plan",
  "superAdmin.hoaAdmins.actions.manage": "Gestionar",
  "superAdmin.hoaAdmins.actions.manageSub": "Gestionar Suscripción",
  "superAdmin.hoaAdmins.actions.viewProof": "Ver Comprobante ↗",
  "superAdmin.hoaAdmins.actions.cancel": "Cancelar",
  "superAdmin.hoaAdmins.actions.delete": "Eliminar",
  "superAdmin.hoaAdmins.actions.edit": "Editar",
  "superAdmin.hoaAdmins.table.adminHoa": "Admin HOA",
  "superAdmin.hoaAdmins.table.plan": "Plan",
  "superAdmin.hoaAdmins.table.period": "Periodo",
  "superAdmin.hoaAdmins.table.history": "Historial",
  "superAdmin.hoaAdmins.table.awaiting": "Esperando Revisión",
  "superAdmin.hoaAdmins.table.completed": "Completado",
  "superAdmin.hoaAdmins.table.notes": "Notas",
  "superAdmin.hoaAdmins.states.noPlanList": "— Sin plan —",
  "superAdmin.hoaAdmins.states.noPlan": "Sin plan",
  "superAdmin.hoaAdmins.states.noPlanAssigned": "Sin plan asignado",
  "superAdmin.hoaAdmins.states.noPendingSubs": "No hay pagos de suscripción pendientes para revisar.",
  "superAdmin.hoaAdmins.dialogs.rejectingPaymentFrom": "Rechazando pago de",
  "superAdmin.hoaAdmins.dialogs.rejectionReason": "Motivo del rechazo",
  "superAdmin.hoaAdmins.states.loading": "Cargando...",
  "superAdmin.hoaAdmins.states.noOrg": "Sin org",
  "superAdmin.hoaAdmins.table.name": "Nombre",
  "superAdmin.hoaAdmins.table.email": "Correo electrónico",
  "superAdmin.hoaAdmins.table.org": "Organización",
  "superAdmin.hoaAdmins.table.charge": "Cargo de Servicio",
  "superAdmin.hoaAdmins.table.actions": "Acciones",
  "superAdmin.hoaAdmins.text.serviceChargeSuffix": "% cargo por servicio",

  // Payments Inbox
  "superAdmin.payments.header.title": "Gestión de Pagos",
  "superAdmin.payments.header.desc": "Rastrea y gestiona los pagos de los residentes a través del flujo de verificación",
  "superAdmin.payments.tabs.all": "Todos los Pagos",
  "superAdmin.payments.tabs.review": "Requiere Revisión",
  "superAdmin.payments.tabs.reviewDesc": "Verificar comprobantes de pago",
  "superAdmin.payments.tabs.ready": "Listo para Reenviar",
  "superAdmin.payments.tabs.readyDesc": "Enviar al Administrador del Condominio",
  "superAdmin.payments.tabs.awaiting": "Esperando HOA",
  "superAdmin.payments.tabs.awaitingDesc": "El condominio necesita confirmar",
  "superAdmin.payments.tabs.completed": "Completado",
  "superAdmin.payments.tabs.completedDesc": "Completamente procesado",
  "superAdmin.payments.bulk.actions": "Acciones en Bloque:",
  "superAdmin.payments.bulk.approveAll": "Aprobar Todos ({count})",
  "superAdmin.payments.bulk.rejectAll": "Rechazar Todos ({count})",
  "superAdmin.payments.bulk.clear": "Limpiar",
  "superAdmin.payments.bulk.selected": "{count} seleccionados",
  "superAdmin.payments.toolbar.search": "Buscar residente / correo / unidad / método…",
  "superAdmin.payments.actions.refreshData": "Actualizar datos",
  "superAdmin.payments.toolbar.status": "Estado",
  "superAdmin.payments.toolbar.showingCount": "Mostrando {count} pago(s)",
  "superAdmin.payments.filters.pendingVerification": "Pendiente de Verificación",
  "superAdmin.payments.filters.verifiedPaid": "Verificado/Pagado",
  "superAdmin.payments.toolbar.timeRange": "Rango de tiempo",
  "superAdmin.payments.toolbar.building": "Edificio",
  "superAdmin.payments.toolbar.allBuildings": "Todos los edificios",
  "superAdmin.payments.filters.last1week": "Última semana",
  "superAdmin.payments.filters.last1month": "Último mes",
  "superAdmin.payments.filters.last3months": "Últimos 3 meses",
  "superAdmin.payments.actions.reset": "Restablecer",
  "superAdmin.payments.actions.exportCsv": "Exportar CSV",
  "superAdmin.payments.toolbar.paymentsCount": "pago(s)",
  "superAdmin.payments.states.unknownBuilding": "Edificio Desconocido",
  "superAdmin.payments.states.rejectedCount": "Rechazado {count}x",
  "superAdmin.payments.states.noProof": "Sin comprobante de pago",
  "superAdmin.payments.states.markedBy": "Marcado por: {name}",
  "superAdmin.payments.states.paymentProof": "Comprobante de Pago",
  "superAdmin.payments.actions.forwardToHoa": "Reenviar a la HOA",
  "superAdmin.payments.states.waitingForHoa": "Esperando confirmación del condominio",
  "superAdmin.payments.states.pendingHoa": "Pendiente HOA",
  "superAdmin.payments.states.noResults": "Sin resultados.",
  "superAdmin.payments.table.building": "Edificio",
  "superAdmin.payments.table.resident": "Residente",
  "superAdmin.payments.table.unit": "Unidad",
  "superAdmin.payments.table.amount": "Monto",
  "superAdmin.payments.table.method": "Método",
  "superAdmin.payments.table.completed": "Completado",
  "superAdmin.payments.table.forwarded": "Reenviado",
  "superAdmin.payments.table.date": "Fecha",
  "superAdmin.payments.table.status": "Estado",
  "superAdmin.payments.table.actions": "Acciones",
  "superAdmin.payments.states.imageNotFound": "Imagen no encontrada",
  "superAdmin.payments.actions.openNewTab": "Abrir en Nueva Pestaña",
  "superAdmin.payments.actions.close": "Cerrar",
  "superAdmin.payments.dialogs.approvePayment": "Aprobar Pago",
  "superAdmin.payments.dialogs.approvePaymentDesc": "Aprobar pago para {name} - ${amount}",
  "superAdmin.payments.dialogs.verificationNotes": "Notas de Verificación (Opcional)",
  "superAdmin.payments.dialogs.verificationNotesPlaceholder": "Añade notas sobre la verificación...",
  "superAdmin.payments.actions.approving": "Aprobando...",
  "superAdmin.payments.actions.confirmApproval": "Confirmar Aprobación",
  "superAdmin.payments.actions.cancel": "Cancelar",
  "superAdmin.payments.dialogs.rejectPayment": "Rechazar Pago",
  "superAdmin.payments.dialogs.rejectPaymentDesc": "Rechazar pago para {name} - ${amount}",
  "superAdmin.payments.dialogs.rejectReason": "Motivo de Rechazo",
  "superAdmin.payments.dialogs.rejectReasonPlaceholder": "Explica por qué se rechaza este pago...",
  "superAdmin.payments.dialogs.bulkRejectDefaultNote": "Rechazo masivo",
  "superAdmin.payments.actions.rejecting": "Rechazando...",
  "superAdmin.payments.actions.confirmRejection": "Confirmar Rechazo",
  "superAdmin.payments.dialogs.bulkApprove": "Aprobar Pagos en Bloque",
  "superAdmin.payments.dialogs.bulkApproveDesc": "¿Aprobar {count} pago(s)?",
  "superAdmin.payments.dialogs.bulkApproveNotesPlaceholder": "Añadir notas para todos los pagos aprobados...",
  "superAdmin.payments.dialogs.approveCount": "Aprobar {count} Pago(s)",
  "superAdmin.payments.dialogs.bulkReject": "Rechazar Pagos en Bloque",
  "superAdmin.payments.dialogs.bulkRejectDesc": "¿Rechazar {count} pago(s)?",
  "superAdmin.payments.dialogs.bulkRejectNotesPlaceholder": "Explica por qué se rechazan estos pagos...",
  "superAdmin.payments.dialogs.rejectCount": "Rechazar {count} Pago(s)",
  "superAdmin.payments.dialogs.confirmForward": "Confirmar Pago al Condominio",
  "superAdmin.payments.dialogs.forwardDesc": "Reenviar ${amount} a {name}",
  "superAdmin.payments.dialogs.noHoaPaymentMethod": "El administrador del condominio no tiene método de pago configurado",
  "superAdmin.payments.dialogs.noHoaPaymentMethodDesc": "El administrador del condominio para {name} aún no ha configurado ningún método de pago.",
  "superAdmin.payments.dialogs.cannotForward": "No puedes reenviar este pago hasta que configuren su cuenta.",
  "superAdmin.payments.actions.sendingReminder": "Enviando recordatorio...",
  "superAdmin.payments.actions.sendReminder": "📧 Enviar Recordatorio de Configuración al Administrador",
  "superAdmin.payments.dialogs.selectPaymentMethod": "Seleccionar Método de Pago (Requerido)",
  "superAdmin.payments.dialogs.chooseHoaAccount": "Elige a qué cuenta del condominio estás enviando el pago",
  "superAdmin.payments.dialogs.additionalDestinationDetails": "Detalles adicionales del destino",
  "superAdmin.payments.dialogs.noSupportedMethod": "No hay un método de reenvío compatible configurado",
  "superAdmin.payments.dialogs.noSupportedMethodDesc": "Este destino tiene datos de pago, pero ninguno de los métodos compatibles actualmente en este flujo (Transferencia Bancaria, Zelle, Pago Movil, PayPal).",
  "superAdmin.payments.methods.bankAccount": "Cuenta Bancaria",
  "superAdmin.payments.methods.account": "Cuenta",
  "superAdmin.payments.methods.paypal": "PayPal",
  "superAdmin.payments.dialogs.transferProof": "Comprobante de Transferencia (Requerido)",
  "superAdmin.payments.dialogs.uploadReceipt": "Sube una captura de pantalla o recibo de la transferencia",
  "superAdmin.payments.dialogs.notesOptional": "Notas (Opcional)",
  "superAdmin.payments.dialogs.notesPlaceholder": "Añade notas sobre esta transferencia...",
  "superAdmin.payments.actions.forwarding": "Reenviando...",
  "superAdmin.payments.toasts.forwardSuccess": "Pago reenviado a la HOA con éxito",
  "superAdmin.payments.toasts.forwardFail": "Error al reenviar el pago",
  "superAdmin.payments.toasts.reminderSentTo": "Recordatorio enviado a {email}",
  "superAdmin.payments.toasts.reminderFail": "Error al enviar recordatorio",
  "superAdmin.payments.toasts.bulkApproveSuccess": "Se aprobaron {count} pago(s) correctamente",
  "superAdmin.payments.toasts.bulkRejectSuccess": "Se rechazaron {count} pago(s) correctamente",
  "superAdmin.payments.toasts.bulkVerifyFail": "La verificación masiva falló",

  "settings.subscription": "Suscripción",
  "settings.configurations": "Configuraciones",
  "settings.saveChanges": "Guardar Cambios",
  "settings.saving": "Guardando...",
  "settings.save": "Guardar",
  "settings.orgName": "Nombre de la Organización",
  "settings.firstName": "Nombre",
  "settings.lastName": "Apellido",
  "settings.manageProfileMsg": "Administra tu perfil, detalles de pago y preferencias",
  "settings.profileUpdated": "Perfil actualizado exitosamente",
  "settings.profileUpdateError": "Error al actualizar el perfil",

  "settings.paymentDetailsCreated": "Detalles de pago creados exitosamente",
  "settings.paymentDetailsCreateError": "Error al crear detalles de pago",
  "settings.paymentDetailsUpdated": "Detalles de pago actualizados exitosamente",
  "settings.paymentDetailsUpdateError": "Error al actualizar detalles de pago",

  "settings.notificationsUpdated": "Configuración de notificaciones actualizada",
  "settings.notificationsUpdateError": "Error al actualizar configuración de notificaciones",
  "settings.securityUpdated": "Configuración de seguridad actualizada",
  "settings.securityUpdateError": "Error al actualizar configuración de seguridad",

  "settings.subRequestCreated": "Solicitud de suscripción creada. Por favor, sube tu comprobante de pago.",
  "settings.subRequestError": "Error al crear la solicitud de suscripción.",
  "settings.proofUploaded": "Comprobante de pago enviado. Esperando verificación.",
  "settings.proofUploadError": "Error al subir el comprobante de pago.",
  "settings.subCancelled": "Solicitud de suscripción cancelada.",
  "settings.cancelError": "Error al cancelar.",

  "settings.noActivePlan": "Sin plan activo",
  "settings.units": "Unidades",
  "settings.trialEnds": "El período de prueba termina el",
  "settings.renewsOn": "Se renueva el",

  "settings.cancelRequest": "Cancelar solicitud",
  "settings.uploadProof": "Subir Comprobante de Pago",
  "settings.transferPrefix": "Transfiere",
  "settings.transferSuffix": "a nuestra cuenta de la plataforma, luego sube tu recibo a continuación.",

  "settings.screenshotReceipt": "Captura de pantalla / recibo de pago",
  "settings.clickToSelectFile": "Haz clic para seleccionar un archivo (imagen o PDF)",
  "settings.uploading": "Subiendo...",
  "settings.submitProof": "Enviar Comprobante de Pago",
  "settings.viewPreviousProof": "Ver comprobante enviado anteriormente",

  "settings.waitingAdminVerification": "Esperando Verificación del Administrador",
  "settings.proofReceivedMessage": "Tu comprobante de pago ha sido recibido. El equipo de la plataforma revisará y activará tu suscripción en breve.",
  "settings.viewUploadedProof": "Ver comprobante enviado",

  "settings.noPlansAvailable": "No hay planes de suscripción disponibles todavía.",
  "settings.availablePlans": "Planes Disponibles",
  "settings.current": "Actual",
  "settings.upTo": "Hasta",
  "settings.unlimited": "ilimitadas",
  "settings.unitsLowercase": "unidades",

  "settings.subscribeTo": "Suscribirse a",
  "settings.afterConfirmingMsg": "Después de confirmar, se te pedirá que subas tu comprobante de pago para activar la suscripción.",
  "settings.requesting": "Solicitando...",
  "settings.confirmAndRequest": "Confirmar y Solicitar",
  "settings.cancel": "Cancelar",

  "settings.hide": "Ocultar",
  "settings.show": "Mostrar",
  "settings.paymentHistory": "historial de pagos",

  "settings.emailNotifications": "Notificaciones por Correo",
  "settings.emailNotifDesc": "Recibe notificaciones vía correo",
  "settings.smsNotifications": "Notificaciones por SMS",
  "settings.smsNotifDesc": "Recibe notificaciones urgentes por SMS",
  "settings.maintenanceAlerts": "Alertas de Mantenimiento",
  "settings.maintenanceNotifDesc": "Recibe notificaciones de nuevos problemas de mantenimiento",
  "settings.paymentReminders": "Recordatorios de Pago",
  "settings.paymentRemindersDesc": "Envía recordatorios de pago a los residentes",

  "settings.requirePhotos": "Requerir Fotos para Problemas",
  "settings.requirePhotosDesc": "Los residentes deben adjuntar fotos al reportar problemas",
  "settings.autoApproveResidents": "Auto-aprobar Nuevos Residentes",
  "settings.autoApproveDesc": "Aprueba automáticamente registros de nuevos residentes",
  "settings.allowGuests": "Permitir Acceso de Invitados",
  "settings.allowGuestsDesc": "Los residentes pueden conceder acceso temporal a invitados",
  "settings.security": "Seguridad",
  "settings.notifications": "Notificaciones",
  "settings.maintenance": "Mantenimiento",
  "settings.appInfo": "Info de App",
  "settings.password": "Contraseña",
  "settings.bankName": "Nombre del Banco",
  "settings.legalName": "Nombre Legal",
  "settings.bank": "Banco",
  "settings.idNumber": "Cédula / RIF",
  "settings.phone": "Teléfono",
  "settings.email": "Correo",
  "settings.accountNumber": "Cuenta #",
  "settings.routingNumber": "Número de Ruta",
  "settings.exBanesco": "Ej., Banco Banesco",
  "settings.exCondoName": "Ej., Condominio Las Torres",
  "settings.exMercantil": "Ej: Banco Mercantil",
  "settings.exIdNumber": "V-12345678",
  "settings.currentPassword": "Contraseña actual",
  "settings.newPassword": "Nueva contraseña",
  "settings.confirmPassword": "Confirmar nueva contraseña",
  "settings.passwordUpdated": "Contraseña actualizada exitosamente",
  "settings.passwordUpdateError": "Error al actualizar la contraseña",
  "settings.passwordMinLength": "La nueva contraseña debe tener al menos 8 caracteres",
  "settings.passwordsDoNotMatch": "Las contraseñas no coinciden",
  "settings.showPasswords": "Mostrar contraseñas",
  "settings.updatePassword": "Actualizar contraseña",
  "settings.gracePeriodTitle": "Suscripción Expirada o Cancelada",
  "settings.gracePeriodMessage": "Actualmente te encuentras en un período de gracia de 3 días que culmina el {date}. Por favor, reanuda tu plan de suscripción en la sección inferior para evitar perder tu acceso y permisos de administración.",
  "settings.unitSlotsTitle": "Cupos de Unidades",
  "settings.unitSlotsSubtitle": "Información y uso de tu suscripción",
  "settings.paymentDetailsSubtitle": "Información bancaria y de pago para recibir cobros",
  "settings.mySubscriptionTitle": "Mi Suscripción",
  "settings.mySubscriptionSubtitle": "Administra tu plan de suscripción y pagos en la plataforma",
  "settings.notificationsComingSoonDesc": "Las preferencias de notificación llegarán en una futura actualización.",
  "settings.notificationsTitle": "Configuración de Notificaciones",
  "settings.notificationsSubtitle": "Ver cómo recibes las notificaciones",
  "settings.securityComingSoonDesc": "Las configuraciones de seguridad y control de acceso llegarán en una futura actualización.",
  "settings.securityAccessTitle": "Seguridad y Acceso",
  "settings.securityAccessSubtitle": "Administra las configuraciones de seguridad y acceso",
  "settings.applicationTitle": "Aplicación",
  "settings.applicationSubtitle": "Instala CondoGestión para una experiencia más rápida y similar a una app",
  "settings.appVersionTitle": "Versión de la App",
  "settings.appVersionSubtitle": "Busca actualizaciones y administra la versión de la app",
  "settings.accountSecurityTitle": "Seguridad de la Cuenta",
  "settings.accountSecuritySubtitle": "Actualiza tu contraseña para mantener tu cuenta segura",
  "settings.maintenanceSubtitle": "Administra cachés y revisa el manifiesto",
  "settings.readOnlyEmail": "Correo (solo lectura)",
  "settings.saveProfile": "Guardar Perfil",
  "settings.planUsage": "Uso del plan",
  "settings.unitsUsed": "{used} de {total} unidades usadas",
  "settings.percentUsed": "{percent}% usado",
  "settings.remainingUnits": "{count} restantes",
  "settings.low": "Bajo",
  "settings.unitsLimitReached": "Has alcanzado el límite de unidades. Por favor, contacta a soporte para mejorar tu plan.",
  "settings.subscriptionStatus.trial": "Prueba",
  "settings.subscriptionStatus.active": "Activo",
  "settings.subscriptionStatus.suspended": "Suspendido",
  "settings.subscriptionStatus.cancelled": "Cancelado",
  "settings.subscriptionStatus.expired": "Expirado",
  "settings.paymentDetailsVerified": "Tus detalles de pago han sido verificados por Urbe360",
  "settings.bankTransferDetails": "Detalles de Transferencia Bancaria",
  "settings.accountNumberPlaceholder": "Número de cuenta",
  "settings.routingPlaceholder": "Número de ruta",
  "settings.accountHolderName": "Nombre del Titular de la Cuenta",
  "settings.accountHolderPlaceholder": "Nombre en la cuenta",
  "settings.zelleEmail": "Correo Zelle",
  "settings.zellePhone": "Teléfono Zelle",
  "settings.zelleEmailPlaceholder": "zelle@ejemplo.com",
  "settings.cashInstructionsTitle": "Instrucciones de Efectivo",
  "settings.instructions": "Instrucciones",
  "settings.cashInstructionsPlaceholder": "Instrucciones para recibir pagos en efectivo...",
  "settings.otherPaymentMethods": "Otros Métodos de Pago",
  "settings.paypalEmail": "Correo PayPal",
  "settings.paypalEmailPlaceholder": "paypal@ejemplo.com",
  "settings.venmoUsername": "Usuario Venmo",
  "settings.venmoPlaceholder": "@usuario",
  "settings.cashAppUsername": "Usuario Cash App",
  "settings.cashAppPlaceholder": "$usuario",
  "settings.updatePaymentDetails": "Actualizar Detalles de Pago",
  "settings.createPaymentDetails": "Crear Detalles de Pago",
  "settings.billingCycleMonthly": "/ mes",
  "settings.billingCycleQuarterly": "/ trimestre",
  "settings.billingCycleAnnual": "/ año",
  "settings.invoiceStatus.pendingPayment": "Pago Pendiente",
  "settings.invoiceStatus.pendingVerification": "Verificación Pendiente",
  "settings.invoiceStatus.completed": "Completado",
  "settings.invoiceStatus.rejected": "Rechazado",
  "settings.invoiceStatus.cancelled": "Cancelado",
  "settings.sendAmountToFollowing": "Envía ${amount} a uno de los siguientes:",
  "settings.contactPlatformAdminForPayment": "Contacta al administrador de la plataforma para detalles de pago.",
  "settings.copy": "Copiar",
  "settings.plan": "Plan",
  "settings.rejectedReason": "Rechazado",
  "settings.paymentMethod.bankTransfer": "Transferencia Bancaria",
  "settings.paymentMethod.zelle": "Zelle",
  "settings.paymentMethod.paypal": "PayPal",
  "settings.paymentMethod.cardStripe": "Tarjeta / Stripe",
  "settings.paymentMethod.pagoMovil": "Pago Móvil",
  "settings.paymentMethod.cash": "Efectivo",
  "settings.appInstalled": "La app está instalada en este dispositivo.",
  "settings.howToInstallIOS": "Cómo instalar en iPhone/iPad",
  "settings.iosInstallTip": "Safari en iOS no muestra un aviso nativo de instalación. Compartir -> Añadir a pantalla de inicio.",
  "settings.installApplication": "Instalar la aplicación",
  "settings.waitingBrowserInstall": "Esperando a que el navegador permita la instalación...",
  "settings.installTip": "Consejo: usa el menú del navegador (⋮ / ... -> Instalar app) si el botón está deshabilitado.",
  "settings.quickRepairConfirm": "La reparación rápida limpiará cachés y service workers, y luego recargará. ¿Continuar?",
  "settings.quickRepairFailed": "La reparación rápida falló. Revisa la consola para más detalles.",
  "settings.fullRepairConfirm": "ADVERTENCIA: La reparación completa borrará TODOS los datos de la app, incluyendo sesión, cachés y almacenamiento. Tendrás que iniciar sesión de nuevo. ¿Continuar?",
  "settings.repairCompletedWithErrors": "Reparación completada con {count} error(es). Revisa la consola para más detalles.",
  "settings.fullRepairFailed": "La reparación completa falló. Revisa la consola para más detalles.",
  "settings.appVersionLabel": "Versión de App",
  "settings.buildTime": "Tiempo de Compilación",
  "settings.swSupported": "SW Soportado",
  "settings.swRegistered": "SW Registrado",
  "settings.swActive": "SW Activo",
  "settings.swController": "SW Controlador",
  "settings.swUpdateAvailable": "Actualización de SW Disponible",
  "settings.appInfoError": "No se pudo obtener la info de la app. Revisa la consola.",
  "settings.quickRepairTitle": "Reparación rápida: limpiar cachés y service workers",
  "settings.repairing": "Reparando...",
  "settings.quickRepair": "Reparación Rápida",
  "settings.fullRepairTitle": "Reparación completa: borrar todos los datos de la app (requiere iniciar sesión de nuevo)",
  "settings.fullRepair": "Reparación Completa",
  "settings.appInfoTitle": "Ver versión de la app y estado del service worker",
  "settings.viewManifest": "Ver manifiesto",
  "settings.renewSubscription": "Renovar Suscripción",
  "settings.renewPlanFor": "Renueva tu plan de cupos por ${price}.",
  "settings.currentRenewalDate": "Fecha de renovación actual",
  "settings.renewNow": "Renovar ahora (iniciar siguiente ciclo inmediatamente)",
  "settings.renewNextPeriod": "Renovar para el próximo período (mantener ciclo actual)",
  "settings.processing": "Procesando...",
  "settings.proceed": "Proceder",
  "settings.updateAvailableToast": "¡Actualización disponible! Haz clic en 'Actualizar Ahora' para instalar.",
  "settings.latestVersionToast": "¡Estás usando la última versión!",
  "settings.checkUpdatesError": "Error al buscar actualizaciones",
  "settings.updatingApp": "Actualizando app...",
  "settings.updateError": "Error al actualizar. Por favor, actualiza manualmente.",
  "settings.currentVersion": "Versión Actual",
  "settings.buildLabel": "Compilación",
  "settings.newVersionAvailable": "Nueva versión disponible",
  "settings.checking": "Buscando...",
  "settings.checkForUpdates": "Buscar Actualizaciones",
  "settings.updating": "Actualizando...",
  "settings.updateNow": "Actualizar Ahora",
  "settings.autoUpdateInfo": "La app busca actualizaciones automáticamente cada 60 segundos. Cuando haya una actualización disponible, verás un banner en la parte inferior de la pantalla.",

  // Common
  "common.loading": "Cargando...",
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.delete": "Eliminar",
  "common.edit": "Editar",
  "common.create": "Crear",
  "common.search": "Buscar",
  "common.filter": "Filtrar",
  "common.all": "Todos",
  "common.yes": "Sí",
  "common.no": "No",
  "common.confirm": "Confirmar",
  "common.back": "Volver",
  "common.next": "Siguiente",
  "common.submit": "Enviar",
  "common.close": "Cerrar",
  "common.view": "Ver",
  "common.hide": "Ocultar",
  "common.reset": "Restablecer",
  "common.dismiss": "Descartar",
  "common.verifying": "Verificando...",
  "common.sending": "Enviando...",
  "common.import": "Importar",
  "common.sortBy": "Ordenar por",
  "common.viewDetails": "Ver detalles",
  "common.saveChanges": "Guardar cambios",
  "common.saving": "Guardando...",
  "common.error": "Error",
  "common.success": "Éxito",
  "common.warning": "Advertencia",
  "common.info": "Información",
  "common.noResults": "No se encontraron resultados",
  "common.required": "Requerido",
  "common.optional": "Opcional",
  "common.actions": "Acciones",
  "common.status": "Estado",
  "common.date": "Fecha",
  "common.amount": "Monto",
  "common.total": "Total",
  "common.details": "Detalles",
  "common.description": "Descripción",
  "common.title": "Título",
  "common.content": "Contenido",
  "common.name": "Nombre",
  "common.email": "Correo electrónico",
  "common.phone": "Teléfono",
  "common.address": "Dirección",
  "common.unit": "Unidad",
  "common.building": "Edificio",
  "common.password": "Contraseña",
  "common.logout": "Cerrar sesión",
  "common.login": "Iniciar sesión",
  "common.register": "Registrarse",
  "common.or": "o",
  "common.and": "y",
  "common.priority": "Prioridad",
  "common.priority.low": "Baja",
  "common.priority.medium": "Media",
  "common.priority.high": "Alta",
  "common.priority.urgent": "Urgente",
  "common.unknown": "Desconocido",
  "common.refresh": "Actualizar",
  "common.refreshing": "Actualizando...",
  "common.working": "Trabajando...",
  "common.none": "Ninguno",
  "common.na": "N/D",
  "common.role": "Rol",

  // Auth
  "auth.login": "Iniciar sesión",
  "auth.loginTitle": "Bienvenido de nuevo",
  "auth.loginSubtitle": "Inicia sesión en tu cuenta",
  "auth.email": "Correo electrónico",
  "auth.password": "Contraseña",
  "auth.forgotPassword": "¿Olvidaste tu contraseña?",
  "auth.noAccount": "¿No tienes una cuenta?",
  "auth.hasAccount": "¿Ya tienes una cuenta?",
  "auth.signUp": "Registrarse",
  "auth.signIn": "Iniciar sesión",
  "auth.rememberMe": "Recordarme",
  "auth.invalidCredentials": "Correo o contraseña inválidos",
  "auth.logoutSuccess": "Has cerrado sesión",
  "auth.sessionExpired": "Tu sesión ha expirado. Por favor inicia sesión de nuevo.",
  "auth.loggingOut": "Cerrando sesión...",
  "auth.adminAccessTitle": "Acceso de administrador",
  "auth.superAdminAccess": "Inicio de sesión Súper Admin - Acceso restringido",
  "auth.emailOrId": "Correo o ID",
  "auth.adminEmailPlaceholder": "admin@example.com",
  "auth.emailPlaceholder": "tu@email.com",
  "auth.confirmPassword": "Confirmar contraseña",
  "auth.showPassword": "Mostrar contraseña",
  "auth.hidePassword": "Ocultar contraseña",
  "auth.signingIn": "Iniciando sesión…",
  "auth.redirecting": "Redirigiendo…",
  "auth.signInAdmin": "Iniciar sesión como admin",
  "auth.backToLogin": "← Volver al inicio de sesión",
  "auth.signInError": "No se pudo iniciar sesión. Verifica tus credenciales e inténtalo de nuevo.",
  "auth.accountNotResident": "Esta cuenta no es de residente. Usa la pestaña de administrador HOA.",
  "auth.hoaLoginHint": "Usa las credenciales proporcionadas por el administrador de tu edificio.",
  "auth.residentPasswordHint": "Inicia sesión con la contraseña de tu cuenta de residente.",
  "auth.residentOtpHint": "Inicia sesión con tu correo para recibir un código OTP.",
  "auth.loginWithPassword": "Iniciar sesión con contraseña",
  "auth.keepSignedIn": "Mantener sesión iniciada",
  "auth.otpInfo": "Recibirás un código OTP por correo para completar el inicio de sesión.",
  "auth.continue": "Continuar",
  "auth.continueWithOtp": "Continuar con OTP",
  "auth.demoCredentials": "Credenciales de demo",
  "auth.demoAdminLabel": "Admin:",
  "auth.passwordResetTitle": "Reset password",
  "auth.passwordResetSubtitle": "The new password will work for all properties linked to your email.",
  "auth.sendResetCode": "Send reset code",
  "auth.sending": "Sending…",
  "auth.verificationCode": "Verification code",
  "auth.verifyCode": "Verify code",
  "auth.verifying": "Verifying…",
  "auth.newPassword": "New password",
  "auth.resetPassword": "Reset password",
  "auth.resetting": "Resetting…",
  "auth.passwordInvalid": "Password does not meet the requirements.",
  "auth.passwordMismatch": "Passwords do not match.",
  "auth.passwordReqLength": "At least 8 characters",
  "auth.passwordReqLetter": "At least one letter",
  "auth.passwordReqNumber": "At least one number",
  "auth.unableToRequestReset": "Unable to send the reset code.",
  "auth.unableToVerify": "Unable to verify the code.",
  "auth.unableToReset": "Unable to reset the password.",

  // Navigation
  "nav.home": "Inicio",
  "nav.dashboard": "Panel",
  "nav.announcements": "Anuncios",
  "nav.payments": "Pagos",
  "nav.polls": "Encuestas",
  "nav.issues": "Incidencias",
  "nav.profile": "Perfil",
  "nav.settings": "Configuración",
  "nav.news": "Noticias",
  "nav.members": "Miembros",
  "nav.invoice": "Factura",
  "nav.comms": "Comunicaciones",
  "nav.hoas": "HOAs",
  "nav.residents": "Residentes",
  "nav.units": "Unidades",
  "nav.buildings": "Edificios",
  "nav.reports": "Reportes",
  "nav.admin": "Admin",

  // Roles
  "roles.resident": "Residente",
  "roles.hoaAdmin": "Administrador",
  "roles.hoaAdminFull": "Admin HOA",
  "roles.superAdmin": "Súper Admin",

  // Layout titles
  "resident.title.announcements": "Anuncios",
  "resident.title.polls": "Encuestas de la comunidad",
  "resident.title.issues": "Reportes de incidencias",
  "resident.title.payments": "Mis pagos",
  "resident.title.profile": "Perfil y configuración",
  "resident.title.dashboard": "Panel",
  "hoa.layout.console": "Consola HOA",
  "hoa.layout.titles.members": "Gestión de miembros",
  "hoa.layout.titles.payments": "Pagos y facturas",
  "hoa.layout.titles.communications": "Comunicaciones",
  "hoa.layout.titles.reports": "Reportes y analíticas",
  "superAdmin.layout.console": "Consola de plataforma",
  "superAdmin.layout.titles.hoaAdmins": "Administradores HOA",
  "superAdmin.layout.titles.payments": "Bandeja de pagos",

  // HOA Dashboard
  "common.allCondos": "Todos los condominios",
  "common.comingSoon": "Próximamente",
  "common.inDevelopment": "En Desarrollo",
  "hoa.dashboard.announcementsComing": "El módulo de noticias y comunicados está en desarrollo.",
  "hoa.dashboard.pollsComing": "El módulo de votaciones activas está en desarrollo.",
  "hoa.dashboard.greeting": "Hola, {name}!",
  "hoa.dashboard.subtitle": "Consola HOA • Métricas en vivo y actividad reciente",
  "hoa.dashboard.overview": "Resumen",
  "hoa.dashboard.units": "Unidades",
  "hoa.dashboard.residents": "Residentes",
  "hoa.dashboard.openIssues": "Incidencias abiertas",
  "hoa.dashboard.pendingPayments": "Pagos pendientes",
  "hoa.dashboard.quick.create": "Crear",
  "hoa.dashboard.quick.start": "Iniciar",
  "hoa.dashboard.quick.review": "Revisar",
  "hoa.dashboard.quick.log": "Registrar",
  "hoa.dashboard.quick.announcement": "Anuncio",
  "hoa.dashboard.quick.poll": "Encuesta",
  "hoa.dashboard.quick.payments": "Pagos",
  "hoa.dashboard.quick.issue": "Incidencia",
  "hoa.dashboard.recentAnnouncements": "Anuncios recientes",
  "hoa.dashboard.shown": "{count} mostrados",
  "hoa.dashboard.updatedJustNow": "Actualizado hace un momento",
  "hoa.dashboard.noAnnouncements": "Aún no hay anuncios.",
  "hoa.dashboard.viewAll": "Ver todo",
  "hoa.dashboard.activePolls": "Encuestas activas",
  "hoa.dashboard.liveScheduled": "En vivo y programadas",
  "hoa.dashboard.noPolls": "No hay encuestas en vivo o programadas.",
  "hoa.dashboard.status.live": "En vivo",
  "hoa.dashboard.status.scheduled": "Programada",
  "hoa.dashboard.ends": "Termina {date}",
  "hoa.dashboard.totalVotes": "Total de votos",
  "hoa.dashboard.manage": "Gestionar",
  "hoa.dashboard.openPolls": "Abrir encuestas",
  "hoa.dashboard.issues": "Incidencias",
  "hoa.dashboard.openCount": "{count} abiertas",
  "hoa.dashboard.pending": "Pendiente",
  "hoa.dashboard.inProgress": "En progreso",
  "hoa.dashboard.resolvedThisWeek": "Resueltas esta semana: {count}",
  "hoa.dashboard.openBoard": "Abrir tablero",
  "hoa.dashboard.payments": "Pagos",
  "hoa.dashboard.pendingProofs": "{count} pendientes",
  "hoa.dashboard.thisMonth": "Este mes",
  "hoa.dashboard.approvedThisWeek": "Aprobadas esta semana",
  "hoa.dashboard.rejectedThisWeek": "Rechazadas esta semana",
  "hoa.dashboard.collectedThisMonth": "Recaudado este mes",
  "hoa.dashboard.reviewPayments": "Revisar pagos",
  "hoa.dashboard.mock.announcements.a101.title": "Mantenimiento del ascensor el viernes",
  "hoa.dashboard.mock.announcements.a101.message": "El ascensor B estará en servicio técnico de 9am a 2pm. Planifique con anticipación.",
  "hoa.dashboard.mock.announcements.a102.title": "Reunión comunitaria",
  "hoa.dashboard.mock.announcements.a102.message": "Reunión mensual de la HOA el sábado a las 7pm en el salón comunitario.",
  "hoa.dashboard.mock.announcements.a103.title": "Recordatorio de horario de piscina",
  "hoa.dashboard.mock.announcements.a103.message": "Piscina abierta todos los días de 6am a 10pm.",
  "hoa.dashboard.mock.polls.p201.title": "Compra de equipos para el gimnasio",
  "hoa.dashboard.mock.polls.p202.title": "Actualización de reglas de estacionamiento",
  "hoa.dashboard.mock.polls.p202.options.approve": "Aprobar",
  "hoa.dashboard.mock.polls.p202.options.reject": "Rechazar",

  // HOA Announcements
  "hoa.announcements.toast.created": "¡Anuncio publicado exitosamente!",
  "hoa.announcements.toast.createFailed": "No se pudo crear el anuncio",
  "hoa.announcements.toast.updated": "¡Anuncio actualizado exitosamente!",
  "hoa.announcements.toast.updateFailed": "No se pudo actualizar el anuncio",
  "hoa.announcements.toast.deleted": "¡Anuncio eliminado exitosamente!",
  "hoa.announcements.toast.deleteFailed": "No se pudo eliminar el anuncio",
  "hoa.announcements.count": "{count} anuncios",
  "hoa.announcements.createTitle": "Crear anuncio",
  "hoa.announcements.new": "Nuevo anuncio",
  "hoa.announcements.createNew": "Crear nuevo anuncio",
  "hoa.announcements.titlePlaceholder": "Título del anuncio...",
  "hoa.announcements.contentPlaceholder": "Detalles del anuncio...",
  "hoa.announcements.pinToTop": "Fijar arriba",
  "hoa.announcements.publishDate": "Fecha de publicación",
  "hoa.announcements.expiresOptional": "Expira (opcional)",
  "hoa.announcements.publishing": "Publicando...",
  "hoa.announcements.publish": "Publicar anuncio",
  "hoa.announcements.pinned": "Fijado",
  "hoa.announcements.postedBy": "Publicado por {name}",
  "hoa.announcements.expiresOn": "Expira {date}",
  "hoa.announcements.empty": "Aún no hay anuncios",
  "hoa.announcements.editTitle": "Editar anuncio",
  "hoa.announcements.deleteTitle": "¿Eliminar anuncio?",
  "hoa.announcements.deleteMessage": "\"{title}\" se eliminará permanentemente. Esta acción no se puede deshacer.",
  "hoa.announcements.deleting": "Eliminando...",

  // HOA Payments
  "hoa.payments.title": "Pagos y Facturas",
  "hoa.payments.subtitle": "Administre facturas, realice seguimiento de pagos y confirme transferencias.",
  "hoa.payments.tabs.invoices": "Facturas",
  "hoa.payments.bcv.title": "Tasa de Cambio BCV",
  "payments.rateValidAsOf": "Tasa vigente al {date} (BCV: {rate} Bs./USD)",
  "payments.bcvRateAsOf": "Tasa BCV: {rate}Bs. (al {date})",
  "payments.bcvRateNormal": "Tasa BCV {rate} Bs./USD · {date}",
  "payments.bcvRateCompact": "BCV {rate} · {date}",
  "hoa.payments.bcv.perUsd": "por 1 USD",
  "hoa.payments.bcv.updated": "Actualizado: {date}",
  "hoa.payments.bcv.loading": "Cargando tasa...",
  "hoa.payments.bcv.failed": "Error al cargar tasa",
  "hoa.payments.bcv.rateInline": "BCV: {rate} Bs./USD",
  "hoa.payments.bcv.rateLine": "Tasa BCV: {rate} Bs./USD",
  "hoa.payments.bcv.unavailable": "Tasa BCV no disponible",
  "hoa.payments.bcv.refresh": "Actualizar",
  "hoa.payments.bcv.refreshing": "Actualizando...",
  "hoa.payments.searchPlaceholder": "Buscar residente, unidad o notas...",
  "hoa.payments.period": "Período",
  "hoa.payments.period.this": "Este Mes",
  "hoa.payments.period.last": "Mes Pasado",
  "hoa.payments.period.all": "Todo el Tiempo",
  "hoa.payments.status": "Estado",
  "hoa.payments.status.all": "Todos los Estados",
  "hoa.payments.status.draft": "Borrador",
  "hoa.payments.status.sent": "Enviado",
  "hoa.payments.status.unpaid": "No Pagado",
  "hoa.payments.status.partiallyPaid": "Pago Parcial",
  "hoa.payments.status.pendingVerification": "Verificación Pendiente",
  "hoa.payments.status.pendingHoaTransfer": "Transferencia HOA Pendiente",
  "hoa.payments.status.paid": "Pagado",
  "hoa.payments.status.cancelled": "Cancelado",
  "hoa.payments.statusLabel.draft": "Borrador",
  "hoa.payments.statusLabel.cancelled": "Cancelado",
  "hoa.payments.statusLabel.residentPaid": "Residente pagó (Urbe360 revisando)",
  "hoa.payments.statusLabel.urbe360Verified": "Urbe360 verificó (transfiriendo a HOA)",
  "hoa.payments.statusLabel.urbe360PaidHoa": "Urbe360 pagó HOA (esperando confirmación)",
  "hoa.payments.statusLabel.completed": "Pago confirmado",
  "hoa.payments.statusLabel.overdue": "Vencido del residente",
  "hoa.payments.statusLabel.waiting": "Esperando pago del residente",
  "hoa.payments.statusSubtitle.draft": "Factura aún no enviada al residente.",
  "hoa.payments.statusSubtitle.cancelled": "Factura cancelada.",
  "hoa.payments.statusSubtitle.residentPaid": "Residente afirma pago a Urbe360. En revisión.",
  "hoa.payments.statusSubtitle.urbe360Verified": "Pago verificado por Urbe360. Fondos transfiriéndose a HOA.",
  "hoa.payments.statusSubtitle.urbe360PaidHoa": "Urbe360 le ha enviado los fondos. Por favor confirme.",
  "hoa.payments.statusSubtitle.completed": "Usted confirmó que recibió el pago.",
  "hoa.payments.statusSubtitle.overdue": "Pago del residente está vencido.",
  "hoa.payments.statusSubtitle.waiting": "Factura enviada, esperando que residente pague a Urbe360.",
  "hoa.payments.statusSubtitle.partiallyPaid": "Se recibió parte del saldo. Aún queda un saldo pendiente.",
  "hoa.payments.sortBy.amount": "Monto",
  "hoa.payments.sortBy.dueDate": "Fecha de Vencimiento",
  "hoa.payments.sortBy.updatedAt": "Actualizado",
  "hoa.payments.noResults": "No hay facturas que coincidan con sus filtros.",
  "hoa.payments.createInvoice": "Crear Factura",
  "hoa.payments.bulkCreate": "Crear en Lote",
  "hoa.payments.table.unit": "Unidad",
  "hoa.payments.table.resident": "Residente",
  "hoa.payments.table.period": "Período",
  "hoa.payments.table.amount": "Monto",
  "hoa.payments.table.dueDate": "Vencimiento",
  "hoa.payments.table.status": "Estado",
  "hoa.payments.table.updated": "Actualizado",
  "hoa.payments.table.actions": "Acciones",
  "hoa.payments.viewProofs": "Ver Comprobantes",
  "hoa.payments.confirmReceipt": "Confirmar Recepción",
  "hoa.payments.viewDetails": "Ver Detalles",
  "hoa.payments.finalize": "Finalizar",
  "hoa.payments.recordCash": "Registrar efectivo",
  "hoa.payments.openInNewTab": "Abrir en nueva pestaña",
  "hoa.payments.tooltip.createSingle": "Crear una sola factura",
  "hoa.payments.tooltip.bulkGenerate": "Generar facturas en lote",
  "hoa.payments.tooltip.bulkReminder": "Enviar recordatorios a todas las facturas vencidas",
  "hoa.payments.tooltip.refreshRate": "Actualizar tasa BCV",
  "hoa.payments.tooltip.viewProofs": "Ver comprobantes de pago",
  "hoa.payments.tooltip.viewDetails": "Ver detalles de la factura",
  "hoa.payments.tooltip.finalize": "Finalizar y confirmar recepción",
  "hoa.payments.tooltip.recordCash": "Marcar como recibido en efectivo",
  "hoa.payments.tooltip.delete": "Eliminar factura",
  "hoa.payments.edit": "Editar",
  "hoa.payments.delete": "Eliminar",
  "hoa.payments.modal.createTitle": "Crear Factura",
  "hoa.payments.modal.editTitle": "Editar Factura",
  "hoa.payments.modal.bulkTitle": "Crear Facturas en Lote",
  "hoa.payments.modal.deleteTitle": "¿Eliminar Factura?",
  "hoa.payments.modal.deleteMessage": "Esto eliminará permanentemente la factura de {resident}. Esto no se puede deshacer.",
  "hoa.payments.modal.deleteMessageWithPeriod": "Esto eliminará permanentemente la factura de {resident} ({period}). Esto no se puede deshacer.",
  "hoa.payments.modal.deleting": "Eliminando...",
  "hoa.payments.modal.confirmTitle": "Confirmar Recepción de Pago",
  "hoa.payments.modal.confirmMessage": "¿Ha recibido el pago de Urbe360?",
  "hoa.payments.modal.confirmButton": "Sí, lo recibí",
  "hoa.payments.modal.confirming": "Confirmando...",
  "hoa.payments.modal.proofsTitle": "Comprobantes de Pago",
  "hoa.payments.modal.detailsTitle": "Detalles del Pago",
  "hoa.payments.form.resident": "Residente",
  "hoa.payments.form.selectResident": "Seleccione un residente",
  "hoa.payments.form.searchResident": "Buscar residentes...",
  "hoa.payments.form.searchResidentByNameEmailUnit": "Buscar por nombre, correo o unidad...",
  "hoa.payments.form.unit": "Unidad",
  "hoa.payments.form.selectUnit": "Seleccione una unidad",
  "hoa.payments.form.noUnit": "Sin unidad",
  "hoa.payments.form.errors.selectResidentOrUnit": "Seleccione un residente o una unidad.",
  "hoa.payments.form.period": "Período (AAAA-MM)",
  "hoa.payments.form.dueDate": "Fecha de Vencimiento",
  "hoa.payments.form.amountSource": "Fuente del Monto",
  "hoa.payments.form.amountSource.fixed": "Monto Fijo",
  "hoa.payments.form.amountSource.unitRent": "Renta Mensual de la Unidad",
  "hoa.payments.form.baseAmount": "Monto Base (USD)",
  "hoa.payments.form.credits": "Créditos (USD)",
  "hoa.payments.form.total": "Total",
  "hoa.payments.form.description": "Descripción (opcional)",
  "hoa.payments.form.descriptionPlaceholder": "Agregue notas sobre esta factura...",
  "hoa.payments.form.status": "Estado",
  "hoa.payments.form.paymentMethod": "Método de Pago",
  "hoa.payments.form.paymentMethod.stripe": "Stripe / Tarjeta",
  "hoa.payments.form.paymentMethod.bank": "Transferencia Bancaria",
  "hoa.payments.form.paymentMethod.zelle": "Zelle",
  "hoa.payments.form.paymentMethod.pagoMovil": "Pago Móvil",
  "hoa.payments.form.paymentMethod.cash": "Efectivo",
  "hoa.payments.form.notes": "Notas (opcional)",
  "hoa.payments.form.notesPlaceholder": "Agregue notas sobre este pago...",
  "hoa.payments.form.creating": "Creando factura...",
  "hoa.payments.form.updating": "Actualizando factura...",
  "hoa.payments.form.selectPeriod": "Seleccionar período",
  "hoa.payments.bulk.building": "Edificio",
  "hoa.payments.bulk.selectBuilding": "Seleccione un edificio",
  "hoa.payments.bulk.allBuildings": "Todos los edificios",
  "hoa.payments.bulk.subtitle": "Cree múltiples facturas de una vez",
  "hoa.payments.bulk.allUnits": "Todas las Unidades",
  "hoa.payments.bulk.selectedUnits": "{count} seleccionadas",
  "hoa.payments.bulk.selectedSummary": "{selected} de {total} seleccionadas",
  "hoa.payments.bulk.selectedInvoices": "{count} factura(s) seleccionada(s)",
  "hoa.payments.bulk.notesPlaceholder": "Nota opcional para todas las facturas generadas",
  "hoa.payments.bulk.noResidentsFound": "No se encontraron residentes",
  "hoa.payments.bulk.period": "Período de Facturación",
  "hoa.payments.bulk.dueDate": "Fecha de Vencimiento",
  "hoa.payments.bulk.useUnitRent": "Usar renta mensual de cada unidad",
  "hoa.payments.bulk.fixedAmount": "Usar monto fijo para todas",
  "hoa.payments.bulk.creating": "Creando {count} facturas...",
  "hoa.payments.bulk.generating": "Generando...",
  "hoa.payments.bulk.generate": "Generar",
  "hoa.payments.bulk.success": "Se crearon {count} facturas exitosamente",
  "hoa.payments.bulk.skippedNoFee": "Omitidas (sin cuota/renta): {count}",
  "hoa.payments.bulk.skippedExisting": "Omitidas existentes: {count}",
  "hoa.payments.bulk.errors.alreadyExists": "Algunas facturas ya existen para los residentes y período seleccionados.",
  "hoa.payments.bulk.failed": "Error al crear facturas",
  "hoa.payments.incoming.title": "Pagos Entrantes",
  "hoa.payments.incoming.subtitle": "Pagos esperando su confirmación",
  "hoa.payments.incoming.empty": "No hay confirmaciones pendientes",
  "hoa.payments.incoming.emptyHelp": "Las transferencias entrantes de Urbe360 aparecerán aquí para su confirmación.",
  "hoa.payments.incoming.loading": "Cargando pagos entrantes...",
  "hoa.payments.incoming.pendingConfirmation": "Confirmación pendiente",
  "hoa.payments.incoming.detailsTitle": "Detalles del pago entrante",
  "hoa.payments.incoming.totalAmount": "Monto total",
  "hoa.payments.incoming.residentPaymentMethod": "Método de pago del residente",
  "hoa.payments.incoming.forwardingInfo": "Información de transferencia",
  "hoa.payments.incoming.forwardedBy": "Transferido por",
  "hoa.payments.incoming.forwardedAt": "Transferido el",
  "hoa.payments.incoming.forwardedByLabel": "Transferido por",
  "hoa.payments.incoming.forwardedByOn": "Transferido por {name} el {date}",
  "hoa.payments.incoming.paymentMethodUsed": "Método de pago usado",
  "hoa.payments.incoming.yourPaymentAccount": "Su cuenta de pago",
  "hoa.payments.incoming.fundsTransferredHere": "Los fondos fueron transferidos a esta cuenta HOA.",
  "hoa.payments.incoming.count": "{count} pago(s) esperando confirmación",
  "hoa.payments.toast.created": "Factura creada exitosamente",
  "hoa.payments.toast.createFailed": "Error al crear factura",
  "hoa.payments.toast.updated": "Factura actualizada exitosamente",
  "hoa.payments.toast.updateFailed": "Error al actualizar factura",
  "hoa.payments.toast.deleted": "Factura eliminada exitosamente",
  "hoa.payments.toast.deleteFailed": "Error al eliminar factura",
  "hoa.payments.toast.confirmed": "Pago confirmado exitosamente",
  "hoa.payments.toast.confirmFailed": "Error al confirmar pago",
  "hoa.payments.toast.cashRecorded": "Pago en efectivo registrado exitosamente",
  "hoa.payments.toast.cashRecordFailed": "Error al registrar pago en efectivo",
  "hoa.payments.toast.manualRecorded": "Pago registrado exitosamente",
  "hoa.payments.toast.manualRecordFailed": "Error al registrar el pago",
  "hoa.payments.manual.title": "Registrar pago manualmente",
  "hoa.payments.manual.method": "Método de pago",
  "hoa.payments.manual.proofRequired": "Comprobante de transacción (obligatorio)",
  "hoa.payments.manual.referenceOptional": "Referencia bancaria (opcional)",
  "hoa.payments.manual.referencePlaceholder": "ej., número de confirmación o referencia",
  "hoa.payments.manual.notesOptional": "Notas (opcional)",
  "hoa.payments.manual.notesPlaceholder": "Agregue notas opcionales para este pago...",
  "hoa.payments.manual.recording": "Registrando pago...",
  "hoa.payments.manual.submit": "Registrar pago",
  "hoa.payments.manual.remainingBalance": "Saldo pendiente",
  "hoa.payments.manual.paymentDate": "Fecha de pago",
  "hoa.payments.manual.amountUsd": "Monto (USD)",
  "hoa.payments.manual.amountVes": "Monto (VES)",
  "hoa.payments.manual.rateHint": "Convertido a",
  "hoa.payments.manual.rateForDate": "Tasa BCV del {date}",
  "hoa.payments.manual.rateCarried": "sin publicación ese día; se arrastra {days} día(s)",
  "hoa.payments.manual.rateMissing": "No hay tasa BCV registrada para esa fecha. Ingresa el monto en USD directamente, o elige otra fecha.",
  "hoa.payments.errors.invoiceExistsForUnitPeriod": "Ya existe una factura para este residente/unidad y período.",
  "hoa.payments.errors.retryDifferentValues": "Intente con un residente, unidad o período diferente.",
  "hoa.payments.card.unit": "Unidad {unit}",
  "hoa.payments.card.resident": "Residente: {name}",
  "hoa.payments.card.due": "Vence: {date}",
  "hoa.payments.details.invoice": "Detalles de Factura",
  "hoa.payments.details.resident": "Residente",
  "hoa.payments.details.residentEmail": "Correo del residente",
  "hoa.payments.details.unit": "Unidad",
  "hoa.payments.details.period": "Período",
  "hoa.payments.details.invoiceDate": "Fecha de Factura",
  "hoa.payments.details.createdAt": "Creada el",
  "hoa.payments.details.dueDate": "Fecha de Vencimiento",
  "hoa.payments.details.amountPaid": "Monto Pagado",
  "hoa.payments.details.balanceDue": "Saldo Pendiente",
  "hoa.payments.details.updatedAt": "Actualizada el",
  "hoa.payments.details.baseAmount": "Monto Base",
  "hoa.payments.details.credits": "Créditos",
  "hoa.payments.details.totalAmount": "Monto Total",
  "hoa.payments.details.bcvRateFixed": "Tasa BCV (fijada al crear)",
  "hoa.payments.details.bcvRateFixedLine": "{rate} Bs./USD · {date}",
  "hoa.payments.details.status": "Estado",
  "hoa.payments.details.flow": "Flujo de pago",
  "hoa.payments.details.paymentMethod": "Método de Pago",
  "hoa.payments.details.cashNotesOptional": "Notas de pago en efectivo (opcional)",
  "hoa.payments.details.cashNotesPlaceholder": "Agregue notas opcionales para este pago en efectivo...",
  "hoa.payments.details.recordingCash": "Registrando pago en efectivo...",
  "hoa.payments.details.markedPaidAt": "Marcado Pagado En",
  "hoa.payments.details.verifiedAt": "Verificado En",
  "hoa.payments.details.finalizedAt": "Finalizado En",
  "hoa.payments.details.notes": "Notas",
  "hoa.payments.details.description": "Descripción",
  "hoa.payments.details.noNotes": "Sin notas",
  "hoa.payments.details.noDescription": "Sin descripción",
  "hoa.payments.proofs.loading": "Cargando comprobantes...",
  "hoa.payments.proofs.noProofs": "No hay comprobantes disponibles.",
  "hoa.payments.proofs.residentTransactionProof": "Comprobante de transacción del residente",
  "hoa.payments.proofs.residentIdVerification": "Verificación de identidad del residente",
  "hoa.payments.proofs.residentNotes": "Notas del residente",
  "hoa.payments.proofs.noResidentProofs": "No se cargaron comprobantes del residente.",
  "hoa.payments.proofs.forwardingMethod": "Método de transferencia",
  "hoa.payments.proofs.transferMethod": "Método de transferencia",
  "hoa.payments.proofs.stripePaypal": "Stripe / PayPal",
  "hoa.payments.proofs.forwardingNotes": "Notas de transferencia",
  "hoa.payments.proofs.notesFromUrbe": "Notas de Urbe360",
  "hoa.payments.proofs.transferProof": "Comprobante de transferencia",
  "hoa.payments.proofs.transferProofFromUrbe": "Comprobante de transferencia de Urbe360",
  "hoa.payments.proofs.noTransferProof": "Aún no se cargó comprobante de transferencia.",
  "hoa.payments.proofs.noTransferInfo": "Aún no hay información de transferencia.",

  // HOA Building Details
  "hoa.buildingDetail.backToBuildings": "Volver a Edificios",
  "hoa.buildingDetail.edit": "Editar Edificio",
  "hoa.buildingDetail.delete": "Eliminar Edificio",
  "hoa.buildingDetail.deleteConfirm": "¿Está seguro de que desea eliminar este edificio?",
  "hoa.buildingDetail.deleteWarning": "Esto eliminará permanentemente todas las unidades, residentes y datos asociados. Esta acción no se puede deshacer.",
  "hoa.buildingDetail.deleting": "Eliminando...",
  "hoa.buildingDetail.tabs.overview": "Vista General",
  "hoa.buildingDetail.tabs.units": "Unidades",
  "hoa.buildingDetail.tabs.residents": "Residentes",
  "hoa.buildingDetail.stats.totalUnits": "Total de Unidades",
  "hoa.buildingDetail.stats.totalResidents": "Total de Residentes",
  "hoa.buildingDetail.stats.avgMonthlyFee": "Cuota Mensual Promedio",
  "hoa.buildingDetail.stats.occupancyRate": "Tasa de Ocupación",
  "hoa.buildingDetail.info.buildingCode": "Código de Edificio",
  "hoa.buildingDetail.info.buildingName": "Nombre del Edificio",
  "hoa.buildingDetail.info.address": "Dirección",
  "hoa.buildingDetail.info.city": "Ciudad",
  "hoa.buildingDetail.info.state": "Estado",
  "hoa.buildingDetail.info.postalCode": "Código Postal",
  "hoa.buildingDetail.info.country": "País",
  "hoa.buildingDetail.info.defaultMonthlyFee": "Cuota Mensual Predeterminada",
  "hoa.buildingDetail.info.totalFloors": "Total de Pisos",
  "hoa.buildingDetail.info.created": "Creado",
  "hoa.buildingDetail.units.title": "Unidades",
  "hoa.buildingDetail.units.addUnit": "Agregar Unidad",
  "hoa.buildingDetail.units.importCSV": "Importar CSV",
  "hoa.buildingDetail.units.downloadTemplate": "Descargar Plantilla",
  "hoa.buildingDetail.units.search": "Buscar unidades...",
  "hoa.buildingDetail.units.empty": "No se encontraron unidades. Agregue su primera unidad para comenzar.",
  "hoa.buildingDetail.units.table.number": "Número de Unidad",
  "hoa.buildingDetail.units.table.floor": "Piso",
  "hoa.buildingDetail.units.table.size": "Tamaño (m²)",
  "hoa.buildingDetail.units.table.bedrooms": "Habitaciones",
  "hoa.buildingDetail.units.table.bathrooms": "Baños",
  "hoa.buildingDetail.units.table.monthlyFee": "Cuota Mensual",
  "hoa.buildingDetail.units.table.status": "Estado",
  "hoa.buildingDetail.units.table.resident": "Residente",
  "hoa.buildingDetail.units.table.actions": "Acciones",
  "hoa.buildingDetail.units.status.vacant": "Vacante",
  "hoa.buildingDetail.units.status.occupied": "Ocupado",
  "hoa.buildingDetail.units.status.maintenance": "Mantenimiento",
  "hoa.buildingDetail.units.modal.create": "Crear Unidad",
  "hoa.buildingDetail.units.modal.edit": "Editar Unidad",
  "hoa.buildingDetail.units.modal.delete": "Eliminar Unidad",
  "hoa.buildingDetail.units.modal.deleteConfirm": "¿Está seguro de que desea eliminar esta unidad?",
  "hoa.buildingDetail.units.form.unitNumber": "Número de Unidad",
  "hoa.buildingDetail.units.form.unitCode": "Código de Unidad",
  "hoa.buildingDetail.units.form.floor": "Piso",
  "hoa.buildingDetail.units.form.size": "Tamaño (m²)",
  "hoa.buildingDetail.units.form.bedrooms": "Habitaciones",
  "hoa.buildingDetail.units.form.bathrooms": "Baños",
  "hoa.buildingDetail.units.form.monthlyFee": "Cuota Mensual (USD)",
  "hoa.buildingDetail.units.form.status": "Estado",
  "hoa.buildingDetail.units.form.creating": "Creando...",
  "hoa.buildingDetail.units.form.updating": "Actualizando...",
  "hoa.buildingDetail.residents.title": "Residentes",
  "hoa.buildingDetail.residents.addResident": "Agregar Residente",
  "hoa.buildingDetail.residents.importCSV": "Importar CSV",
  "hoa.buildingDetail.residents.downloadTemplate": "Descargar Plantilla",
  "hoa.buildingDetail.residents.sendOTP": "Enviar OTP",
  "hoa.buildingDetail.residents.selectAll": "Seleccionar Todos",
  "hoa.buildingDetail.residents.deselectAll": "Deseleccionar Todos",
  "hoa.buildingDetail.residents.selected": "{count} seleccionados",
  "hoa.buildingDetail.residents.search": "Buscar residentes...",
  "hoa.buildingDetail.residents.empty": "No se encontraron residentes. Agregue su primer residente para comenzar.",
  "hoa.buildingDetail.residents.emptyUnits": "Cree una unidad primero para agregar residentes",
  "hoa.buildingDetail.residents.table.name": "Nombre",
  "hoa.buildingDetail.residents.table.email": "Correo",
  "hoa.buildingDetail.residents.table.phone": "Teléfono",
  "hoa.buildingDetail.residents.table.unit": "Unidad",
  "hoa.buildingDetail.residents.table.role": "Rol",
  "hoa.buildingDetail.residents.table.balance": "Saldo",
  "hoa.buildingDetail.residents.table.actions": "Acciones",
  "hoa.buildingDetail.residents.role.tenant": "Inquilino",
  "hoa.buildingDetail.residents.role.owner": "Propietario",
  "hoa.buildingDetail.residents.modal.create": "Crear Residente",
  "hoa.buildingDetail.residents.modal.edit": "Editar Residente",
  "hoa.buildingDetail.residents.modal.delete": "Eliminar Residente",
  "hoa.buildingDetail.residents.modal.deleteConfirm": "¿Está seguro de que desea eliminar este residente?",
  "hoa.buildingDetail.residents.form.firstName": "Nombre",
  "hoa.buildingDetail.residents.form.lastName": "Apellido",
  "hoa.buildingDetail.residents.form.email": "Correo",
  "hoa.buildingDetail.residents.form.phone": "Teléfono",
  "hoa.buildingDetail.residents.form.unit": "Unidad",
  "hoa.buildingDetail.residents.form.selectUnit": "Seleccionar una unidad",
  "hoa.buildingDetail.residents.form.role": "Rol",
  "hoa.buildingDetail.residents.form.contactType": "Tipo de Contacto",
  "hoa.buildingDetail.residents.form.currentBalance": "Saldo Actual",
  "hoa.buildingDetail.residents.form.creating": "Creando...",
  "hoa.buildingDetail.residents.form.updating": "Actualizando...",
  "hoa.buildingDetail.toast.unitCreated": "Unidad creada exitosamente",
  "hoa.buildingDetail.toast.unitUpdated": "Unidad actualizada exitosamente",
  "hoa.buildingDetail.toast.unitDeleted": "Unidad eliminada exitosamente",
  "hoa.buildingDetail.toast.unitCreateFailed": "Error al crear unidad",
  "hoa.buildingDetail.toast.unitUpdateFailed": "Error al actualizar unidad",
  "hoa.buildingDetail.toast.unitDeleteFailed": "Error al eliminar unidad",
  "hoa.buildingDetail.toast.residentCreated": "Residente creado exitosamente",
  "hoa.buildingDetail.toast.residentUpdated": "Residente actualizado exitosamente",
  "hoa.buildingDetail.toast.residentDeleted": "Residente eliminado exitosamente",
  "hoa.buildingDetail.toast.residentCreateFailed": "Error al crear residente",
  "hoa.buildingDetail.toast.residentUpdateFailed": "Error al actualizar residente",
  "hoa.buildingDetail.toast.residentDeleteFailed": "Error al eliminar residente",
  "hoa.buildingDetail.toast.otpSent": "OTP enviado exitosamente",
  "hoa.buildingDetail.toast.otpFailed": "Error al enviar OTP",
  "hoa.buildingDetail.toast.buildingDeleted": "Edificio eliminado exitosamente",
  "hoa.buildingDetail.toast.buildingDeleteFailed": "Error al eliminar edificio",

  // HOA Communications
  "hoa.communications.title": "Comunicaciones",
  "hoa.communications.subtitle": "Anuncios, encuestas e incidencias reportadas.",
  "hoa.communications.tabs.announcements": "Anuncios",
  "hoa.communications.tabs.polling": "Encuestas",
  "hoa.communications.tabs.issues": "Incidencias reportadas",

  // HOA Issues (Admin)
  "hoa.issues.subtitle": "Gestiona solicitudes de mantenimiento y actualizaciones de estado.",
  "hoa.issues.new": "Nueva incidencia",
  "hoa.issues.status.pending": "Pendiente",
  "hoa.issues.status.inProgress": "En progreso",
  "hoa.issues.status.resolved": "Resuelta",
  "hoa.issues.searchPlaceholder": "Buscar título, unidad, detalles...",
  "hoa.issues.allPriorities": "Todas las prioridades",
  "hoa.issues.empty": "No se encontraron incidencias",
  "hoa.issues.modal.newTitle": "Nueva incidencia",
  "hoa.issues.modal.editTitle": "Editar incidencia",
  "hoa.issues.deleteTitle": "¿Eliminar incidencia?",
  "hoa.issues.deleteMessage": "\"{title}\" se eliminará permanentemente.",
  "hoa.issues.actions.start": "Iniciar",
  "hoa.issues.actions.resolve": "Resolver",
  "hoa.issues.actions.markResolved": "Marcar como resuelta",
  "hoa.issues.actions.backToPending": "Volver a pendiente",
  "hoa.issues.actions.reopen": "Reabrir",
  "hoa.issues.unit": "Unidad {unit}",
  "hoa.issues.updatedBy": "Actualizado {date} • Abierto por {name}",
  "hoa.issues.titlePlaceholder": "Ej., Fuga de agua en 7C",
  "hoa.issues.descriptionOptional": "Descripción (opcional)",
  "hoa.issues.descriptionPlaceholder": "Describe la incidencia...",
  "hoa.issues.assignUnit": "Asignar unidad (opcional)",
  "hoa.issues.heading": "Incidencias",
  "hoa.issues.allCategories": "Todas las categorías",
  "hoa.issues.loadError": "No se pudieron cargar las incidencias. Inténtalo de nuevo.",
  "hoa.issues.stat.open": "Abiertas",
  "hoa.issues.triage": "Gestión",
  "hoa.issues.clearFilters": "Limpiar filtros",
  "hoa.issues.emptyHint": "Los reportes de los residentes aparecerán aquí en cuanto lleguen.",
  "hoa.issues.emptyFiltered": "Nada coincide con estos filtros",
  "hoa.issues.emptyFilteredHint": "Prueba otro estado, o limpia los filtros para verlo todo.",
  "hoa.issues.deleteFiles": "Sus fotos y documentos también se eliminan del almacenamiento.",
  "hoa.issues.statusNote": "Nota para el próximo cambio de estado (opcional)",
  "hoa.issues.statusNotePlaceholder": "Ej., Plomero agendado para el jueves",
  "hoa.issues.actions.cancel": "Cancelar incidencia",

  // HOA Polls
  "hoa.polls.toast.createdTitle": "Encuesta creada",
  "hoa.polls.toast.createdDesc": "Tu encuesta se creó exitosamente.",
  "hoa.polls.toast.createFailed": "No se pudo crear la encuesta",
  "hoa.polls.toast.updatedTitle": "Encuesta actualizada",
  "hoa.polls.toast.updatedDesc": "Tus cambios se guardaron.",
  "hoa.polls.toast.updateFailed": "No se pudo actualizar la encuesta",
  "hoa.polls.toast.deletedTitle": "Encuesta eliminada",
  "hoa.polls.toast.deletedDesc": "La encuesta fue eliminada.",
  "hoa.polls.toast.deleteFailed": "No se pudo eliminar la encuesta",
  "hoa.polls.toast.closedTitle": "Encuesta cerrada",
  "hoa.polls.toast.closedDesc": "La encuesta se cerró. No se aceptarán más votos.",
  "hoa.polls.toast.closeFailed": "No se pudo cerrar la encuesta",
  "hoa.polls.title": "Encuestas y votaciones",
  "hoa.polls.subtitle": "Crea encuestas, monitorea resultados y gestiona horarios.",
  "hoa.polls.statusSummary": "{live} en vivo • {scheduled} programadas • {closed} cerradas",
  "hoa.polls.new": "Nueva encuesta",
  "hoa.polls.closeTitle": "¿Cerrar encuesta?",
  "hoa.polls.closeMessage": "\"{title}\" se cerrará y no se aceptarán más votos.",
  "hoa.polls.closeAction": "Cerrar encuesta",
  "hoa.polls.deleteTitle": "¿Eliminar encuesta?",
  "hoa.polls.deleteMessage": "\"{title}\" se eliminará permanentemente. Esta acción no se puede deshacer.",
  "hoa.polls.status.live": "En vivo",
  "hoa.polls.status.scheduled": "Programada",
  "hoa.polls.status.closed": "Cerrada",
  "hoa.polls.multipleChoice": "Opción múltiple",
  "hoa.polls.anonymous": "Anónima",
  "hoa.polls.quorum": "{percent}% quórum",
  "hoa.polls.starts": "Inicia: {date}",
  "hoa.polls.ends": "Termina: {date}",
  "hoa.polls.totalVotes": "Total de votos: {count}",
  "hoa.polls.loadingDetails": "Cargando detalles de la encuesta...",
  "hoa.polls.allowMultiple": "Permitir múltiples",
  "hoa.polls.allowChangeVote": "Permitir cambiar voto",
  "hoa.polls.quorumLabel": "Quórum",
  "hoa.polls.eligible": "Elegibles",
  "hoa.polls.startsLabel": "Inicia",
  "hoa.polls.endsLabel": "Termina",
  "hoa.polls.createdBy": "Creado por",
  "hoa.polls.noOptions": "No hay opciones disponibles",
  "hoa.polls.editTitle": "Editar encuesta",
  "hoa.polls.titlePlaceholder": "Título de la encuesta",
  "hoa.polls.descriptionOptional": "Descripción (opcional)",
  "hoa.polls.descriptionPlaceholder": "Contexto breve para residentes",
  "hoa.polls.optionsLabel": "Opciones (solo etiquetas)",
  "hoa.polls.optionLabel": "Opción {index}",
  "hoa.polls.removeOption": "Eliminar opción",
  "hoa.polls.addOption": "+ Agregar opción",
  "hoa.polls.start": "Inicio",
  "hoa.polls.end": "Fin",
  "hoa.polls.quorumOptional": "Quórum % (opcional)",
  "hoa.polls.quorumPlaceholder": "ej., 50",
  "hoa.polls.totalEligibleOptional": "Total de votantes elegibles (opcional)",
  "hoa.polls.anonymousVoting": "Votación anónima",
  "hoa.polls.emptyTitle": "Aún no hay encuestas",
  "hoa.polls.emptyDesc": "Crea tu primera encuesta para que los residentes voten.",
  "hoa.polls.createTitle": "Crear encuesta",
  "hoa.polls.buildingRequired": "Edificio *",
  "hoa.polls.loadingBuildings": "Cargando edificios...",
  "hoa.polls.selectBuilding": "Seleccionar un edificio",
  "hoa.polls.noBuildings": "No hay edificios disponibles. Crea un edificio primero.",
  "hoa.polls.options": "Opciones",
  "hoa.polls.creating": "Creando...",
  "hoa.polls.createAction": "Crear encuesta",

  // HOA Residents
  "hoa.residents.otpSent": "OTP enviado correctamente a {name}!",
  "otp.alreadyActive": "OTP ya activo",
  "otp.useExisting": "Usa el mismo código actualmente activo para este residente.",
  "otp.resendAvailableIn": "Reenvío disponible en {time}.",
  "otp.resent": "OTP reenviado",
  "otp.resentDescription": "El código de un solo uso existente fue reenviado al residente.",
  "otp.sent": "OTP enviado",
  "otp.sentDescription": "La contraseña de un solo uso fue enviada al residente.",
  "otp.failedSend": "Error al enviar OTP",
  "otp.failedSendFallback": "Por favor intenta de nuevo. Es posible que se haya alcanzado el límite de la API de correo.",
  "otp.sending": "Enviando OTP...",
  "otp.bulk.sent": "OTPs enviados ({count})",
  "otp.bulk.sentDescription": "Todas las invitaciones fueron entregadas correctamente.",
  "otp.bulk.someInCooldown": "{count} residente(s) ya tenían un OTP activo en enfriamiento.",
  "otp.bulk.issues": "OTPs enviados con problemas ({count} entregados)",
  "otp.bulk.issuesDescription": "{failed} invitación(es) fallaron. {cooldown} en enfriamiento.",
  "otp.bulk.failed": "Error al enviar OTPs",
  "hoa.residents.title": "Gestión de residentes",
  "hoa.residents.subtitle": "Administra residentes, contacto y estado de pagos.",
  "hoa.residents.searchPlaceholder": "Buscar residente, correo o unidad...",
  "hoa.residents.sendInvites": "Enviar invitaciones ({count})",
  "hoa.residents.sendOtp": "Enviar OTP ({count})",
  "hoa.residents.sendOtpTitle": "Enviar OTP",
  "hoa.residents.importCsv": "Importar CSV",
  "hoa.residents.selectAll": "Seleccionar todo ({selected}/{total})",
  "hoa.residents.sort.nameAsc": "Nombre (A-Z)",
  "hoa.residents.sort.nameDesc": "Nombre (Z-A)",
  "hoa.residents.sort.unitAsc": "Código de unidad (A-Z)",
  "hoa.residents.sort.unitDesc": "Código de unidad (Z-A)",
  "hoa.residents.sort.buildingAsc": "Edificio (A-Z)",
  "hoa.residents.sort.buildingDesc": "Edificio (Z-A)",
  "hoa.residents.primary": "Principal",
  "hoa.residents.secondary": "Secundario",
  "hoa.residents.primaryResident": "Residente principal",
  "hoa.residents.empty": "Aún no hay residentes. Haz clic en + para agregar uno.",
  "hoa.residents.noMatches": "No hay residentes que coincidan.",
  "hoa.residents.unitLabel": "Unidad {unit} {building}",
  "hoa.residents.add": "Agregar residente",
  "hoa.residents.deleteTitle": "Eliminar residente",
  "hoa.residents.deleteDesc": "Esta acción no se puede deshacer. El residente será eliminado de la lista.",
  "hoa.residents.sheet.addTitle": "Agregar residente",
  "hoa.residents.sheet.editTitle": "Editar residente",
  "hoa.residents.sheet.description": "Completa los datos básicos. Puedes actualizar luego.",
  "hoa.residents.sheet.fullName": "Nombre completo *",
  "hoa.residents.sheet.phonePlaceholder": "+58 (212) 555-1234",
  "hoa.residents.sheet.selectUnit": "Selecciona una unidad",
  "hoa.residents.roles.owner": "Propietario",
  "hoa.residents.roles.tenant": "Inquilino",
  "hoa.residents.errors.noPackage": "No puedes gestionar residentes porque tu suscripción no está activa. Actualiza tu plan en Configuración o contacta soporte.",
  "hoa.residents.errors.limitReached": "Alcanzaste el límite permitido por tu plan actual. Actualiza el plan para continuar.",
  "hoa.residents.errors.validation": "Revisa los datos del residente y corrige los campos indicados.",
  "hoa.residents.errors.rateLimited": "Demasiados intentos en poco tiempo. Espera un momento e inténtalo de nuevo.",

  // Profile Page
  "profile.title": "Perfil",
  "profile.personalInfo": "Información Personal",
  "profile.personalInfoDesc": "Administra los detalles de tu cuenta",
  "profile.fullName": "Nombre Completo",
  "profile.email": "Correo Electrónico",
  "profile.phone": "Número de Teléfono",
  "profile.unit": "Unidad",
  "profile.saveChanges": "Guardar Cambios",
  "profile.changePhoto": "Cambiar Foto",
  "profile.removePhoto": "Eliminar Foto",
  "profile.notifications": "Notificaciones",
  "profile.notificationsDesc": "Controla qué notificaciones recibes",
  "profile.announcements": "Anuncios",
  "profile.announcementsDesc": "Recibe notificaciones sobre nuevos anuncios de la comunidad",
  "profile.polls": "Encuestas y Votaciones",
  "profile.pollsDesc": "Recibe notificaciones sobre nuevas encuestas y fechas límite",
  "profile.paymentReminders": "Recordatorios de Pago",
  "profile.paymentRemindersDesc": "Recibe recordatorios antes de las fechas de vencimiento",
  "profile.issueUpdates": "Actualizaciones de Incidencias",
  "profile.issueUpdatesDesc": "Recibe actualizaciones sobre tus incidencias reportadas",
  "profile.security": "Seguridad",
  "profile.securityDesc": "Administra tu contraseña y configuración de seguridad",
  "profile.changePassword": "Cambiar Contraseña",
  "profile.currentPassword": "Contraseña Actual",
  "profile.newPassword": "Nueva Contraseña",
  "profile.confirmPassword": "Confirmar Nueva Contraseña",
  "profile.updatePassword": "Actualizar Contraseña",
  "profile.twoFactorAuth": "Autenticación de Dos Factores",
  "profile.twoFactorAuthDesc": "Añade una capa extra de seguridad a tu cuenta",
  "profile.enable2FA": "Habilitar 2FA",
  "profile.disable2FA": "Deshabilitar 2FA",
  "profile.language": "Idioma",
  "profile.languageDesc": "Elige tu idioma preferido",
  "profile.languageAppliedNote": "La preferencia de idioma se aplicará en toda la aplicación.",
  "profile.english": "Inglés",
  "profile.spanish": "Español",
  "profile.default": "Predeterminado",
  "profile.appSettings": "Configuración de la App",
  "profile.appSettingsDesc": "Personaliza tu experiencia",
  "profile.darkMode": "Modo Oscuro",
  "profile.darkModeDesc": "Cambia entre tema claro y oscuro",
  "profile.support": "Soporte",
  "profile.supportDesc": "Obtén ayuda o contáctanos",
  "profile.helpCenter": "Centro de Ayuda",
  "profile.contactSupport": "Contactar Soporte",
  "profile.deleteAccount": "Eliminar Cuenta",
  "profile.deleteAccountDesc": "Elimina permanentemente tu cuenta y todos tus datos",
  "profile.deleteAccountWarning": "Esta acción no se puede deshacer. Todos tus datos serán eliminados permanentemente.",
  "profile.confirmDelete": "Sí, eliminar mi cuenta",
  "profile.logoutTitle": "Cerrar Sesión",
  "profile.logoutDesc": "Cierra sesión de tu cuenta",
  "profile.logoutConfirm": "¿Estás seguro de que quieres cerrar sesión?",
  "profile.version": "Versión",
  "profile.installApp": "Instalar App",
  "profile.deviceInfo": "Información del Dispositivo",
  "profile.platform": "Plataforma",
  "profile.browser": "Navegador",
  "profile.personalInfoViewOnlyDesc": "Actualiza tus datos de contacto. La unidad es de solo lectura.",
  "profile.avatarAlt": "Avatar del perfil",
  "profile.profilePhoto": "Foto de perfil",
  "profile.photoUploadHelp": "JPG/PNG, hasta 4 MB. Revisaremos las cargas por seguridad.",
  "profile.saveProfile": "Guardar perfil",
  "profile.deleteAccountRequestDesc": "Solicita la eliminación de cuenta. Esto requiere aprobación de la HOA.",
  "profile.installHelp": "Ayuda de instalación",
  "profile.install.calloutLine1": "Si no ves el botón Instalar, es posible que tu navegador no admita avisos automáticos.",
  "profile.install.calloutLine2": "Sigue los pasos de abajo para tu dispositivo.",
  "profile.install.ios.title": "iPhone / iPad (Safari)",
  "profile.install.ios.step1.pre": "Toca el ícono",
  "profile.install.ios.step1.post": "en Safari.",
  "profile.install.ios.step2.pre": "Elige",
  "profile.install.ios.step3.pre": "Toca",
  "profile.install.ios.note": "Si ya está instalada, ábrela desde tu pantalla de inicio.",
  "profile.install.android.title": "Android (Chrome)",
  "profile.install.android.step1.pre": "Toca el menú",
  "profile.install.android.step1.post": "en Chrome.",
  "profile.install.android.step2.pre": "Selecciona",
  "profile.install.android.step2.middle": "o",
  "profile.install.android.step3": "Confirma para instalar.",
  "profile.install.desktop.title": "Escritorio (Chrome / Edge)",
  "profile.install.desktop.step1.pre": "Busca el ícono",
  "profile.install.desktop.step1.post": "en la barra de direcciones, o",
  "profile.install.desktop.step2.pre": "Abre el menú del navegador ->",
  "profile.install.desktop.note": "Las apps instaladas se abren en su propia ventana.",
  "profile.install.term.share": "Compartir",
  "profile.install.term.addToHomeScreen": "Agregar a pantalla de inicio",
  "profile.install.term.add": "Agregar",
  "profile.install.term.menuDots": "⋮",
  "profile.install.term.installApp": "Instalar app",
  "profile.install.term.install": "Instalar",
  "profile.install.button.installApp": "Instalar app",
  "profile.install.button.installedOrNotSupported": "Instalada / No compatible",
  "profile.install.button.install": "Instalar",
  "profile.install.button.alreadyInstalled": "La app ya está instalada",
  "profile.install.button.notSupported": "La instalación no es compatible con este navegador",
  "profile.alert.profileUpdated": "Perfil actualizado.",
  "profile.alert.notificationsSaved": "Configuración de notificaciones guardada.",
  "profile.alert.passwordMismatch": "La nueva contraseña y la confirmación no coinciden.",
  "profile.alert.passwordChanged": "Contraseña cambiada.",
  "profile.alert.loggedOutAllDevices": "Sesión cerrada en todos los dispositivos.",
  "profile.alert.accountDeletionRequested": "Solicitud de eliminación de cuenta enviada. El admin de HOA la revisará.",
  "profile.alert.twoFactorUpdatedStub": "2FA actualizada (demo).",
  "profile.properties": "Propiedades",
  "profile.propertiesDesc": "Tu propiedad activa y todas las membresías vinculadas.",
  "profile.switchProperty": "Cambiar propiedad",
  "profile.active": "Activa",
  "profile.primaryContact": "Contacto principal",
  "profile.unknownBuilding": "Edificio desconocido",
  "profile.noActiveProperty": "No hay propiedad activa en esta sesión.",

  // Payments Page
  "payments.title": "Pagos",
  "payments.subtitle": "Administra tus facturas e historial de pagos",
  "payments.pending": "Pendiente",
  "payments.paid": "Pagado",
  "payments.overdue": "Vencido",
  "payments.partiallyPaid": "Parcialmente Pagado",
  "payments.dueDate": "Fecha de Vencimiento",
  "payments.dueOn": "Vence el",
  "payments.paidOn": "Pagado el",
  "payments.amount": "Monto",
  "payments.balance": "Saldo",
  "payments.payNow": "Pagar Ahora",
  "payments.viewDetails": "Ver Detalles",
  "payments.downloadReceipt": "Descargar Recibo",
  "payments.paymentMethod": "Método de Pago",
  "payments.selectMethod": "Seleccionar método de pago",
  "payments.bankTransfer": "Transferencia Bancaria",
  "payments.mobilePayment": "Pago Móvil",
  "payments.cash": "Efectivo",
  "payments.creditCard": "Tarjeta de Crédito",
  "payments.uploadProof": "Subir Comprobante de Pago",
  "payments.proofRequired": "Sube una captura de pantalla o foto de tu pago",
  "payments.submitPayment": "Enviar Pago",
  "payments.paymentHistory": "Historial de Pagos",
  "payments.noPayments": "No se encontraron pagos",
  "payments.noPendingInvoices": "No hay facturas pendientes",
  "payments.allPaid": "¡Todas las facturas están pagadas!",
  "payments.invoice": "Factura",
  "payments.invoiceNumber": "Factura #",
  "payments.invoiceDetails": "Detalles de la Factura",
  "payments.concept": "Concepto",
  "payments.period": "Período",
  "payments.issuedOn": "Emitida el",
  "payments.reference": "Referencia",
  "payments.notes": "Notas",
  "payments.summary": "Resumen",
  "payments.subtotal": "Subtotal",
  "payments.tax": "Impuesto",
  "payments.discount": "Descuento",
  "payments.totalDue": "Total a Pagar",
  "payments.amountPaid": "Monto Pagado",
  "payments.remainingBalance": "Saldo Restante",
  "payments.paymentPending": "Pago Pendiente de Verificación",
  "payments.paymentVerified": "Pago Verificado",
  "payments.paymentRejected": "Pago Rechazado",
  "payments.verificationPending": "Tu pago está siendo verificado",
  "payments.thankYou": "¡Gracias por tu pago!",
  "payments.dueThisMonth": "Vencido este mes",
  "payments.totalUnpaid": "Total sin pagar",
  "payments.pendingTab": "Pendientes",
  "payments.historyTab": "Historial de pagos",
  "payments.searchInvoices": "Buscar facturas",
  "payments.searchPlaceholder": "ID de factura, período, descripción…",
  "payments.showing": "Mostrando",
  "payments.invoicesUnpaid": "factura(s) (sin pagar)",
  "payments.invoicesPaid": "factura(s) (pagadas)",
  "payments.refresh": "Actualizar",
  "payments.refreshing": "Actualizando…",
  "payments.loadingInvoices": "Cargando facturas…",
  "payments.noMatchingInvoices": "No hay facturas que coincidan con tu búsqueda.",
  "payments.calendarMonth": "Mes calendario",
  "payments.paymentSent": "Pago enviado (en revisión)",
  "payments.paidByUrbe360": "Pagada por Urbe360",
  "payments.paymentConfirmed": "Pago confirmado",
  "payments.verified": "Pago verificado",
  "payments.transferringToHoa": "Urbe360 verificó tu pago. Los fondos se están transfiriendo a la HOA.",
  "payments.expired": "Vencida",
  "payments.urbe360Reviewing": "Urbe360 está revisando tu comprobante.",
  "payments.urbe360PaidAdmin": "Urbe360 ya pagó a la administración. Pendiente confirmación.",
  "payments.adminConfirmedPayment": "La administración confirmó que recibió tu pago.",
  "payments.invoiceOverdue": "Esta factura está vencida. Por favor paga lo antes posible.",
  "payments.partiallyPaidSubtitle": "La administración registró parte de este pago. Aún queda un saldo pendiente.",
  "payments.notReceived": "Aún no hemos recibido el pago de esta factura.",
  "payments.dueOn2": "Vence:",
  "payments.paymentSentDate": "Pago enviado:",
  "payments.underReview": "en revisión",
  "payments.paidDate": "Pagada:",
  "payments.openInvoice": "Abrir factura",
  "payments.unpaid": "Sin pagar",
  "payments.verifyingPayment": "Tu pago está siendo verificado por el administrador",
  "payments.reviewInvoiceDetails": "Revisa los detalles de la factura.",
  "payments.reviewDetailsAndPay": "Revisa los detalles y completa el pago.",
  "payments.invoiceId": "ID de Factura",
  "payments.dueDate2": "Vencimiento",
  "payments.baseAmount": "Monto base",
  "payments.credits": "Créditos",
  "payments.paymentTimeline": "Línea de tiempo del pago",
  "payments.paymentSentToUrbe360": "Pago enviado a Urbe360",
  "payments.urbe360ConfirmedPaid": "Urbe360 confirmó y pagó a la administración",
  "payments.adminConfirmedReceipt": "La administración confirmó recepción del pago",
  "payments.totalToPay": "Total a pagar",
  "payments.invoiceAlreadyPaid": "Esta factura ya está pagada.",
  "payments.choosePaymentMethod": "Elige un método de pago",
  "payments.zelle": "Zelle",
  "payments.transfer": "Transferencia",
  "payments.stripe": "Stripe / Tarjeta (+3%)",
  "payments.pagoMovil": "Pago Móvil",
  "payments.stripeCard": "Stripe / Tarjeta",
  "payments.recipient": "Destinatario",
  "payments.accountName": "Nombre de cuenta",
  "payments.memo": "Memo",
  "payments.bank": "Banco",
  "payments.instructions": "Instrucciones",
  "payments.schedule": "Horario",
  "payments.idNumberRif": "Cédula / RIF",
  "payments.paymentLink": "Enlace de pago",
  "payments.accountNumber": "Número de cuenta",
  "payments.routingNumber": "Número de ruta",
  "payments.method": "Método",
  "payments.service": "Servicio",
  "payments.paymentAccountDetails": "Detalles de la cuenta de pago",
  "payments.pagoMovilBankName": "Banesco",
  "payments.pagoMovilPhone": "0414-1234567",
  "payments.pagoMovilIdNumber": "J-40123456-7",
  "payments.pagoMovilConcept": "Pago de condominio",
  "payments.pagoMovilHelper": "Por favor envía tu captura de pantalla con el número de referencia después de pagar.",
  "payments.cashOfficeDelivery": "Entregar pago en la oficina de administración",
  "payments.cashSchedule": "Lunes a Viernes, 8am a 5pm",
  "payments.cashHelper": "El comprobante de pago será subido a la plataforma por administración una vez recibido.",
  "payments.stripePaymentLink": "https://buy.stripe.com/test_12345",
  "payments.stripeInstructions": "Paga por el enlace y luego sube aquí una captura del comprobante.",
  "payments.stripeLinkHelper": "El Super Admin proporcionó este enlace de Stripe. Haz clic o cópialo para pagar de forma segura y luego adjunta tu comprobante.",
  "payments.cashManagedByHoaAdmin": "Los pagos en efectivo son gestionados directamente por tu administrador de HOA.",
  "payments.cashVisitOfficeInstructions": "Por favor visita la oficina de administración para entregar el efectivo. Ellos registrarán el pago y actualizarán el estado en tu portal.",
  "payments.noFileChosen": "Ningún archivo seleccionado",
  "payments.copy": "Copiar",
  "payments.zelleHelper": "Las transferencias por Zelle suelen completarse en minutos. Sin comisiones.",
  "payments.bankTransferHelper": "Las transferencias ACH pueden tardar 1-3 días hábiles.",
  "payments.stripeHelper": "Serás redirigido a una página segura de Stripe para completar el pago. Se aplica un 3% de comisión.",
  "payments.redirectToStripe": "Serás redirigido a Stripe para completar tu pago.",
  "payments.goToStripe": "Ir a Stripe",
  "payments.uploadPaymentProof": "Subir comprobante de pago",
  "payments.paymentDate": "Fecha en que realizó el pago *",
  "payments.paymentDateHelp": "El día en que salió la transferencia de su cuenta. La tasa BCV de ese día es la que queda registrada en su recibo.",
  "payments.transactionScreenshot": "Captura de la transacción *",
  "payments.idDocument": "Documento de identidad *",
  "payments.choosePdfJpgPng": "Elegir PDF/JPG/PNG (máx 10MB)",
  "payments.notesOptional": "Notas (opcional)",
  "payments.addNoteAboutPayment": "Agrega cualquier nota sobre tu pago…",
  "payments.markAsPaid": "Marcar como pagado",
  "payments.sending": "Enviando…",
  "payments.paymentMarkedAsPaid": "¡Pago marcado como pagado!",
  "payments.paymentBeingVerified": "Tu pago está siendo verificado por el administrador.",
  "payments.errorMarkingPaid": "Error al marcar como pagado",
  "payments.tryAgainLater": "Inténtalo de nuevo más tarde.",
  "payments.uploadPdfOrImage": "Por favor sube un PDF o imagen (PNG/JPG).",
  "payments.fileTooLarge": "El archivo es demasiado grande (máx 10MB).",
  "payments.uploadBothFiles": "Debes subir ambos archivos: captura de transacción y ID.",
  "payments.stripeRedirect": "Redirección a Stripe",
  "payments.featureComingSoon": "Esta funcionalidad será implementada pronto.",
  "payments.receiveConfirmationSoon": "Recibirás una confirmación pronto.",
  "payments.unitInvoice": "Unidad {{UNIT}} • Factura #{{INVOICE_ID}}",

  // Announcements Page
  "announcements.title": "Anuncios",
  "announcements.subtitle": "Noticias y actualizaciones de la comunidad",
  "announcements.new": "Nuevo",
  "announcements.urgent": "Urgente",
  "announcements.general": "General",
  "announcements.maintenance": "Mantenimiento",
  "announcements.event": "Evento",
  "announcements.noAnnouncements": "No hay anuncios",
  "announcements.postedOn": "Publicado el",
  "announcements.expiresOn": "Expira el",
  "announcements.readMore": "Leer más",
  "announcements.viewAll": "Ver todos",
  "announcements.markAsRead": "Marcar como leído",
  "announcements.createNew": "Crear Anuncio",
  "announcements.editAnnouncement": "Editar Anuncio",
  "announcements.deleteAnnouncement": "Eliminar Anuncio",
  "announcements.confirmDelete": "¿Estás seguro de que quieres eliminar este anuncio?",
  "announcements.draft": "Borrador",
  "announcements.scheduled": "Programado",

  // Polls Page
  "polls.title": "Encuestas",
  "polls.subtitle": "Vota en las decisiones de la comunidad",
  "polls.active": "Activas",
  "polls.closed": "Cerradas",
  "polls.upcoming": "Próximas",
  "polls.noPolls": "No hay encuestas disponibles",
  "polls.vote": "Votar",
  "polls.viewResults": "Ver Resultados",
  "polls.votedOn": "Votaste el",
  "polls.endsOn": "Termina el",
  "polls.endedOn": "Terminó el",
  "polls.startsOn": "Comienza el",
  "polls.totalVotes": "Total de votos",
  "polls.yourVote": "Tu voto",
  "polls.changeVote": "Cambiar voto",
  "polls.submitVote": "Enviar Voto",
  "polls.voteRecorded": "Tu voto ha sido registrado",
  "polls.alreadyVoted": "Ya has votado",
  "polls.createPoll": "Crear Encuesta",
  "polls.editPoll": "Editar Encuesta",
  "polls.deletePoll": "Eliminar Encuesta",
  "polls.question": "Pregunta",
  "polls.options": "Opciones",
  "polls.addOption": "Agregar Opción",
  "polls.removeOption": "Eliminar Opción",
  "polls.multipleChoice": "Permitir selección múltiple",
  "polls.anonymous": "Votación anónima",
  "polls.results": "Resultados",
  "polls.participation": "Participación",

  // Issues Page
  "issues.title": "Incidencias",
  "issues.subtitle": "Reporta y da seguimiento a incidencias de mantenimiento",
  "issues.reportIssue": "Reportar Incidencia",
  "issues.myIssues": "Mis Incidencias",
  "issues.allIssues": "Todas las Incidencias",
  "issues.open": "Abierta",
  "issues.inProgress": "En Progreso",
  "issues.resolved": "Resuelta",
  "issues.closed": "Cerrada",
  "issues.noIssues": "No hay incidencias reportadas",
  "issues.issueTitle": "Título de la Incidencia",
  "issues.issueDescription": "Descripción",
  "issues.location": "Ubicación",
  "issues.priority": "Prioridad",
  "issues.low": "Baja",
  "issues.medium": "Media",
  "issues.high": "Alta",
  "issues.critical": "Crítica",
  "issues.attachPhotos": "Adjuntar Fotos",
  "issues.submitIssue": "Enviar Incidencia",
  "issues.issueSubmitted": "Incidencia enviada exitosamente",
  "issues.statusUpdated": "Estado actualizado",
  "issues.addComment": "Agregar Comentario",
  "issues.comments": "Comentarios",
  "issues.timeline": "Línea de Tiempo",
  "issues.createdOn": "Creada el",
  "issues.updatedOn": "Actualizada el",
  "issues.assignedTo": "Asignada a",
  "issues.reportedBy": "Reportada por",

  // Dashboard
  "dashboard.welcome": "Bienvenido",
  "dashboard.welcomeBack": "Bienvenido de nuevo",
  "dashboard.overview": "Resumen",
  "dashboard.quickActions": "Acciones Rápidas",
  "dashboard.recentActivity": "Actividad Reciente",
  "dashboard.pendingPayments": "Pagos Pendientes",
  "dashboard.activePolls": "Encuestas Activas",
  "dashboard.openIssues": "Incidencias Abiertas",
  "dashboard.newAnnouncements": "Nuevos Anuncios",
  "dashboard.viewAll": "Ver Todo",
  "dashboard.noActivity": "No hay actividad reciente",

  // Admin
  "admin.residents": "Residentes",
  "admin.addResident": "Agregar Residente",
  "admin.editResident": "Editar Residente",
  "admin.deleteResident": "Eliminar Residente",
  "admin.inviteResident": "Invitar Residente",
  "admin.residentDetails": "Detalles del Residente",
  "admin.units": "Unidades",
  "admin.addUnit": "Agregar Unidad",
  "admin.editUnit": "Editar Unidad",
  "admin.deleteUnit": "Eliminar Unidad",
  "admin.unitDetails": "Detalles de la Unidad",
  "admin.unitNumber": "Número de Unidad",
  "admin.floor": "Piso",
  "admin.type": "Tipo",
  "admin.size": "Tamaño",
  "admin.owner": "Propietario",
  "admin.tenant": "Inquilino",
  "admin.vacant": "Vacante",
  "admin.occupied": "Ocupada",
  "admin.buildings": "Edificios",
  "admin.addBuilding": "Agregar Edificio",
  "admin.editBuilding": "Editar Edificio",
  "admin.deleteBuilding": "Eliminar Edificio",
  "admin.buildingDetails": "Detalles del Edificio",
  "admin.totalUnits": "Total de Unidades",
  "admin.occupiedUnits": "Unidades Ocupadas",
  "admin.vacantUnits": "Unidades Vacantes",
  "admin.createInvoice": "Crear Factura",
  "admin.sendReminder": "Enviar Recordatorio",
  "admin.exportData": "Exportar Datos",
  "admin.importData": "Importar Datos",
  "admin.bulkActions": "Acciones en Lote",

  // HOA Buildings
  "hoa.buildings.title": "Gestión de edificios",
  "hoa.buildings.subtitle": "Administra edificios/condominios, unidades y residentes en una estructura jerárquica.",
  "hoa.buildings.searchPlaceholder": "Buscar por nombre, código o ciudad…",
  "hoa.buildings.importCsv": "Importar CSV",
  "hoa.buildings.status.activeOnly": "Solo activos",
  "hoa.buildings.status.inactiveOnly": "Solo inactivos",
  "hoa.buildings.sort.nameAsc": "Nombre (A-Z)",
  "hoa.buildings.sort.nameDesc": "Nombre (Z-A)",
  "hoa.buildings.sort.codeAsc": "Código (A-Z)",
  "hoa.buildings.sort.codeDesc": "Código (Z-A)",
  "hoa.buildings.sort.cityAsc": "Ciudad (A-Z)",
  "hoa.buildings.sort.cityDesc": "Ciudad (Z-A)",
  "hoa.buildings.sort.unitsAsc": "Unidades (Menor-Mayor)",
  "hoa.buildings.sort.unitsDesc": "Unidades (Mayor-Menor)",
  "hoa.buildings.kpi.totalBuildings": "Total de edificios",
  "hoa.buildings.kpi.active": "Activos",
  "hoa.buildings.kpi.inactive": "Inactivos",
  "hoa.buildings.kpi.totalUnits": "Total de unidades",
  "hoa.buildings.kpi.totalResidents": "Total de residentes",
  "hoa.buildings.emptyNone": "Aún no hay edificios. Haz clic en \"Agregar edificio\" para crear el primero.",
  "hoa.buildings.emptyFiltered": "No se encontraron edificios que coincidan.",
  "hoa.buildings.deleteTitle": "¿Eliminar edificio?",
  "hoa.buildings.deleteDesc": "¿Seguro que deseas eliminar {name}? Esta acción no se puede deshacer. Todas las unidades y residentes asociados también se verán afectados.",
  "hoa.buildings.viewAria": "Ver {name}",
  "hoa.buildings.active": "Activo",
  "hoa.buildings.inactive": "Inactivo",
  "hoa.buildings.actions": "Acciones de edificio",
  "hoa.buildings.edit": "Editar edificio",
  "hoa.buildings.delete": "Eliminar edificio",
  "hoa.buildings.floors": "Pisos",
  "hoa.buildings.occupancy": "Ocupación",
  "hoa.buildings.form.addTitle": "Agregar nuevo edificio",
  "hoa.buildings.form.editTitle": "Editar edificio",
  "hoa.buildings.form.addDesc": "Ingresa los detalles del nuevo edificio.",
  "hoa.buildings.form.editDesc": "Actualiza la información del edificio.",
  "hoa.buildings.form.basicInfo": "Información básica",
  "hoa.buildings.form.code": "Código",
  "hoa.buildings.form.codePlaceholder": "BLDG-A",
  "hoa.buildings.form.namePlaceholder": "Edificio A - Torre Norte",
  "hoa.buildings.form.addressPlaceholder": "123 Calle Principal",
  "hoa.buildings.form.city": "Ciudad",
  "hoa.buildings.form.cityPlaceholder": "Caracas",
  "hoa.buildings.form.state": "Estado",
  "hoa.buildings.form.statePlaceholder": "Miranda",
  "hoa.buildings.form.postalCode": "Código postal",
  "hoa.buildings.form.postalCodePlaceholder": "1050",
  "hoa.buildings.form.country": "País",
  "hoa.buildings.form.countryPlaceholder": "Venezuela",
  "hoa.buildings.form.rifImageLabel": "Imagen del documento RIF",
  "hoa.buildings.form.chooseFile": "Elegir archivo...",
  "hoa.buildings.form.removeFile": "Quitar",
  "hoa.buildings.form.viewCurrentRifImage": "Ver imagen RIF actual",
  "hoa.buildings.form.specs": "Especificaciones",
  "hoa.buildings.form.totalUnits": "Total de unidades",
  "hoa.buildings.form.defaultFee": "Tarifa predeterminada ($)",
  "hoa.buildings.form.additionalInfo": "Información adicional",
  "hoa.buildings.form.notesPlaceholder": "Notas adicionales...",
  "hoa.buildings.form.activeStatus": "Estado activo",
  "hoa.buildings.form.activeHint": "Los edificios inactivos no aparecerán en selecciones",
  "hoa.buildings.form.create": "Crear edificio",
  "hoa.buildings.errors.generic": "Ocurrió un error al guardar el edificio. Inténtalo de nuevo.",
  "hoa.buildings.errors.noPackage": "No puedes crear edificios porque tu suscripción no está activa. Actualiza tu plan en Configuración o contacta soporte.",
  "hoa.buildings.errors.limitReached": "Alcanzaste el límite de tu plan actual. Actualiza tu plan para seguir creando edificios.",
  "hoa.buildings.errors.rifTooLarge": "El archivo RIF es demasiado grande. El máximo permitido es {maxMb} MB.",
  "hoa.buildings.errors.rifInvalidType": "Formato de archivo no válido. Sube un archivo de imagen (JPG, PNG, WebP, etc.).",
  "hoa.buildings.errors.rifUploadFailed": "No pudimos subir el documento RIF. Verifica el archivo e inténtalo de nuevo.",
  "hoa.buildings.errors.subscriptionBlockedTitle": "La creación de edificios no está disponible",
  "hoa.buildings.errors.subscriptionBlocked": "El estado actual de tu suscripción es {status}. Actualiza tu suscripción para crear nuevos edificios.",
  "hoa.buildings.errors.network": "No pudimos conectarnos al servidor. Verifica tu conexión a internet e inténtalo de nuevo.",
  "hoa.buildings.errors.timeout": "La solicitud tardó demasiado. Inténtalo de nuevo.",
  "hoa.buildings.errors.unauthorized": "Tu sesión expiró. Inicia sesión nuevamente e inténtalo otra vez.",
  "hoa.buildings.errors.forbidden": "Tu cuenta no puede realizar esta acción en este momento.",
  "hoa.buildings.errors.notFound": "No se encontró el recurso solicitado. Actualiza la página e inténtalo de nuevo.",
  "hoa.buildings.errors.conflict": "No se pudo guardar el edificio por un conflicto. Revisa los datos e inténtalo de nuevo.",
  "hoa.buildings.errors.validation": "Revisa los datos del formulario y corrige los campos indicados.",
  "hoa.buildings.errors.rateLimited": "Demasiados intentos en poco tiempo. Espera un momento e inténtalo de nuevo.",
  "hoa.buildings.errors.server": "El servidor no está disponible temporalmente. Inténtalo de nuevo en unos minutos.",

  // Super Admin Dashboard
  "superAdmin.dashboard.greeting": "¡Hola, {name}!",
  "superAdmin.dashboard.platformConsole": "Consola de Plataforma",
  "superAdmin.dashboard.paymentsInbox.title": "Bandeja de Pagos",
  "superAdmin.dashboard.paymentsInbox.pending": "{count} pendientes",
  "superAdmin.dashboard.paymentsInbox.noPending": "No hay elementos pendientes",
  "superAdmin.dashboard.paymentsInbox.forwardedToday": "Enviados hoy",
  "superAdmin.dashboard.paymentsInbox.lastIncoming": "Último recibido",
  "superAdmin.dashboard.paymentsInbox.quickJump": "Acceso rápido",
  "superAdmin.dashboard.paymentsInbox.openInbox": "Abrir Bandeja",
  "superAdmin.dashboard.actions.manage": "Gestionar",
  "superAdmin.dashboard.actions.view": "Ver",
  "superAdmin.dashboard.actions.open": "Abrir",
  "superAdmin.dashboard.actions.platform": "Plataforma",
  "superAdmin.dashboard.actions.hoaAdmins": "Admins de HOA",
  "superAdmin.dashboard.actions.payouts": "Pagos",
  "superAdmin.dashboard.actions.paymentsInbox": "Bandeja de Pagos",
  "superAdmin.dashboard.actions.settings": "Configuración",
  "superAdmin.dashboard.approvals.title": "Aprobaciones Pendientes de Admin-HOA",
  "superAdmin.dashboard.approvals.pending": "{count} pendientes",
  "superAdmin.dashboard.approvals.updatedNow": "Actualizado justo ahora",
  "superAdmin.dashboard.approvals.approve": "Aprobar",
  "superAdmin.dashboard.approvals.reject": "Rechazar",
  "superAdmin.dashboard.approvals.noPending": "No hay aprobaciones pendientes.",
  "superAdmin.dashboard.payouts.title": "Pagos Recientes",
  "superAdmin.dashboard.payouts.last14Days": "Últimos 14 días",
  "superAdmin.dashboard.payouts.records": "{count} registros",
  "superAdmin.dashboard.payouts.noPayouts": "Sin pagos todavía.",
  "superAdmin.dashboard.payouts.viewAll": "Ver todos los pagos",
  "superAdmin.dashboard.platformNominal": "Todos los sistemas funcionando",
  "superAdmin.dashboard.systemNotes.title": "Notas del Sistema",
  "superAdmin.dashboard.systemNotes.viewAll": "Ver todo",

  // Super Admin Settings
  "superAdmin.settings.title": "Súper Admin • Configuración",
  "superAdmin.settings.subtitle": "Administra notificaciones de la plataforma, seguridad e instalación de la app.",
  "superAdmin.settings.paymentDetails.title": "Detalles de Pago de la Plataforma",
  "superAdmin.settings.paymentDetails.desc": "Configura los datos bancarios, Zelle y PayPal que se muestran a los administradores cuando pagan su suscripción.",
  "superAdmin.settings.paymentDetails.generalInstructions": "Instrucciones Generales de Pago",
  "superAdmin.settings.paymentDetails.generalInstructionsHint": "Nota opcional sobre métodos de pago disponibles.",
  "superAdmin.settings.paymentDetails.generalInstructionsPlaceholder": "Ej: Incluye el nombre de tu HOA en la referencia de la transferencia.",
  "superAdmin.settings.paymentDetails.bankNotes": "Notas Adicionales del Banco",
  "superAdmin.settings.paymentDetails.bankNotesPlaceholder": "Ej: Incluir nombre de HOA en el memo",
  "superAdmin.settings.paymentDetails.zelleName": "Nombre de Zelle",
  "superAdmin.settings.paymentDetails.zelleNamePlaceholder": "Ej: Urbe-360",
  "superAdmin.settings.paymentDetails.zellePhonePlaceholder": "Ej: +1 555 123 4567",
  "superAdmin.settings.paymentDetails.pagoMovilPhonePlaceholder": "Ej: +58 414 1234567",
  "superAdmin.settings.paymentDetails.lastUpdated": "Última actualización:",
  "superAdmin.settings.notifications.title": "Notificaciones",
  "superAdmin.settings.notifications.desc": "Elige sobre qué quieres recibir notificaciones.",
  "superAdmin.settings.notifications.paymentsInbox": "Bandeja de pagos",
  "superAdmin.settings.notifications.paymentsInboxHint": "Recibe alertas cuando lleguen nuevos comprobantes de pago para revisión.",
  "superAdmin.settings.notifications.hoaRequests": "Solicitudes de HOA",
  "superAdmin.settings.notifications.hoaRequestsHint": "Notifica cuando las HOAs soliciten onboarding o requieran aprobación.",
  "superAdmin.settings.notifications.billingAlerts": "Alertas de facturación",
  "superAdmin.settings.notifications.billingAlertsHint": "Alertas de suscripción/Stripe que requieren atención.",
  "superAdmin.settings.notifications.save": "Guardar notificaciones",
  "superAdmin.settings.notifications.callout": "Puedes ajustar el ruteo de alertas por HOA más adelante (por ejemplo, enviar facturas a un correo de finanzas). Por ahora esto activa las notificaciones globales de la plataforma para tu cuenta súper admin.",
  "superAdmin.settings.notifications.saved": "Notificaciones guardadas.",
  "superAdmin.settings.security.desc": "Administra tu contraseña y sesiones.",
  "superAdmin.settings.security.logoutAllDevices": "Cerrar sesión en todos los dispositivos",
  "superAdmin.settings.security.passwordMismatch": "La nueva contraseña y la confirmación no coinciden.",
  "superAdmin.settings.security.passwordChanged": "Contraseña cambiada.",
  "superAdmin.settings.security.loggedOutAllDevices": "Sesión cerrada en todos los dispositivos.",
  "superAdmin.settings.install.desc": "Instala esta PWA para una experiencia más rápida, tipo app.",
  "superAdmin.settings.install.help": "Ayuda de instalación",
  "superAdmin.settings.install.callout": "Si no ves el botón Instalar, tu navegador puede no admitir avisos automáticos. Sigue los pasos para tu dispositivo.",
  "superAdmin.settings.install.iosTitle": "iPhone / iPad (Safari)",
  "superAdmin.settings.install.iosStep1": "Toca el ícono Compartir en Safari.",
  "superAdmin.settings.install.iosStep2": "Elige Agregar a la pantalla de inicio.",
  "superAdmin.settings.install.iosStep3": "Toca Agregar.",
  "superAdmin.settings.install.androidTitle": "Android (Chrome)",
  "superAdmin.settings.install.androidStep1": "Toca el menú ⋮ en Chrome.",
  "superAdmin.settings.install.androidStep2": "Selecciona Instalar app o Agregar a la pantalla de inicio.",
  "superAdmin.settings.install.androidStep3": "Confirma para instalar.",
  "superAdmin.settings.install.desktopTitle": "Escritorio (Chrome / Edge)",
  "superAdmin.settings.install.desktopStep1": "Busca el ícono de instalar en la barra de direcciones, o",
  "superAdmin.settings.install.desktopStep2": "Abre el menú del navegador → Instalar app.",
  "superAdmin.settings.install.installApp": "Instalar app",
  "superAdmin.settings.install.installedOrUnsupported": "Instalada / No compatible",
  "superAdmin.settings.install.install": "Instalar",
  "superAdmin.settings.install.alreadyInstalled": "La app ya está instalada",
  "superAdmin.settings.install.notSupported": "Instalación no compatible en este navegador",

  // Not Found
  "notFound.title": "Página no encontrada",
  "notFound.subtitle": "Lo sentimos, la página que buscas no existe o ha sido movida.",
  "notFound.goHome": "Ir al inicio",
  "notFound.goBack": "Volver",

  // Activation
  "activation.title": "Activa tu cuenta",
  "activation.verify.subtitle": "Ingresa tus credenciales para comenzar",
  "activation.otp.subtitle": "Ingresa el código OTP enviado a tu correo",
  "activation.invitationCode": "Código de invitación",
  "activation.emailPlaceholder": "tu@email.com",
  "activation.tempPassword": "Contraseña temporal",
  "activation.tempPasswordPlaceholder": "De tu correo de invitación",
  "activation.tempPasswordHint": "Revisa tu correo para la contraseña temporal.",
  "activation.invitationExpired": "Esta invitación ha expirado. Por favor contacta a tu administrador HOA.",
  "activation.invitationInvalid": "Invitación inválida. Verifica tu código y correo.",
  "activation.otpInstructions": "Después de hacer clic en \"Obtener OTP\", revisa tu correo para el código de 6 dígitos.",
  "activation.sendingOtp": "Enviando OTP...",
  "activation.getOtp": "Obtener código OTP",
  "activation.otpSentTitle": "¡OTP enviado!",
  "activation.otpSentDesc": "Revisa tu correo en",
  "activation.enterOtp": "Ingresa el código OTP de 6 dígitos",
  "activation.otpExpires": "El código expira en 10 minutos",
  "activation.verifying": "Verificando...",
  "activation.verifyLogin": "Verificar e iniciar sesión",
  "activation.resendOtp": "Reenviar código OTP",
  "activation.backToLogin": "Volver al inicio de sesión",
  "activation.needHelp": "¿Necesitas ayuda? Contacta a tu administrador HOA",

  // Password Change
  "passwordChange.title": "Cambia tu contraseña",
  "passwordChange.subtitle": "Por seguridad, debes cambiar tu contraseña temporal antes de continuar.",
  "passwordChange.requiredTitle": "Paso obligatorio:",
  "passwordChange.requiredDesc": "Este es tu primer inicio de sesión. Crea una contraseña segura para proteger tu cuenta.",
  "passwordChange.currentTempPassword": "Contraseña temporal actual",
  "passwordChange.tempPasswordPlaceholder": "Tu contraseña temporal",
  "passwordChange.newPasswordPlaceholder": "Crea una contraseña segura",
  "passwordChange.confirmPasswordPlaceholder": "Vuelve a escribir tu nueva contraseña",
  "passwordChange.requirementsTitle": "Requisitos de contraseña:",
  "passwordChange.requirementLength": "Al menos 8 caracteres",
  "passwordChange.requirementLetters": "Contiene letras",
  "passwordChange.requirementNumbers": "Contiene números",
  "passwordChange.requirementMatch": "Las contraseñas coinciden",
  "passwordChange.error.length": "La contraseña debe tener al menos 8 caracteres",
  "passwordChange.error.letters": "La contraseña debe contener letras",
  "passwordChange.error.numbers": "La contraseña debe contener números",
  "passwordChange.successTitle": "¡Éxito!",
  "passwordChange.successDesc": "Tu contraseña ha sido cambiada. Redirigiendo...",
  "passwordChange.buttonLoading": "Cambiando contraseña...",
  "passwordChange.buttonSuccess": "¡Éxito!",
  "passwordChange.buttonSubmit": "Cambiar contraseña",
  "passwordChange.help": "Elige una contraseña segura que no hayas usado antes.",

  // Clear Storage
  "clearStorage.title": "Depuración y limpieza de almacenamiento",
  "clearStorage.checkStorage": "Revisar almacenamiento actual",
  "clearStorage.clearAll": "Borrar TODO el almacenamiento",
  "clearStorage.goToLogin": "Ir a la página de inicio de sesión",
  "clearStorage.cleared": "✅ ¡Todo el almacenamiento fue borrado!",
  "clearStorage.contentsTitle": "Contenido del almacenamiento:",
  "clearStorage.instructionsTitle": "📝 Instrucciones:",
  "clearStorage.instructions.check": "Haz clic en \"Revisar almacenamiento actual\" para ver lo almacenado",
  "clearStorage.instructions.clear": "Haz clic en \"Borrar TODO el almacenamiento\" para eliminar todo",
  "clearStorage.instructions.goToLogin": "Haz clic en \"Ir a la página de inicio de sesión\" para ir al login",
  "clearStorage.sessionStorageHeader": "=== SessionStorage ===",
  "clearStorage.localStorageHeader": "=== LocalStorage ===",

  // Registration
  "register.error.requiredFields": "Por favor completa todos los campos requeridos",
  "register.error.passwordRequirements": "Asegúrate de que tu contraseña cumpla todos los requisitos",
  "register.error.sendOtp": "No se pudo enviar el OTP. Intenta de nuevo.",
  "register.error.enterOtp": "Por favor ingresa el código de 6 dígitos",
  "register.error.createAccount": "No se pudo crear la cuenta. Intenta de nuevo.",
  "register.error.invalidOtp": "Código OTP inválido. Intenta de nuevo.",
  "register.error.resendOtp": "No se pudo reenviar el OTP. Intenta de nuevo.",
  "register.success.title": "¡Registro exitoso!",
  "register.success.subtitle": "Tu cuenta de administrador HOA ha sido creada. Ya puedes iniciar sesión para gestionar tu condominio.",
  "register.success.continue": "Continuar para iniciar sesión",
  "register.otp.title": "Verifica tu correo",
  "register.otp.sentTo": "Hemos enviado un código de 6 dígitos a",
  "register.otp.enterCode": "Ingresar código OTP",
  "register.otp.verifying": "Verificando...",
  "register.otp.verifyCreate": "Verificar y crear cuenta",
  "register.otp.sending": "Enviando...",
  "register.otp.resend": "Reenviar OTP",
  "register.otp.back": "Volver al registro",
  "register.details.title": "Crear cuenta de administrador HOA",
  "register.details.subtitle": "Registra tu asociación y comienza a gestionar tu comunidad",
  "register.firstName": "Nombre",
  "register.firstNamePlaceholder": "Juan",
  "register.lastName": "Apellido",
  "register.lastNamePlaceholder": "Pérez",
  "register.condoName": "Nombre del condominio/asociación",
  "register.condoNamePlaceholder": "Condominio Sunset Towers",
  "register.details.sendingCode": "Enviando código de verificación...",

  // Resident Setup
  "resident.setup.loadingProfile": "Cargando tu perfil...",
  "resident.setup.title": "Completa tu perfil",
  "resident.setup.subtitle": "Configura tu cuenta para acceder a todas las funciones de residentes",
  "resident.setup.emailLabel": "Correo:",
  "resident.setup.emailHint": "Tu correo no se puede cambiar. Contacta a tu HOA si esto es incorrecto.",
  "resident.setup.fullNamePlaceholder": "Juan Pérez",
  "resident.setup.phonePlaceholder": "+58 (212) 555-1234",
  "resident.setup.preferredLanguage": "Idioma preferido",
  "resident.setup.setPasswordTitle": "Configura tu contraseña",
  "resident.setup.passwordPlaceholder": "Al menos 8 caracteres",
  "resident.setup.confirmPasswordPlaceholder": "Vuelve a escribir tu contraseña",
  "resident.setup.passwordRuleLength": "La contraseña debe tener al menos 8 caracteres",
  "resident.setup.passwordRuleStrong": "Usa una contraseña fuerte y única",
  "resident.setup.completing": "Completando configuración...",
  "resident.setup.complete": "Completar configuración",
  "resident.setup.terms": "Al completar la configuración, aceptas nuestros Términos de servicio y Política de privacidad",
  "resident.setup.profileLoadFailed": "No se pudo cargar el perfil. Por favor inicia sesión de nuevo.",
  "resident.setup.fullNameRequired": "El nombre completo es obligatorio",
  "resident.setup.passwordRequired": "La contraseña es obligatoria",
  "resident.setup.passwordLength": "La contraseña debe tener al menos 8 caracteres",
  "resident.setup.completeTitle": "¡Configuración completada! 🎉",
  "resident.setup.completeDesc": "Tu cuenta ya está lista para usarse.",
  "resident.setup.failed": "No se pudo completar la configuración. Intenta de nuevo.",
  "resident.setup.failedTitle": "La configuración falló",

  // Resident OTP
  "resident.otp.enterCodeError": "Por favor ingresa el código OTP",
  "resident.otp.loginFailed": "Inicio de sesión fallido. Verifica tu código OTP.",
  "resident.otp.requiredTitle": "Se requiere verificación OTP",
  "resident.otp.noEmailTitle": "No se proporcionó una dirección de correo.",
  "resident.otp.noEmailDesc": "Usa el enlace enviado a tu correo por tu administrador HOA o contáctalo para recibir un nuevo código OTP.",
  "resident.otp.title": "Verificar código OTP",
  "resident.otp.sentTo": "Código OTP enviado a:",
  "resident.otp.subtitle": "Ingresa el código OTP de 6 dígitos de tu correo para verificar tu identidad.",
  "resident.otp.enterCode": "Ingresar código OTP",
  "resident.otp.placeholder": "123456",
  "resident.otp.checkEmail": "Revisa tu bandeja de entrada y la carpeta de spam",
  "resident.otp.noCode": "¿No recibiste el código?",
  "resident.otp.contactHoa": "Contacta a tu administrador HOA",
  "resident.otp.didntReceive": "¿No recibiste el código?",
  "resident.otp.resendCode": "Reenviar código",
  "resident.otp.resendIn": "Reenviar en",
  "resident.otp.cooldownError": "Por favor espera antes de solicitar otro código.",
  "auth.codeSent": "Código enviado.",

  // Resident Dashboard
  "resident.dashboard.greeting": "Hola, {name}!",
  "resident.dashboard.residentFallback": "Residente",
  "resident.dashboard.unitStatus": "Unidad {unit} • Todo está al día",
  "resident.dashboard.paymentStatus": "Estado de pagos",
  "resident.dashboard.upToDate": "Al día",
  "resident.dashboard.lastPaymentMade": "Último pago realizado",
  "resident.dashboard.action.report": "Reportar",
  "resident.dashboard.action.issue": "Incidencia",
  "resident.dashboard.action.view": "Ver",
  "resident.dashboard.action.payments": "Pagos",
  "resident.dashboard.latestAnnouncement": "Anuncio más reciente",
  "resident.dashboard.announcementSummary": "Mantenimiento de ascensor programado",
  "resident.dashboard.latestPoll": "Encuesta más reciente",
  "resident.dashboard.pollCloses": "Cierra:",
  "resident.dashboard.voteCount": "{count} votos",
  "resident.dashboard.goToPolls": "Ir a encuestas",
  "resident.dashboard.voteNow": "Votar ahora",
  "resident.dashboard.pollTitle": "¿Debemos extender el horario de la piscina hasta las 11 PM?",
  "resident.dashboard.comingSoon": "Próximamente",
  "resident.dashboard.pollsComingSoonDescription": "La función de votaciones y encuestas llegará en una próxima actualización.",
  "resident.dashboard.inDevelopment": "En desarrollo",
  "resident.dashboard.pendingInvitationTitle": "Invitación pendiente",
  "resident.dashboard.pendingAccept": "Aceptar invitación",
  "resident.dashboard.pendingAcceptError": "No se pudo iniciar el proceso de aceptación. Inténtalo de nuevo.",
  "resident.dashboard.overdue": "Vencido",
  "resident.dashboard.underReview": "En revisión",
  "resident.dashboard.paymentDue": "Pago pendiente",
  "resident.dashboard.nextPaymentDue": "Próximo pago vence",
  "resident.dashboard.noPayments": "Sin pagos pendientes",
  "resident.dashboard.switchUnit": "Cambiar unidad",

  // Resident property selection
  "resident.selectProperty.title": "Seleccionar propiedad",
  "resident.selectProperty.subtitle": "Elige a qué unidad o comunidad deseas acceder. Tu sesión estará limitada a la propiedad seleccionada.",
  "resident.selectProperty.loading": "Cargando propiedades disponibles…",
  "resident.selectProperty.noProperties": "No hay propiedades activas disponibles para esta cuenta.",
  "resident.selectProperty.propertyFallback": "Propiedad",
  "resident.selectProperty.unit": "Unidad",
  "resident.selectProperty.primaryContact": "Contacto principal",
  "resident.selectProperty.enter": "Entrar",
  "resident.selectProperty.opening": "Abriendo…",
  "resident.selectProperty.backToPortal": "Volver al portal",
  "resident.selectProperty.loadError": "No se pudieron cargar las propiedades. Inténtalo de nuevo.",
  "resident.selectProperty.enterError": "No se pudo acceder a la propiedad seleccionada. Inténtalo de nuevo.",

  // Announcements (Resident)
  "announcements.activeTitle": "Anuncios activos",
  "announcements.count": "{count} anuncio(s)",
  "announcements.filterPriority": "Filtrar por prioridad",
  "announcements.filterAll": "Todas las prioridades",
  "announcements.loading": "Cargando anuncios...",
  "announcements.pinned": "Fijado",
  "announcements.priorityLabel": "Prioridad",
  "announcements.published": "Publicado",
  "announcements.author": "Autor",
  "announcements.message": "Mensaje",
  "announcements.noneMatch": "No hay anuncios que coincidan con tu filtro.",
  "announcements.postedBy": "Publicado por {name}",
  "announcements.priority.urgent": "Urgente",
  "announcements.priority.high": "Alta",
  "announcements.priority.medium": "Media",
  "announcements.priority.low": "Baja",

  // Polls (Resident)
  "polls.communityTitle": "Encuestas de la comunidad",
  "polls.activeCount": "{count} encuesta(s) activa(s)",
  "polls.howToVoteTitle": "Cómo votar:",
  "polls.howToVote.step1": "Haz clic en una encuesta para ver detalles y votar",
  "polls.howToVote.step2": "Selecciona tu(s) opción(es) y envía",
  "polls.howToVote.step3": "Solo puedes votar una vez por encuesta",
  "polls.howToVote.step4": "Los resultados se muestran después de votar o cuando la encuesta cierra",
  "polls.loading": "Cargando encuestas...",
  "polls.noneActive": "No hay encuestas activas en este momento",
  "polls.status.voted": "Votado",
  "polls.status.closingSoon": "Cierra pronto",
  "polls.status.active": "Activa",
  "polls.status.closed": "Cerrada",
  "polls.voteCount": "{count} voto(s)",
  "polls.ends": "Termina",
  "polls.noEndDate": "Sin fecha de finalización",
  "polls.voteNow": "Votar ahora",
  "polls.voteThanks": "¡Gracias por participar!",
  "polls.noOptionTitle": "Ninguna opción seleccionada",
  "polls.noOptionDesc": "Selecciona al menos una opción para votar.",
  "polls.voteFailed": "Voto fallido",
  "polls.submitFailed": "No se pudo enviar el voto",
  "polls.loadingPoll": "Cargando encuesta...",
  "polls.alreadyVotedTitle": "Ya votaste",
  "polls.alreadyVotedDesc": "Ya has votado en esta encuesta",
  "polls.alreadyVotedNote": "Solo puedes votar una vez por encuesta. ¡Gracias por participar!",
  "polls.castVoteTitle": "Emite tu voto",
  "polls.multipleOptions": "Puedes seleccionar varias opciones",
  "polls.singleOption": "Solo puedes seleccionar una opción",
  "polls.submitting": "Enviando...",
  "polls.loadingResults": "Cargando resultados...",
  "polls.resultsTitle": "Resultados de la encuesta",
  "polls.voteSummary": "{total} voto(s) de {voters} votante(s)",
  "polls.ended": "Finalizada",
  "polls.inHours": "en {count}h",
  "polls.inDays": "en {count}d",

  // Issues (Resident)
  "issues.timeFrame": "Rango de tiempo",
  "issues.selectRange": "Selecciona un rango",
  "issues.range.week": "Última 1 semana",
  "issues.range.month": "Último 1 mes",
  "issues.range.quarter": "Últimos 3 meses",
  "issues.range.all": "Todo el tiempo",
  "issues.allStatuses": "Todos los estados",
  "issues.pending": "Pendiente",
  "issues.noneMatch": "No hay incidencias que coincidan con tus filtros.",
  "issues.count": "Mostrando {count} incidencia(s)",
  "issues.viewDetails": "Ver detalles",
  "issues.reported": "Reportado",
  "issues.reporter": "Reportero",
  "issues.assignee": "Asignado",
  "issues.issue": "Incidencia",
  "issues.detailsSubtitle": "Detalles completos para este reporte.",
  "issues.reportMeta": "{name} • {role} • {unit}",
  "issues.titlePlaceholder": "Breve descripción de la incidencia…",
  "issues.detailDescription": "Descripción detallada",
  "issues.detailPlaceholder": "Proporciona información detallada sobre la incidencia…",
  "issues.category": "Categoría",
  "issues.selectCategory": "Seleccionar categoría",
  "issues.categoryGeneral": "General",
  "issues.categoryPlumbing": "Plomería",
  "issues.categoryElectrical": "Eléctrico",
  "issues.categoryHvac": "HVAC",
  "issues.categoryCommonArea": "Área común",
  "issues.selectPriority": "Seleccionar prioridad",
  "issues.photosOptional": "Fotos (opcional)",
  "issues.clickToUpload": "Haz clic para subir fotos",
  "issues.uploadHint": "PNG, JPG o PDF hasta 10MB",
  "issues.uploadError": "Por favor sube PNG/JPG/PDF hasta 10MB.",
  "issues.reportSubmitted": "Incidencia enviada. ¡Te mantendremos informado!",
  "issues.reportCancelled": "Reporte cancelado.",

  "issues.status.PENDING": "Pendiente",
  "issues.status.IN_PROGRESS": "En progreso",
  "issues.status.RESOLVED": "Resuelta",
  "issues.status.CANCELLED": "Cancelada",
  "issues.priority.LOW": "Baja",
  "issues.priority.MEDIUM": "Media",
  "issues.priority.HIGH": "Alta",
  "issues.priority.URGENT": "Urgente",

  "issues.description": "Descripción",
  "issues.commonArea": "Área común",
  "issues.aSpecificUnit": "Una unidad específica",
  "issues.commonAreaExplainer":
    "Todos los residentes de este edificio verán este reporte y recibirán un aviso.",
  "issues.searchUnitOrResident": "Buscar por unidad o nombre del residente",
  "issues.noUnitMatches": "Ninguna unidad o residente coincide.",
  "issues.noUnitsInBuilding": "Este edificio aún no tiene unidades.",
  "issues.noResidents": "Sin residentes registrados",
  "issues.willNotify": "Se notificará a",
  "issues.pickAUnit": "Elige a qué unidad se refiere.",
  "issues.building": "Edificio",
  "issues.allBuildings": "Todos los edificios",
  "issues.unassigned": "Sin asignar",
  "issues.attachments": "Archivos adjuntos",
  "issues.attachmentHint": "Hasta 5 archivos — PNG, JPG, WEBP o PDF, 10MB cada uno",
  "issues.attachmentCount": "{count} adjunto(s)",
  "issues.commentCount": "{count} comentario(s)",
  "issues.tooManyFiles": "Puedes adjuntar como máximo 5 archivos.",
  "issues.badFileType": "Solo se permiten archivos PNG, JPG, WEBP o PDF.",
  "issues.fileTooLarge": "Cada archivo debe pesar menos de 10MB.",
  "issues.noComments": "Aún no hay comentarios.",
  "issues.commentPlaceholder": "Escribe un comentario…",
  "issues.internalNote": "Nota interna",
  "issues.internalOnly": "Nota interna (solo administradores)",
  "issues.timelineReported": "Reportada",
  "issues.timelineChanged": "{from} → {to}",
  "issues.loadError": "No se pudieron cargar las incidencias. Inténtalo de nuevo.",
  "issues.summaryLine": "{open} abiertas · {resolved} resueltas",
  "issues.emptyHint": "No hay nada en este período. Reporta un problema y podrás seguirlo aquí.",
  "issues.descriptionHint": "Dónde está, cuándo empezó, y qué has intentado ya.",
  "issues.pagination": "Páginas",
  "issues.previousPage": "Página anterior",
  "issues.nextPage": "Página siguiente",
  "issues.showingRange": "{first}–{last} de {count}",
  "issues.newCategory": "Nueva",
  "issues.newCategoryPlaceholder": "Ej. Filtraciones, Estacionamiento, Piscina",
  "issues.addCategory": "Agregar categoría",

  // Historial de tasa BCV
  "nav.rates": "Tasas",
  "hoa.payments.tabs.rates": "Tasas BCV",
  "hoa.payments.waiting.nobody": "Sin enviar",
  "hoa.payments.waiting.resident": "Esperando al residente",
  "hoa.payments.waiting.you": "Requiere tu revisión",
  "hoa.payments.waiting.platform": "En la plataforma",
  "hoa.payments.waiting.settled": "Cerrada",
  "hoa.payments.overdue": "Vencida",
  "hoa.payments.overdueDays": "{days}d vencida",
  "hoa.payments.kpi.overdue": "Vencidas",
  "hoa.payments.kpi.overdueSub": "pasada la fecha límite",
  "hoa.payments.moreActions": "Más acciones",
  "hoa.payments.kpi.needsReview": "comprobante(s) por revisar",
  "hoa.payments.kpi.rateShort": "{rate}% cobrado",
  "hoa.payments.noResultsFiltered": "Nada coincide con este período y estado. Limpia los filtros para verlo todo.",
  "rates.title": "Tasa de cambio BCV",
  "rates.subtitle": "La tasa oficial de cada día, y cómo se obtuvo la cifra de ese día.",
  "rates.previousMonth": "Mes anterior",
  "rates.nextMonth": "Mes siguiente",
  "rates.jumpToMonth": "Ir a un mes",
  "rates.day": "Día",
  "rates.rate": "Bs. / USD",
  "rates.change": "Variación",
  "rates.source": "Origen",
  "rates.published": "Publicadas",
  "rates.carried": "Arrastradas",
  "rates.longestGap": "Brecha mayor",
  "rates.uncovered": "Sin datos",
  "rates.reason.published": "Publicada por el BCV",
  "rates.reason.weekend": "Fin de semana",
  "rates.reason.noPublication": "Sin publicación",
  "rates.reason.beforeCoverage": "Antes de nuestros registros",
  "rates.carriedFrom": "del {date} · {days} día(s)",
  "rates.gapWarning": "{days} días bancarios seguidos sin publicación. Uno o dos son un feriado; una racha así suele significar que la consulta diaria se detuvo.",
  "rates.staleWarning": "Hoy se está usando una tasa arrastrada {days} días. Verifica que la consulta diaria siga corriendo.",
  "rates.loadError": "No se pudo cargar el historial de tasas. Inténtalo de nuevo.",
  "rates.footnote": "El BCV publica solo en días bancarios, cada tarde para el siguiente día bancario. Los fines de semana y feriados no publica, así que la última tasa publicada sigue vigente — eso es lo que significa \"arrastrada\". Un día entre semana sin publicación se muestra como tal y no se asume feriado, porque una consulta detenida se ve igual.",
  "rates.viewInHistory": "Ver ese día",
  "rates.emptyMonth": "Sin tasas para este mes",
  "rates.coverageStarts": "Nuestros registros comienzan el {date}.",
  "rates.noDataYet": "Todavía no se ha registrado ninguna tasa del BCV.",
  "rates.jumpToFirst": "Ir al primer mes",
  "issues.ageToday": "hoy",
  "issues.ageOneDay": "hace 1 día",
  "issues.ageDays": "hace {days} días",
  "issues.lastUpdated": "Última actualización {when}",
  "issues.attachmentTotal": "{count} archivo(s) · {size}",
  "issues.previousImage": "Imagen anterior",
  "issues.nextImage": "Imagen siguiente",
  "issues.openOriginal": "Abrir el original",

  // Payments
  "payments.zelleCash": "Zelle Cash",
  "payments.stripeCheckout": "Stripe Checkout",
  "payments.paymentInstructions": "Instrucciones de pago",
  "payments.sendPaymentToAccount": "Envía tu pago a esta cuenta",

  // Validation messages
  "validation.required": "Este campo es requerido",
  "validation.email": "Por favor ingresa un correo electrónico válido",
  "validation.minLength": "Debe tener al menos {min} caracteres",
  "validation.maxLength": "Debe tener como máximo {max} caracteres",
  "validation.passwordMatch": "Las contraseñas no coinciden",
  "validation.invalidPhone": "Por favor ingresa un número de teléfono válido",
  "validation.invalidAmount": "Por favor ingresa un monto válido",
  "validation.selectOption": "Por favor selecciona una opción",
  "validation.uploadFile": "Por favor sube un archivo",
  "validation.fileTooLarge": "El archivo debe ser menor a {size}MB",
  "validation.invalidFileType": "Tipo de archivo inválido. Permitidos: {types}",

  // Error messages
  "error.generic": "Algo salió mal. Por favor intenta de nuevo.",
  "error.network": "Error de red. Por favor verifica tu conexión.",
  "error.notFound": "El recurso solicitado no fue encontrado.",
  "error.unauthorized": "No estás autorizado para realizar esta acción.",
  "error.forbidden": "Acceso denegado.",
  "error.serverError": "Error del servidor. Por favor intenta más tarde.",
  "error.timeout": "La solicitud expiró. Por favor intenta de nuevo.",
  "error.invalidData": "Datos inválidos proporcionados.",

  // Success messages
  "success.saved": "Cambios guardados exitosamente",
  "success.created": "Creado exitosamente",
  "success.updated": "Actualizado exitosamente",
  "success.deleted": "Eliminado exitosamente",
  "success.sent": "Enviado exitosamente",
  "success.uploaded": "Subido exitosamente",

  // Date/Time
  "date.today": "Hoy",
  "date.yesterday": "Ayer",
  "date.tomorrow": "Mañana",
  "date.thisWeek": "Esta semana",
  "date.lastWeek": "La semana pasada",
  "date.thisMonth": "Este mes",
  "date.lastMonth": "El mes pasado",
  "date.daysAgo": "Hace {count} días",
  "date.hoursAgo": "Hace {count} horas",
  "date.minutesAgo": "Hace {count} minutos",
  "date.justNow": "Justo ahora",

  // Desglose de comisión
  "commission.title": "Desglose de Pago",
  "commission.totalAmount": "Monto Total de Factura",
  "commission.platformFee": "Tarifa de Plataforma (10%)",
  "commission.paid": "Pagado",
  "commission.netToHoa": "Neto para Admin HOA",
  "commission.pendingTransfer": "Pago recibido por la plataforma. Pendiente de transferencia al admin HOA.",
  "commission.completedCycle": "Ciclo de pago completo. El admin HOA ha recibido los fondos.",

  // Tarjeta de detalles de pago
  "payment.details.notAvailable": "Detalles de pago de {title} no disponibles",
  "payment.details.verified": "Cuenta verificada",
  "payment.details.unverified": "Cuenta no verificada",
  "payment.details.accountEmail": "Correo de cuenta",
  "payment.details.bankTransfer": "Transferencia bancaria",
  "payment.details.account": "Cuenta: {number}",
  "payment.details.routing": "Enrutamiento: {number}",
  "payment.details.zelle": "Zelle",
  "payment.details.zellePhone": "Tel\u00e9fono Zelle",
  "payment.details.paypal": "PayPal",
  "payment.details.venmo": "Venmo",
  "payment.details.cashapp": "Cash App",
  "payment.details.noMethods": "No hay m\u00e9todos de pago configurados",

  // Modal de importaci\u00f3n masiva
  "import.title": "Importar {type} masivamente",
  "import.description": "Sube un archivo CSV para importar varios {type} a la vez. Ver\u00e1s una vista previa antes de importar.",
  "import.instructions": "Instrucciones:",
  "import.step1": "Descarga la plantilla CSV de abajo",
  "import.step2": "Completa los datos de {type}",
  "import.step3": "Sube el archivo CSV completado",
  "import.step4": "Revisa la vista previa y haz clic en Importar",
  "import.template": "Plantilla de {type}",
  "import.entity.buildings": "Edificios",
  "import.entity.units": "Unidades",
  "import.entity.residents": "Residentes",
  "import.csvFormat": "Formato CSV",
  "import.downloading": "Descargando...",
  "import.download": "Descargar",
  "import.uploadLabel": "Subir archivo CSV",
  "import.chooseFile": "Elige un archivo CSV",
  "import.clickToBrowse": "Haz clic para explorar",
  "import.importing": "Importando...",
  "import.processingCsv": "Procesando tu archivo CSV",
  "import.readingPreview": "Leyendo vista previa del CSV\u2026",
  "import.showing": "Mostrando los primeros {count} de {total} registros",
  "import.columns": "{count} columnas",
  "import.success": "\u00a1\u00c9xito! Se importaron {count} {type} correctamente.",
  "import.partialFailed": "Importaci\u00f3n parcial/fallida: Se importaron {success} de {total} {type}. Se encontraron {errors} error(es).",
  "import.errorDetails": "Detalles de errores",
  "import.downloadErrorCsv": "Descargar CSV de errores",
  "import.rowHeader": "Fila",
  "import.errorsHeader": "Error(es)",
  "import.rowData": "Datos de fila",
  "import.noData": "Sin datos",
  "import.importBtn": "Importar {type}",
  "import.reviewAndConfirm": "Revisar y confirmar",
  "import.invalidFile": "Por favor selecciona un archivo CSV",
  "import.missingColumns": "Faltan columnas requeridas: {columns}. Descarga la plantilla para el formato correcto.",
  "import.failed": "La importación falló. Revisa el archivo e inténtalo de nuevo.",
  "import.parseFailed": "No se pudo leer el archivo CSV. Verifica el formato e inténtalo de nuevo.",
  "import.invalidEncoding": "El archivo CSV debe estar codificado en UTF-8.",
  "import.fileTooLarge": "El archivo CSV es demasiado grande. El tamaño máximo es {maxMb} MB.",
  "import.rateLimited": "Demasiados intentos de importación en poco tiempo. Espera un momento e inténtalo de nuevo.",
  "import.validRows": "Filas válidas",
  "import.invalidRows": "Filas inválidas",
  "import.willCreate": "Se crearán",
  "import.selectAllValid": "Seleccionar todas las válidas",
  "import.clearSelection": "Limpiar selección",
  "import.noCreateUntilConfirm": "No se crean registros durante la vista previa. Los registros se crean solo después de confirmar la importación.",
  "import.statusWillCreate": "Se creará",
  "import.statusSkipped": "Omitida",
  "import.statusInvalid": "Inválida",
  "import.confirmPrompt": "Estás por crear {count} registro(s). Confirma para continuar.",
  "import.noRowsSelected": "Selecciona al menos una fila válida para importar.",
  "import.duplicateInFile": "Duplicado en el archivo",
  "import.duplicateExisting": "Ya existe",

  // Modal de invitaciones masivas
  "invite.title": "Enviar invitaciones masivas",
  "invite.description": "Env\u00eda invitaciones de activaci\u00f3n de cuenta a los residentes seleccionados por correo.",
  "invite.howItWorks": "\u00bfC\u00f3mo funciona?",
  "invite.step1": "Cada residente recibir\u00e1 un correo con un enlace seguro de acceso",
  "invite.step2": "Abrir\u00e1n el enlace y solicitar\u00e1n un c\u00f3digo de acceso \u00fanico",
  "invite.step3": "Ingresan el c\u00f3digo para confirmar la membres\u00eda",
  "invite.step4": "Configuran su contrase\u00f1a y acceden al portal",
  "invite.selectedResidents": "Residentes seleccionados ({count})",
  "invite.customMessage": "Mensaje personalizado (opcional)",
  "invite.messagePlaceholder": "Agrega un mensaje personal al correo de invitaci\u00f3n...",
  "invite.messageHint": "Este mensaje se incluir\u00e1 en el correo de invitaci\u00f3n.",
  "invite.expiryLabel": "La invitaci\u00f3n expira despu\u00e9s de",
  "invite.days": "d\u00edas",
  "invite.expiryHint": "Las invitaciones expirar\u00e1n despu\u00e9s de {count} d\u00eda(s). Rango v\u00e1lido: 1-30 d\u00edas.",
  "invite.success": "\u00a1\u00c9xito! Se enviaron {count} invitaci\u00f3n(es) correctamente.",
  "invite.someFailed": "Algunas invitaciones fallaron:",
  "invite.sentList": "Invitaciones enviadas:",
  "invite.expires": "Vence: {date}",
  "invite.sending": "Enviando...",
  "invite.sendBtn": "Enviar {count} invitaci\u00f3n(es)",

  // Modal de OTP masivo
  "otp.send.title": "Enviar OTP a residentes",
  "otp.send.subtitle": "Env\u00eda contrase\u00f1as de un solo uso a {count} residente(s)",
  "otp.send.selectedResidents": "Residentes seleccionados:",
  "otp.send.unit": "Unidad {code}",
  "otp.send.whatNext": "\uD83D\uDCE7 \u00bfQu\u00e9 pasa despu\u00e9s?",
  "otp.send.infoStep1": "Cada residente recibir\u00e1 un OTP de 6 d\u00edgitos por correo",
  "otp.send.infoStep2": "Los c\u00f3digos OTP son v\u00e1lidos por 24 horas",
  "otp.send.infoStep3": "Los residentes pueden usar el OTP para autenticarse",
  "otp.send.failed": "\u274C No se pudo enviar el OTP",
  "otp.send.sending": "Enviando c\u00f3digos OTP...",
  "otp.send.sendingWait": "Por favor espera mientras enviamos correos a todos los residentes seleccionados",
  "otp.send.successTitle": "\u00a1OTP enviado exitosamente!",
  "otp.send.successDesc": "Enviado a {success} de {total} residentes",
  "otp.send.deliveryStatus": "Estado de entrega:",
  "otp.send.failedCount": "\u26A0\uFE0F {count} correo(s) no se pudieron enviar",
  "otp.send.failedHint": "Por favor verifica las direcciones de correo e int\u00e9ntalo m\u00e1s tarde",
  "otp.send.sendBtn": "Enviar OTP",
  "otp.send.pendingSending": "Enviando...",

  // Informes
  "reports.title": "Informes y Análisis",
  "reports.subtitle": "Elige un período y exporta resúmenes para tu junta.",
  "reports.period.current_month": "Mes Actual",
  "reports.period.last_month": "Mes Pasado",
  "reports.period.3months": "Últimos 3 Meses",
  "reports.period.6months": "Últimos 6 Meses",
  "reports.period.year": "Este Año",
  "reports.exportReport": "Exportar Informe",
  "reports.export": "Exportar",
  "reports.financial.title": "Resumen Financiero",
  "reports.financial.totalRevenue": "Ingreso Total",
  "reports.financial.collected": "Recaudado",
  "reports.financial.pending": "Pendiente",
  "reports.financial.collectionRate": "Tasa de Recaudación",
  "reports.financial.trendChart": "Tendencia de Recaudación Mensual",
  "reports.financial.trendChartDesc": "Ingresos recaudados vs pendientes a lo largo del tiempo",
  "reports.financial.statusChart": "Desglose de recaudación",
  "reports.financial.statusChartDesc": "Distribución de ingresos por estado de cobro",
  "reports.financial.overdue": "Vencido",
  "reports.financial.invoiceCount": "Facturas",
  "reports.financial.noData": "No hay datos de facturas para este período",
  "reports.occupancy.title": "Informe de Ocupación",
  "reports.occupancy.totalUnits": "Total de Unidades",
  "reports.occupancy.occupied": "Ocupadas",
  "reports.occupancy.vacant": "Vacantes",
  "reports.occupancy.rate": "Tasa de Ocupación",
  "reports.maintenance.title": "Informe de Mantenimiento",
  "reports.maintenance.totalIssues": "Total de Problemas",
  "reports.maintenance.resolved": "Resueltos",
  "reports.maintenance.pending": "Pendientes",
  "reports.maintenance.rate": "Tasa de Resolución",
  "reports.maintenance.byCategory": "Problemas por Categoría",
  "reports.maintenance.issueCount": "{count} problemas",
  "reports.action.monthly.title": "Informe Mensual",
  "reports.action.monthly.desc": "Recibe un CSV completo con cada registro de factura, detalles del residente, estado de pago y tasas BCV.",
  "reports.action.monthly.cta": "Generar",
  "reports.action.resident.title": "Informe de Residentes",
  "reports.action.resident.desc": "Desglose detallado por residente con toda la actividad de pagos del período seleccionado.",
  "reports.action.resident.cta": "Exportar",
  "reports.action.custom.title": "Informe Personalizado",
  "reports.action.custom.desc": "Crear informe con rango de fechas personalizado",
  "reports.action.custom.cta": "Crear",
  "reports.comingSoon": "Abrir generador de informes personalizados (próximamente)",

  // Unidades
  "units.importCSV": "Importar CSV",
  "units.stat.total": "Total",
  "units.stat.paid": "Pagado",
  "units.stat.pending": "Pendiente",
  "units.stat.occupied": "Ocupadas",
  "units.stat.vacant": "Vacantes",
  "units.stat.inactive": "Inactivas",
  "units.search.placeholder": "Buscar unidad o residente…",
  "units.filter.all": "Todos",
  "units.filter.paid": "Pagado",
  "units.filter.pending": "Pendiente",
  "units.filter.vacant": "Vacante",
  "units.filter.occupied": "Ocupadas",
  "units.filter.inactive": "Inactivas",
  "units.empty": "No hay unidades coincidentes.",
  "units.unit": "Unidad {number}",
  "units.perMonth": "${amount}/mes",
  "units.unassigned": "Sin asignar",
  "units.displayNumber": "Ref: {number}",
  "units.floor": "Piso {floor}",
  "units.residentCount": "{count} residente(s)",
  "units.status.paid": "Pagado",
  "units.status.pending": "Pendiente",
  "units.status.vacant": "Vacante",
  "units.status.occupied": "Ocupada",
  "units.status.inactive": "Inactiva",
  "units.viewPayment": "Ver Pago",
  "units.add": "Agregar unidad",
  "units.drawer.title": "Pagos — Unidad {number}",
  "units.drawer.vacant": "Vacante",
  "units.drawer.noInvoices": "No hay facturas para esta unidad.",
  "units.drawer.issued": "Emitida {issued} • Vence {due}",
  "units.invoice.status.sent": "Enviada",
  "units.invoice.status.cancelled": "Cancelada",
  "units.modal.newUnit": "Nueva Unidad",
  "units.modal.editUnit": "Editar Unidad",
  "units.modal.unitNumber": "Número de unidad",
  "units.modal.unitCode": "Código de unidad",
  "units.modal.floor": "Piso (opcional)",
  "units.modal.displayNumber": "Número de visualización",
  "units.modal.monthlyFee": "Cuota mensual",
  "units.modal.status": "Estado",
  "units.modal.rent": "Renta mensual",
  "units.modal.residentSection": "Residente (opcional)",
  "units.modal.name": "Nombre",
  "units.modal.createUnit": "Crear unidad",
  "units.confirm.deleteTitle": "Eliminar unidad",
  "units.confirm.deleteMessage": "¿Estás seguro de que deseas eliminar la Unidad {number}? Esta acción no se puede deshacer.",
  "units.errors.noPackage": "No puedes crear ni editar unidades porque tu suscripción no está activa. Actualiza tu plan en Configuración o contacta soporte.",
  "units.errors.limitReached": "Alcanzaste el límite actual de unidades. Actualiza tu plan para crear más unidades.",
  "units.errors.validation": "Revisa los datos de la unidad y corrige los campos indicados.",
  "units.errors.rateLimited": "Demasiados intentos en poco tiempo. Espera un momento e inténtalo de nuevo.",

  // Venezuela compliance
  "residents.cedula": "Cédula",
  "residents.cedulaPlaceholder": "V-12345678 o E-12345678",
  "buildings.rif": "RIF",
  "buildings.rifPlaceholder": "J-12345678-9",
  "invoice.download": "Descargar PDF",
  "invoice.downloadReceipt": "Descargar Recibo",
  "invoice.downloadError": "Error al descargar el documento",
  "invoice.sendReminder": "Enviar Recordatorio",
  "invoice.reminderSent": "Recordatorio de pago vencido enviado",
  "invoice.reminderFailed": "Error al enviar el recordatorio",
  "invoice.notifications": "Registro de Notificaciones",
  "invoice.notifSent": "Factura Enviada",
  "invoice.notifFailed": "Envío Fallido",
  "invoice.notifMocked": "SMS (simulado)",

  // Payments - KPI Cards
  "hoa.payments.kpi.expected": "Esperado (este mes)",
  "hoa.payments.kpi.showAll": "Toca para quitar filtros",
  "hoa.payments.details.section.invoice": "Detalles de la factura",
  "hoa.payments.form.section.recipients": "Quién recibe factura",
  "hoa.payments.form.amountSourceLabel": "Cobrar a cada residente",
  "hoa.payments.bulk.projectedTotal": "Total {total}",
  "hoa.payments.form.createSubtitle": "Una factura para una unidad.",
  "hoa.payments.form.section.who": "Para quién es",
  "hoa.payments.form.section.amount": "Monto y fechas",
  "hoa.payments.form.unitOrResident": "Unidad o residente",
  "hoa.payments.form.pickBuildingFirst": "Elige un edificio para ver sus unidades.",
  "hoa.payments.form.pickOneHint": "Busca por número de unidad o por el nombre del residente.",
  "hoa.payments.form.noUnitsInBuilding": "Este edificio aún no tiene unidades.",
  "hoa.payments.form.noMatches": "Ninguna unidad o residente coincide.",
  "hoa.payments.form.vacantUnit": "Sin residentes registrados",
  "hoa.payments.form.methodUnset": "No especificado",
  "hoa.payments.reminderModal.title": "Enviar recordatorios de mora",
  "hoa.payments.reminderModal.subtitle": "Elige a quién recordar. Todos los morosos están seleccionados.",
  "hoa.payments.reminderModal.selectAll": "Seleccionar todos",
  "hoa.payments.reminderModal.chosen": "{count} de {total}",
  "hoa.payments.reminderModal.send": "Enviar {count}",
  "hoa.payments.reminderModal.noneTitle": "No hay nada en mora",
  "hoa.payments.reminderModal.noneHint": "Todas las facturas están pagadas, aún no vencen, o ya se están procesando.",
  "hoa.payments.reminderModal.loadFailed": "No se pudo cargar la lista. Cierra e intenta de nuevo.",
  "hoa.payments.reminderModal.footnote": "Los residentes que ya están pagando quedan fuera automáticamente, aunque su factura siga como impaga.",
  "hoa.payments.kpi.incoming": "Esperando por ti",
  "hoa.payments.kpi.incomingSub": "Confirma que el dinero llegó",
  "hoa.payments.kpi.paid": "Cobrado (este mes)",
  "hoa.payments.kpi.sent": "Facturas enviadas",
  "hoa.payments.kpi.rate": "Tasa de cobro",

  // Payments - Bulk Reminder
  "hoa.payments.tabs.notifications": "Registro de notificaciones",
  "hoa.payments.bulkReminder": "Enviar recordatorios",
  "hoa.payments.bulkReminderSending": "Enviando…",
  "hoa.payments.bulkReminderTitle": "Resultados de los recordatorios",
  "hoa.payments.bulkReminderTotal": "Total:",
  "hoa.payments.bulkReminderSent": "Enviados:",
  "hoa.payments.bulkReminderMocked": "Simulado:",
  "hoa.payments.bulkReminderFailed": "Fallidos:",
  "hoa.payments.bulkReminderSummary": "Enviados {sent} de {total} recordatorios",
  "hoa.payments.bulkReminderFailedToast": "Error al enviar recordatorios masivos",
  "hoa.payments.bulkReminderDaysOverdue": "{count}d vencido",

  // Notification Log
  "hoa.notifLog.allTypes": "Todos los tipos",
  "hoa.notifLog.allStatuses": "Todos los estados",
  "hoa.notifLog.typeOverdue": "Recordatorio de vencimiento",
  "hoa.notifLog.typeInvoiceSent": "Factura enviada",
  "hoa.notifLog.channelEmail": "Correo",
  "hoa.notifLog.channelSms": "SMS",
  "hoa.notifLog.triggeredAuto": "Automático",
  "hoa.notifLog.records": "{count} registros",
  "hoa.notifLog.noResults": "No se encontraron notificaciones",
  "hoa.notifLog.refreshing": "Actualizando…",
  "hoa.notifLog.refresh": "↺ Actualizar",
  "hoa.notifLog.loading": "Cargando…",
  "hoa.notifLog.colDate": "Fecha",
  "hoa.notifLog.colInvoice": "Factura",
  "hoa.notifLog.colType": "Tipo",
  "hoa.notifLog.colChannel": "Canal",
  "hoa.notifLog.colStatus": "Estado",
  "hoa.notifLog.colRecipient": "Destinatario",
  "hoa.notifLog.colTriggeredBy": "Enviado por",
  "hoa.notifLog.colError": "Error",
  "hoa.notifLog.resendOk": "Recordatorio reenviado.",
  "hoa.notifLog.resendFailed": "No se pudo reenviar. Intenta de nuevo.",
  "hoa.notifLog.status.sent": "Enviado",
  "hoa.notifLog.status.failed": "Fallido",
  "hoa.notifLog.status.mocked": "Simulado",
  "hoa.notifLog.retryNotification": "Reintentar notificación",
  "hoa.notifLog.resend": "Reenviar",
  "hoa.notifLog.toast.resent": "Notificación reenviada exitosamente",
  "hoa.notifLog.toast.resendFailed": "Error al reenviar notificación",

  // Building Detail Page
  "hoa.buildingDetail.noVacantUnits": "No hay unidades vacantes disponibles",
  "hoa.buildingDetail.markUnitVacant": "Marca una unidad como vacante o crea una nueva unidad para continuar.",
  "hoa.buildingDetail.createUnit": "Crear Unidad",
  "hoa.buildingDetail.cannotCreateResident": "No se puede crear el residente",
  "hoa.buildingDetail.noVacantUnitsDescription": "No hay unidades vacantes disponibles en este edificio. Todas las unidades están ocupadas o inactivas.",
  "hoa.buildingDetail.createNewVacantUnit": "✓ Crea una nueva unidad vacante, o",
  "hoa.buildingDetail.markExistingUnitVacant": "✓ Marca una unidad existente como vacante con 0 residentes",
  "hoa.buildingDetail.createUnitFirst": "No hay unidades vacantes disponibles - Crea una unidad primero",
  "hoa.buildingDetail.viewAllUnits": "Ver todas las unidades",
  "hoa.buildingDetail.notFound.title": "Edificio no encontrado",
  "hoa.buildingDetail.notFound.description": "El edificio que buscas no existe o fue eliminado.",
  "hoa.buildingDetail.editBuildingDescription": "Actualiza la información del edificio a continuación.",
  "hoa.buildingDetail.loadingUnits": "Cargando unidades...",
  "hoa.buildingDetail.retry": "Reintentar",
  "hoa.buildingDetail.adjustSearch": "Intenta ajustar tus criterios de búsqueda.",
  "hoa.buildingDetail.adjustSearchOrFilter": "Intenta ajustar tu búsqueda o filtro.",
  "hoa.buildingDetail.status.active": "Activo",
  "hoa.buildingDetail.status.inactive": "Inactivo",
  "hoa.buildingDetail.rifLabel": "RIF (Registro de Información Fiscal)",
  "hoa.buildingDetail.rifHelper": "Se imprime en facturas y recibos oficiales",
  "hoa.buildingDetail.rifPlaceholder": "J-12345678-9",
  "hoa.buildingDetail.defaultMonthlyFeePlaceholder": "0.00",
  "hoa.buildingDetail.info.title": "Información del Edificio",
  "hoa.buildingDetail.info.lastUpdated": "Última actualización",
  "hoa.buildingDetail.info.totalUnitsPlanned": "Total de unidades (planificadas)",
  "hoa.buildingDetail.notes": "Notas",
  "hoa.buildingDetail.unitLabel": "Unidad {code}",
  "hoa.buildingDetail.floorLabel": "Piso {floor}",
  "hoa.buildingDetail.perMonthShort": "/mes",
  "hoa.buildingDetail.optional": "opcional",
  "hoa.buildingDetail.sections.basicInformation": "Información básica",
  "hoa.buildingDetail.sections.financialInformation": "Información financiera",
  "hoa.buildingDetail.sections.systemInformation": "Información del sistema",
  "hoa.buildingDetail.financial.currentBalance": "Saldo actual",
  "hoa.buildingDetail.financial.initialBalance": "Saldo inicial",
  "hoa.buildingDetail.stats.detailed": "Estadísticas detalladas",
  "hoa.buildingDetail.stats.occupiedSub": "{count} ocupadas",
  "hoa.buildingDetail.stats.primarySub": "{count} principales",
  "hoa.buildingDetail.stats.occupiedUnits": "Unidades ocupadas",
  "hoa.buildingDetail.stats.vacantUnits": "Unidades vacantes",
  "hoa.buildingDetail.stats.inactiveUnits": "Unidades inactivas",
  "hoa.buildingDetail.stats.primaryResidents": "Residentes principales",
  "hoa.buildingDetail.stats.secondaryResidents": "Residentes secundarios",
  "hoa.buildingDetail.stats.totalBalance": "Saldo total",
  "hoa.buildingDetail.units.filter.allStatus": "Todos los estados",
  "hoa.buildingDetail.units.status.inactive": "Inactiva",
  "hoa.buildingDetail.units.errorLoading": "Error al cargar unidades",
  "hoa.buildingDetail.units.emptyInBuilding": "Aún no hay unidades en este edificio",
  "hoa.buildingDetail.units.emptyHint": "Haz clic en \"Agregar Unidad\" para crear la primera unidad.",
  "hoa.buildingDetail.units.noMatching": "No hay unidades que coincidan",
  "hoa.buildingDetail.units.residentCount": "{count} residente(s)",
  "hoa.buildingDetail.units.actionsAria": "Acciones de unidad",
  "hoa.buildingDetail.units.detailsTitle": "Detalles de la unidad",
  "hoa.buildingDetail.units.viewingDetailsFor": "Viendo detalles de la unidad {code}",
  "hoa.buildingDetail.units.loadDetailsFailed": "No se pudieron cargar los detalles de la unidad",
  "hoa.buildingDetail.units.updateUnit": "Actualizar unidad",
  "hoa.buildingDetail.units.deleteTitle": "¿Eliminar unidad?",
  "hoa.buildingDetail.units.deleteDescription": "¿Estás seguro de que deseas eliminar la unidad {code}? Esta acción no se puede deshacer. Todos los datos asociados se eliminarán permanentemente.",
  "hoa.buildingDetail.units.deleteResidentWarning": "Advertencia: esta unidad tiene {count} residente(s).",
  "hoa.buildingDetail.units.modal.createDescription": "Agregando unidad a",
  "hoa.buildingDetail.units.modal.editDescription": "Editando unidad en",
  "hoa.buildingDetail.units.form.unitCodePlaceholder": "A-101",
  "hoa.buildingDetail.units.form.floorPlaceholder": "1",
  "hoa.buildingDetail.units.form.unitNumberPlaceholder": "01",
  "hoa.buildingDetail.units.form.monthlyFeePlaceholder": "300.00",
  "hoa.buildingDetail.units.form.alicuota": "Alícuota (%)",
  "hoa.buildingDetail.units.form.alicuotaPlaceholder": "2.5000",
  "hoa.buildingDetail.units.form.alicuotaHelper": "Porción proporcional de gastos del edificio (ej. 2.5 = 2.5%)",
  "hoa.buildingDetail.units.form.selectStatus": "Selecciona estado",
  "hoa.buildingDetail.residents.unitsRequired": "Se requieren unidades antes de agregar residentes",
  "hoa.buildingDetail.residents.assignmentWarning": "Los residentes deben asignarse a una unidad vacante. Crea una unidad primero y luego vuelve aquí para agregar residentes.",
  "hoa.buildingDetail.residents.searchByFields": "Buscar residentes por nombre, correo, teléfono o unidad...",
  "hoa.buildingDetail.residents.sendOtpCount": "Enviar OTP ({count})",
  "hoa.buildingDetail.residents.assignedToUnit": "Los residentes deben estar asignados a una unidad.",
  "hoa.buildingDetail.residents.noMatching": "No hay residentes que coincidan",
  "hoa.buildingDetail.residents.selectResidentAria": "Seleccionar {name}",
  "hoa.buildingDetail.residents.actionsAria": "Acciones de residente",
  "hoa.buildingDetail.residents.noEmailAddress": "Sin correo electrónico",
  "hoa.buildingDetail.residents.selectVacantUnit": "Selecciona una unidad vacante",
  "hoa.buildingDetail.residents.noUnitsAvailable": "No hay unidades disponibles. Crea una unidad para continuar.",
  "hoa.buildingDetail.residents.detailsTitle": "Detalles del residente",
  "hoa.buildingDetail.residents.viewingDetailsFor": "Viendo detalles de {name}",
  "hoa.buildingDetail.residents.fullName": "Nombre completo",
  "hoa.buildingDetail.residents.language": "Idioma",
  "hoa.buildingDetail.residents.unitInformation": "Información de la unidad",
  "hoa.buildingDetail.residents.typeTitle": "Tipo de residente",
  "hoa.buildingDetail.residents.identityTitle": "Identidad",
  "hoa.buildingDetail.residents.idDocument": "Documento de identidad",
  "hoa.buildingDetail.residents.viewDocument": "Ver documento",
  "hoa.buildingDetail.residents.loadDetailsFailed": "No se pudieron cargar los detalles del residente",
  "hoa.buildingDetail.residents.updateResident": "Actualizar residente",
  "hoa.buildingDetail.residents.deleteTitle": "¿Eliminar residente?",
  "hoa.buildingDetail.residents.deleteDescription": "¿Estás seguro de que deseas eliminar a {name} de la unidad {unit}? Esta acción no se puede deshacer. Todos los datos asociados se eliminarán permanentemente.",
  "hoa.buildingDetail.residents.deletePrimaryWarning": "Advertencia: este es el contacto principal de la unidad.",
  "hoa.buildingDetail.residents.modal.createDescription": "Agregando residente a",
  "hoa.buildingDetail.residents.modal.editDescription": "Editando residente en",
  "hoa.buildingDetail.residents.form.firstNamePlaceholder": "Juan",
  "hoa.buildingDetail.residents.form.lastNamePlaceholder": "Pérez",
  "hoa.buildingDetail.residents.form.emailPlaceholder": "juan.perez@correo.com",
  "hoa.buildingDetail.residents.form.phonePlaceholder": "+58 412 123 4567",
  "hoa.buildingDetail.residents.form.identityDocument": "Documento de identidad",
  "hoa.buildingDetail.residents.form.identityPlaceholder": "V-12345678",
  "hoa.buildingDetail.residents.form.identityHelper": "Formato: V-12345678 / E-12345678",
  "hoa.buildingDetail.residents.form.idDocumentPhoto": "Foto del documento de identidad",
  "hoa.buildingDetail.residents.form.idDocumentUploadHelper": "Sube una foto o escaneo del documento/pasaporte.",
  "hoa.buildingDetail.residents.form.idDocumentReplaceHelper": "Sube una nueva foto/escaneo para reemplazar la actual.",
  "hoa.buildingDetail.residents.form.idPreviewAlt": "Vista previa del documento",
  "hoa.buildingDetail.residents.form.selectVacantUnit": "Selecciona una unidad vacante",
  "hoa.buildingDetail.residents.form.selectType": "Selecciona tipo",
  "hoa.buildingDetail.residents.form.primaryContact": "Contacto principal",
  "hoa.buildingDetail.residents.form.primaryContactHelper": "Contacto principal de esta unidad",
  "hoa.buildingDetail.residents.contact.primary": "Principal",
  "hoa.buildingDetail.residents.contact.secondary": "Secundario",
  "hoa.buildingDetail.toast.buildingUpdated": "Edificio actualizado exitosamente",
  "hoa.buildingDetail.toast.buildingUpdateFailed": "Error al actualizar edificio",
  "hoa.buildingDetail.toast.unitCreatedDescription": "La unidad {code} fue agregada a {building}",
  "hoa.buildingDetail.toast.unitUpdatedDescription": "La unidad {code} fue actualizada",
  "hoa.buildingDetail.toast.unitDeletedDescription": "La unidad {code} fue eliminada exitosamente",
  "hoa.buildingDetail.toast.unitDuplicate": "El código de unidad \"{code}\" ya existe en este edificio",
  "hoa.buildingDetail.toast.unitDeleteErrorDescription": "Ocurrió un error al eliminar la unidad",
  "hoa.buildingDetail.toast.residentCreatedDescription": "{name} fue agregado a {building}",
  "hoa.buildingDetail.toast.residentUpdatedDescription": "{name} fue actualizado",
  "hoa.buildingDetail.toast.residentDeletedDescription": "{name} fue eliminado exitosamente",
  "hoa.buildingDetail.toast.residentDuplicate": "Ya existe un residente con el correo \"{email}\"",
  "hoa.buildingDetail.toast.residentDeleteErrorDescription": "Ocurrió un error al eliminar al residente",
  "hoa.buildingDetail.noVacantUnitsDescriptionShort": "en este edificio. Todas las unidades están ocupadas o inactivas.",
};

export const translations = { en, es };
